// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./icons/font-awesome/css/font-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./icons/simple-line-icons/css/simple-line-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./icons/themify-icons/themify-icons.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23ffffff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23ffffff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/static-slider/slider10/img1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/form-banners/banner1/banner-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/team/t1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/team/t2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/team/t3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/team/t4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/landingpage/imagenjueces.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/landingpage/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/ui/custom-select.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/ui/success.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/ui/warning.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/ui/danger.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Wrakit UI Kit
Author: wrappixel
Email: niravjoshi87@gmail.com
File: scss
*/
/**
 * Table Of Content
 *
 * 	1. Globals
 *	2. Headers
 *	3. Navigations
 *	4. Banners
 *	5. Footers
 *	6. app
 *	7. Widgets
 *	8. Custom Templates
 */
/*
Template Name: Wrapkit
Author: wrappixel
Email: niravjoshi87@gmail.com
File: scss
*/
/*Theme Colors*/
/*bootstrap Color*/
/*Light colors*/
/*Normal Color*/
/*Extra Variable*/
/*Gradiant*/
/*!
 * Bootstrap v4.1.3 (https://getbootstrap.com/)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
:root {
  --blue: #02bec9;
  --indigo: #6610f2;
  --purple: #7460ee;
  --pink: #e83e8c;
  --red: #fb3a3a;
  --orange: #ff6a5b;
  --yellow: #fed700;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #ffffff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #316ce8;
  --secondary: #727b84;
  --success: #2cdd9b;
  --info: #188ef4;
  --warning: #fec500;
  --danger: #ff4d7e;
  --light: #f4f8fa;
  --dark: #263238;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #ffffff;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

dfn {
  font-style: italic;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #316ce8;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: rgb(20.53930131, 73.2270742358, 183.96069869);
  text-decoration: underline;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
  outline: 0;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html [type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date],
input[type=time],
input[type=datetime-local],
input[type=month] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-cancel-button,
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}

h1, .h1 {
  font-size: 2.5rem;
}

h2, .h2 {
  font-size: 2rem;
}

h3, .h3 {
  font-size: 1.75rem;
}

h4, .h4 {
  font-size: 1.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-break: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #ffffff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }
  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }
  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }
  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }
  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.3333333333%;
  }
  .offset-md-2 {
    margin-left: 16.6666666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.3333333333%;
  }
  .offset-md-5 {
    margin-left: 41.6666666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.3333333333%;
  }
  .offset-md-8 {
    margin-left: 66.6666666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.3333333333%;
  }
  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }
  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }
  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }
  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }
  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }
  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }
  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }
  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }
  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}
.table .table {
  background-color: #ffffff;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(197.32, 213.84, 248.56);
}

.table-hover .table-primary:hover {
  background-color: rgb(174.3811353712, 197.4710043668, 245.9988646288);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(174.3811353712, 197.4710043668, 245.9988646288);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(215.52, 218.04, 220.56);
}

.table-hover .table-secondary:hover {
  background-color: rgb(201.9006818182, 205.29, 208.6793181818);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(201.9006818182, 205.29, 208.6793181818);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(195.92, 245.48, 227);
}

.table-hover .table-success:hover {
  background-color: rgb(173.9587755102, 241.9412244898, 216.5918367347);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(173.9587755102, 241.9412244898, 216.5918367347);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(190.32, 223.36, 251.92);
}

.table-hover .table-info:hover {
  background-color: rgb(165.9790909091, 211.4529752066, 250.7609090909);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(165.9790909091, 211.4529752066, 250.7609090909);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(254.72, 238.76, 183.6);
}

.table-hover .table-warning:hover {
  background-color: rgb(254.620390625, 232.98265625, 158.199609375);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(254.620390625, 232.98265625, 158.199609375);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(255, 205.16, 218.88);
}

.table-hover .table-danger:hover {
  background-color: rgb(255, 179.66, 200.3996629213);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(255, 179.66, 200.3996629213);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(251.92, 253.04, 253.6);
}

.table-hover .table-light:hover {
  background-color: rgb(234.38875, 241.88375, 245.63125);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(234.38875, 241.88375, 245.63125);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(194.24, 197.6, 199.28);
}

.table-hover .table-dark:hover {
  background-color: rgb(180.9383173077, 185.0338942308, 187.0816826923);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(180.9383173077, 185.0338942308, 187.0816826923);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #ffffff;
  background-color: #212529;
  border-color: rgb(50.0574324324, 56.125, 62.1925675676);
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #ffffff;
  background-color: #212529;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(50.0574324324, 56.125, 62.1925675676);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #ffffff;
  border-color: rgb(163.6943231441, 189.8449781659, 244.8056768559);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #ffffff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.8125rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(2.875rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #2cdd9b;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #212529;
  background-color: rgba(44, 221, 155, 0.9);
  border-radius: 0.25rem;
}

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #2cdd9b;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #2cdd9b;
  box-shadow: 0 0 0 0.2rem rgba(44, 221, 155, 0.25);
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control-file:valid ~ .valid-feedback,
.was-validated .form-control-file:valid ~ .valid-tooltip, .form-control-file.is-valid ~ .valid-feedback,
.form-control-file.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #2cdd9b;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #2cdd9b;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: rgb(153.806122449, 238.693877551, 207.0408163265);
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: rgb(87.9224489796, 228.0775510204, 175.8163265306);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(44, 221, 155, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #2cdd9b;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::after, .custom-file-input.is-valid ~ .custom-file-label::after {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(44, 221, 155, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ff4d7e;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #ffffff;
  background-color: rgba(255, 77, 126, 0.9);
  border-radius: 0.25rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #ff4d7e;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #ff4d7e;
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 126, 0.25);
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control-file:invalid ~ .invalid-feedback,
.was-validated .form-control-file:invalid ~ .invalid-tooltip, .form-control-file.is-invalid ~ .invalid-feedback,
.form-control-file.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ff4d7e;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #ff4d7e;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: rgb(255, 204.5, 218.4016853933);
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: rgb(255, 128, 162.9606741573);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(255, 77, 126, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #ff4d7e;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::after, .custom-file-input.is-invalid ~ .custom-file-label::after {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 126, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover, .btn:focus {
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #ffffff;
  background-color: #316ce8;
  border-color: #316ce8;
}
.btn-primary:hover {
  color: #ffffff;
  background-color: rgb(24.3810043668, 86.923580786, 218.3689956332);
  border-color: rgb(23.1004366812, 82.3580786026, 206.8995633188);
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #ffffff;
  background-color: #316ce8;
  border-color: #316ce8;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(23.1004366812, 82.3580786026, 206.8995633188);
  border-color: rgb(21.8198689956, 77.7925764192, 195.4301310044);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.5);
}

.btn-secondary {
  color: #ffffff;
  background-color: #727b84;
  border-color: #727b84;
}
.btn-secondary:hover {
  color: #ffffff;
  background-color: rgb(96.2743902439, 103.875, 111.4756097561);
  border-color: rgb(90.3658536585, 97.5, 104.6341463415);
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(114, 123, 132, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #ffffff;
  background-color: #727b84;
  border-color: #727b84;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(90.3658536585, 97.5, 104.6341463415);
  border-color: rgb(84.4573170732, 91.125, 97.7926829268);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(114, 123, 132, 0.5);
}

.btn-success {
  color: #212529;
  background-color: #2cdd9b;
  border-color: #2cdd9b;
}
.btn-success:hover {
  color: #ffffff;
  background-color: rgb(31.4673469388, 195.2826530612, 134.1989795918);
  border-color: rgb(29.6979591837, 184.3020408163, 126.6530612245);
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(44, 221, 155, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #212529;
  background-color: #2cdd9b;
  border-color: #2cdd9b;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(29.6979591837, 184.3020408163, 126.6530612245);
  border-color: rgb(27.9285714286, 173.3214285714, 119.1071428571);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(44, 221, 155, 0.5);
}

.btn-info {
  color: #ffffff;
  background-color: #188ef4;
  border-color: #188ef4;
}
.btn-info:hover {
  color: #ffffff;
  background-color: rgb(10.4431818182, 122.4700413223, 219.3068181818);
  border-color: rgb(9.8636363636, 115.673553719, 207.1363636364);
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(24, 142, 244, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #ffffff;
  background-color: #188ef4;
  border-color: #188ef4;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(9.8636363636, 115.673553719, 207.1363636364);
  border-color: rgb(9.2840909091, 108.8770661157, 194.9659090909);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(24, 142, 244, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #fec500;
  border-color: #fec500;
}
.btn-warning:hover {
  color: #212529;
  background-color: rgb(215.75, 167.3336614173, 0);
  border-color: rgb(203, 157.4448818898, 0);
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(254, 197, 0, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #fec500;
  border-color: #fec500;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(203, 157.4448818898, 0);
  border-color: rgb(190.25, 147.5561023622, 0);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(254, 197, 0, 0.5);
}

.btn-danger {
  color: #ffffff;
  background-color: #ff4d7e;
  border-color: #ff4d7e;
}
.btn-danger:hover {
  color: #ffffff;
  background-color: rgb(255, 38.75, 98.279494382);
  border-color: rgb(255, 26, 89.0393258427);
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 126, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #ffffff;
  background-color: #ff4d7e;
  border-color: #ff4d7e;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(255, 26, 89.0393258427);
  border-color: rgb(255, 13.25, 79.7991573034);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 126, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f4f8fa;
  border-color: #f4f8fa;
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(217.703125, 231.265625, 238.046875);
  border-color: rgb(208.9375, 225.6875, 234.0625);
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 248, 250, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f4f8fa;
  border-color: #f4f8fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(208.9375, 225.6875, 234.0625);
  border-color: rgb(200.171875, 220.109375, 230.078125);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 248, 250, 0.5);
}

.btn-dark {
  color: #ffffff;
  background-color: #263238;
  border-color: #263238;
}
.btn-dark:hover {
  color: #ffffff;
  background-color: rgb(22.5372340426, 29.6542553191, 33.2127659574);
  border-color: rgb(17.3829787234, 22.8723404255, 25.6170212766);
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 50, 56, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #ffffff;
  background-color: #263238;
  border-color: #263238;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(17.3829787234, 22.8723404255, 25.6170212766);
  border-color: rgb(12.2287234043, 16.0904255319, 18.0212765957);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 50, 56, 0.5);
}

.btn-outline-primary {
  color: #316ce8;
  background-color: transparent;
  background-image: none;
  border-color: #316ce8;
}
.btn-outline-primary:hover {
  color: #ffffff;
  background-color: #316ce8;
  border-color: #316ce8;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #316ce8;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #ffffff;
  background-color: #316ce8;
  border-color: #316ce8;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.5);
}

.btn-outline-secondary {
  color: #727b84;
  background-color: transparent;
  background-image: none;
  border-color: #727b84;
}
.btn-outline-secondary:hover {
  color: #ffffff;
  background-color: #727b84;
  border-color: #727b84;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(114, 123, 132, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #727b84;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: #727b84;
  border-color: #727b84;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(114, 123, 132, 0.5);
}

.btn-outline-success {
  color: #2cdd9b;
  background-color: transparent;
  background-image: none;
  border-color: #2cdd9b;
}
.btn-outline-success:hover {
  color: #212529;
  background-color: #2cdd9b;
  border-color: #2cdd9b;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(44, 221, 155, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #2cdd9b;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #212529;
  background-color: #2cdd9b;
  border-color: #2cdd9b;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(44, 221, 155, 0.5);
}

.btn-outline-info {
  color: #188ef4;
  background-color: transparent;
  background-image: none;
  border-color: #188ef4;
}
.btn-outline-info:hover {
  color: #ffffff;
  background-color: #188ef4;
  border-color: #188ef4;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(24, 142, 244, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #188ef4;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #ffffff;
  background-color: #188ef4;
  border-color: #188ef4;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(24, 142, 244, 0.5);
}

.btn-outline-warning {
  color: #fec500;
  background-color: transparent;
  background-image: none;
  border-color: #fec500;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #fec500;
  border-color: #fec500;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(254, 197, 0, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #fec500;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #fec500;
  border-color: #fec500;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(254, 197, 0, 0.5);
}

.btn-outline-danger {
  color: #ff4d7e;
  background-color: transparent;
  background-image: none;
  border-color: #ff4d7e;
}
.btn-outline-danger:hover {
  color: #ffffff;
  background-color: #ff4d7e;
  border-color: #ff4d7e;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 126, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #ff4d7e;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #ffffff;
  background-color: #ff4d7e;
  border-color: #ff4d7e;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 77, 126, 0.5);
}

.btn-outline-light {
  color: #f4f8fa;
  background-color: transparent;
  background-image: none;
  border-color: #f4f8fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f4f8fa;
  border-color: #f4f8fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 248, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f4f8fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f4f8fa;
  border-color: #f4f8fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 248, 250, 0.5);
}

.btn-outline-dark {
  color: #263238;
  background-color: transparent;
  background-image: none;
  border-color: #263238;
}
.btn-outline-dark:hover {
  color: #ffffff;
  background-color: #263238;
  border-color: #263238;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 50, 56, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #263238;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #ffffff;
  background-color: #263238;
  border-color: #263238;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 50, 56, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #316ce8;
  background-color: transparent;
}
.btn-link:hover {
  color: rgb(20.53930131, 73.2270742358, 183.96069869);
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
  border-color: transparent;
  box-shadow: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media screen and (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media screen and (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  text-decoration: none;
  background-color: #f8f9fa;
}
.dropdown-item.active, .dropdown-item:active {
  color: #ffffff;
  text-decoration: none;
  background-color: #316ce8;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 0 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}
.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .btn + .btn,
.btn-group-vertical .btn + .btn-group,
.btn-group-vertical .btn-group + .btn,
.btn-group-vertical .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:first-child {
  margin-left: 0;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical .btn,
.btn-group-vertical .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  height: calc(2.875rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  height: calc(1.8125rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #ffffff;
  background-color: #316ce8;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.custom-control-input:active ~ .custom-control-label::before {
  color: #ffffff;
  background-color: rgb(209.5720524017, 222.5829694323, 249.9279475983);
}
.custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
          user-select: none;
  background-color: #dee2e6;
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #316ce8;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #316ce8;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(49, 108, 232, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(49, 108, 232, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #316ce8;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(49, 108, 232, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: rgb(163.6943231441, 189.8449781659, 244.8056768559);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(163.6943231441, 189.8449781659, 244.8056768559, 0.5);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #ffffff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  opacity: 0;
}

.custom-select-sm {
  height: calc(1.8125rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 75%;
}

.custom-select-lg {
  height: calc(2.875rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 125%;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin: 0;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(163.6943231441, 189.8449781659, 244.8056768559);
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.custom-file-input:focus ~ .custom-file-label::after {
  border-color: rgb(163.6943231441, 189.8449781659, 244.8056768559);
}
.custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: 2.25rem;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: 1px solid #ced4da;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  padding-left: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: none;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #316ce8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb {
  appearance: none;
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(209.5720524017, 222.5829694323, 249.9279475983);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #316ce8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb {
  appearance: none;
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(209.5720524017, 222.5829694323, 249.9279475983);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #316ce8;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb {
  appearance: none;
}
.custom-range::-ms-thumb:active {
  background-color: rgb(209.5720524017, 222.5829694323, 249.9279475983);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #ffffff;
  border-color: #dee2e6 #dee2e6 #ffffff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #ffffff;
  background-color: #316ce8;
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}
.navbar-toggler:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand > .container,
.navbar-expand > .container-fluid {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #ffffff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #ffffff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #ffffff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #ffffff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #ffffff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.card > .list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img {
  width: 100%;
  border-radius: calc(0.25rem - 1px);
}

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck {
  display: flex;
  flex-direction: column;
}
.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: flex;
  flex-direction: column;
}
.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:first-child .card-img-top,
  .card-group > .card:first-child .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:first-child .card-img-bottom,
  .card-group > .card:first-child .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:last-child .card-img-top,
  .card-group > .card:last-child .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:last-child .card-img-bottom,
  .card-group > .card:last-child .card-footer {
    border-bottom-left-radius: 0;
  }
  .card-group > .card:only-child {
    border-radius: 0.25rem;
  }
  .card-group > .card:only-child .card-img-top,
  .card-group > .card:only-child .card-header {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .card-group > .card:only-child .card-img-bottom,
  .card-group > .card:only-child .card-footer {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {
    border-radius: 0;
  }
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {
    border-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 0;
  border-radius: 0;
}
.accordion .card:not(:first-of-type) .card-header:first-child {
  border-radius: 0;
}
.accordion .card:first-of-type {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion .card:last-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #316ce8;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: rgb(20.53930131, 73.2270742358, 183.96069869);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(49, 108, 232, 0.25);
}
.page-link:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 1;
  color: #ffffff;
  background-color: #316ce8;
  border-color: #316ce8;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #ffffff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #ffffff;
  background-color: #316ce8;
}
.badge-primary[href]:hover, .badge-primary[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(23.1004366812, 82.3580786026, 206.8995633188);
}

.badge-secondary {
  color: #ffffff;
  background-color: #727b84;
}
.badge-secondary[href]:hover, .badge-secondary[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(90.3658536585, 97.5, 104.6341463415);
}

.badge-success {
  color: #212529;
  background-color: #2cdd9b;
}
.badge-success[href]:hover, .badge-success[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(29.6979591837, 184.3020408163, 126.6530612245);
}

.badge-info {
  color: #ffffff;
  background-color: #188ef4;
}
.badge-info[href]:hover, .badge-info[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(9.8636363636, 115.673553719, 207.1363636364);
}

.badge-warning {
  color: #212529;
  background-color: #fec500;
}
.badge-warning[href]:hover, .badge-warning[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(203, 157.4448818898, 0);
}

.badge-danger {
  color: #ffffff;
  background-color: #ff4d7e;
}
.badge-danger[href]:hover, .badge-danger[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(255, 26, 89.0393258427);
}

.badge-light {
  color: #212529;
  background-color: #f4f8fa;
}
.badge-light[href]:hover, .badge-light[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(208.9375, 225.6875, 234.0625);
}

.badge-dark {
  color: #ffffff;
  background-color: #263238;
}
.badge-dark[href]:hover, .badge-dark[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(17.3829787234, 22.8723404255, 25.6170212766);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: rgb(25.48, 56.16, 120.64);
  background-color: rgb(213.8, 225.6, 250.4);
  border-color: rgb(197.32, 213.84, 248.56);
}
.alert-primary hr {
  border-top-color: rgb(174.3811353712, 197.4710043668, 245.9988646288);
}
.alert-primary .alert-link {
  color: rgb(16.5867615658, 36.5585765125, 78.5332384342);
}

.alert-secondary {
  color: rgb(59.28, 63.96, 68.64);
  background-color: rgb(226.8, 228.6, 230.4);
  border-color: rgb(215.52, 218.04, 220.56);
}
.alert-secondary hr {
  border-top-color: rgb(201.9006818182, 205.29, 208.6793181818);
}
.alert-secondary .alert-link {
  color: rgb(35.6458536585, 38.46, 41.2741463415);
}

.alert-success {
  color: rgb(22.88, 114.92, 80.6);
  background-color: rgb(212.8, 248.2, 235);
  border-color: rgb(195.92, 245.48, 227);
}
.alert-success hr {
  border-top-color: rgb(173.9587755102, 241.9412244898, 216.5918367347);
}
.alert-success .alert-link {
  color: rgb(14.4120754717, 72.3879245283, 50.7698113208);
}

.alert-info {
  color: rgb(12.48, 73.84, 126.88);
  background-color: rgb(208.8, 232.4, 252.8);
  border-color: rgb(190.32, 223.36, 251.92);
}
.alert-info hr {
  border-top-color: rgb(165.9790909091, 211.4529752066, 250.7609090909);
}
.alert-info .alert-link {
  color: rgb(7.9128358209, 46.8176119403, 80.4471641791);
}

.alert-warning {
  color: rgb(132.08, 102.44, 0);
  background-color: rgb(254.8, 243.4, 204);
  border-color: rgb(254.72, 238.76, 183.6);
}
.alert-warning hr {
  border-top-color: rgb(254.620390625, 232.98265625, 158.199609375);
}
.alert-warning .alert-link {
  color: rgb(81.08, 62.8848818898, 0);
}

.alert-danger {
  color: rgb(132.6, 40.04, 65.52);
  background-color: rgb(255, 219.4, 229.2);
  border-color: rgb(255, 205.16, 218.88);
}
.alert-danger hr {
  border-top-color: rgb(255, 179.66, 200.3996629213);
}
.alert-danger .alert-link {
  color: rgb(93.428313253, 28.211686747, 46.1645783133);
}

.alert-light {
  color: rgb(126.88, 128.96, 130);
  background-color: rgb(252.8, 253.6, 254);
  border-color: rgb(251.92, 253.04, 253.6);
}
.alert-light hr {
  border-top-color: rgb(234.38875, 241.88375, 245.63125);
}
.alert-light .alert-link {
  color: rgb(101.6711441214, 103.3629519595, 104.2088558786);
}

.alert-dark {
  color: rgb(19.76, 26, 29.12);
  background-color: rgb(211.6, 214, 215.2);
  border-color: rgb(194.24, 197.6, 199.28);
}
.alert-dark hr {
  border-top-color: rgb(180.9383173077, 185.0338942308, 187.0816826923);
}
.alert-dark .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  background-color: #316ce8;
  transition: width 0.6s ease;
}
@media screen and (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.list-group-item:hover, .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  background-color: #ffffff;
}
.list-group-item.active {
  z-index: 2;
  color: #ffffff;
  background-color: #316ce8;
  border-color: #316ce8;
}

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0;
}
.list-group-flush:last-child .list-group-item:last-child {
  border-bottom: 0;
}

.list-group-item-primary {
  color: rgb(25.48, 56.16, 120.64);
  background-color: rgb(197.32, 213.84, 248.56);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(25.48, 56.16, 120.64);
  background-color: rgb(174.3811353712, 197.4710043668, 245.9988646288);
}
.list-group-item-primary.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(25.48, 56.16, 120.64);
  border-color: rgb(25.48, 56.16, 120.64);
}

.list-group-item-secondary {
  color: rgb(59.28, 63.96, 68.64);
  background-color: rgb(215.52, 218.04, 220.56);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(59.28, 63.96, 68.64);
  background-color: rgb(201.9006818182, 205.29, 208.6793181818);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(59.28, 63.96, 68.64);
  border-color: rgb(59.28, 63.96, 68.64);
}

.list-group-item-success {
  color: rgb(22.88, 114.92, 80.6);
  background-color: rgb(195.92, 245.48, 227);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(22.88, 114.92, 80.6);
  background-color: rgb(173.9587755102, 241.9412244898, 216.5918367347);
}
.list-group-item-success.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(22.88, 114.92, 80.6);
  border-color: rgb(22.88, 114.92, 80.6);
}

.list-group-item-info {
  color: rgb(12.48, 73.84, 126.88);
  background-color: rgb(190.32, 223.36, 251.92);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(12.48, 73.84, 126.88);
  background-color: rgb(165.9790909091, 211.4529752066, 250.7609090909);
}
.list-group-item-info.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(12.48, 73.84, 126.88);
  border-color: rgb(12.48, 73.84, 126.88);
}

.list-group-item-warning {
  color: rgb(132.08, 102.44, 0);
  background-color: rgb(254.72, 238.76, 183.6);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(132.08, 102.44, 0);
  background-color: rgb(254.620390625, 232.98265625, 158.199609375);
}
.list-group-item-warning.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(132.08, 102.44, 0);
  border-color: rgb(132.08, 102.44, 0);
}

.list-group-item-danger {
  color: rgb(132.6, 40.04, 65.52);
  background-color: rgb(255, 205.16, 218.88);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(132.6, 40.04, 65.52);
  background-color: rgb(255, 179.66, 200.3996629213);
}
.list-group-item-danger.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(132.6, 40.04, 65.52);
  border-color: rgb(132.6, 40.04, 65.52);
}

.list-group-item-light {
  color: rgb(126.88, 128.96, 130);
  background-color: rgb(251.92, 253.04, 253.6);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(126.88, 128.96, 130);
  background-color: rgb(234.38875, 241.88375, 245.63125);
}
.list-group-item-light.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(126.88, 128.96, 130);
  border-color: rgb(126.88, 128.96, 130);
}

.list-group-item-dark {
  color: rgb(19.76, 26, 29.12);
  background-color: rgb(194.24, 197.6, 199.28);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(19.76, 26, 29.12);
  background-color: rgb(180.9383173077, 185.0338942308, 187.0816826923);
}
.list-group-item-dark.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(19.76, 26, 29.12);
  border-color: rgb(19.76, 26, 29.12);
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #ffffff;
  opacity: 0.5;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.close:not(:disabled):not(.disabled) {
  cursor: pointer;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  -webkit-appearance: none;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -25%);
}
.modal.show .modal-dialog {
  transform: translate(0, 0);
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 0.5rem * 2);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 0.5rem * 2);
  content: "";
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.modal-header .close {
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
}
.modal-footer > :not(:first-child) {
  margin-left: 0.25rem;
}
.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-centered {
    min-height: calc(100% - 1.75rem * 2);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 1.75rem * 2);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #ffffff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top .arrow, .bs-popover-auto[x-placement^=top] .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}
.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before,
.bs-popover-top .arrow::after,
.bs-popover-auto[x-placement^=top] .arrow::after {
  border-width: 0.5rem 0.5rem 0;
}
.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before {
  bottom: 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=top] .arrow::after {
  bottom: 1px;
  border-top-color: #ffffff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right .arrow, .bs-popover-auto[x-placement^=right] .arrow {
  left: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before,
.bs-popover-right .arrow::after,
.bs-popover-auto[x-placement^=right] .arrow::after {
  border-width: 0.5rem 0.5rem 0.5rem 0;
}
.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before {
  left: 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=right] .arrow::after {
  left: 1px;
  border-right-color: #ffffff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=bottom] .arrow {
  top: calc((0.5rem + 1px) * -1);
}
.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before,
.bs-popover-bottom .arrow::after,
.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-width: 0 0.5rem 0.5rem 0.5rem;
}
.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before {
  top: 0;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=bottom] .arrow::after {
  top: 1px;
  border-bottom-color: #ffffff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(247.35, 247.35, 247.35);
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left .arrow, .bs-popover-auto[x-placement^=left] .arrow {
  right: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before,
.bs-popover-left .arrow::after,
.bs-popover-auto[x-placement^=left] .arrow::after {
  border-width: 0.5rem 0 0.5rem 0.5rem;
}
.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before {
  right: 0;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=left] .arrow::after {
  right: 1px;
  border-left-color: #ffffff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: inherit;
  background-color: rgb(247.35, 247.35, 247.35);
  border-bottom: 1px solid rgb(234.6, 234.6, 234.6);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-item {
  position: relative;
  display: none;
  align-items: center;
  width: 100%;
  backface-visibility: hidden;
  perspective: 1000px;
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
  transition: transform 0.6s ease;
}
@media screen and (prefers-reduced-motion: reduce) {
  .carousel-item.active,
  .carousel-item-next,
  .carousel-item-prev {
    transition: none;
  }
}

.carousel-item-next,
.carousel-item-prev {
  position: absolute;
  top: 0;
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
  transform: translateX(0);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-next.carousel-item-left,
  .carousel-item-prev.carousel-item-right {
    transform: translate3d(0, 0, 0);
  }
}

.carousel-item-next,
.active.carousel-item-right {
  transform: translateX(100%);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-next,
  .active.carousel-item-right {
    transform: translate3d(100%, 0, 0);
  }
}

.carousel-item-prev,
.active.carousel-item-left {
  transform: translateX(-100%);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-prev,
  .active.carousel-item-left {
    transform: translate3d(-100%, 0, 0);
  }
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  opacity: 0;
}
.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active,
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev {
  transform: translateX(0);
}
@supports (transform-style: preserve-3d) {
  .carousel-fade .carousel-item-next,
  .carousel-fade .carousel-item-prev,
  .carousel-fade .carousel-item.active,
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-prev {
    transform: translate3d(0, 0, 0);
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #ffffff;
  text-align: center;
  opacity: 0.5;
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: transparent no-repeat center center;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  position: relative;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.5);
}
.carousel-indicators li::before {
  position: absolute;
  top: -10px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 10px;
  content: "";
}
.carousel-indicators li::after {
  position: absolute;
  bottom: -10px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 10px;
  content: "";
}
.carousel-indicators .active {
  background-color: #ffffff;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #ffffff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #316ce8 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(23.1004366812, 82.3580786026, 206.8995633188) !important;
}

.bg-secondary {
  background-color: #727b84 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(90.3658536585, 97.5, 104.6341463415) !important;
}

.bg-success {
  background-color: #2cdd9b !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(29.6979591837, 184.3020408163, 126.6530612245) !important;
}

.bg-info {
  background-color: #188ef4 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(9.8636363636, 115.673553719, 207.1363636364) !important;
}

.bg-warning {
  background-color: #fec500 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(203, 157.4448818898, 0) !important;
}

.bg-danger {
  background-color: #ff4d7e !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(255, 26, 89.0393258427) !important;
}

.bg-light {
  background-color: #f4f8fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(208.9375, 225.6875, 234.0625) !important;
}

.bg-dark {
  background-color: #263238 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(17.3829787234, 22.8723404255, 25.6170212766) !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #316ce8 !important;
}

.border-secondary {
  border-color: #727b84 !important;
}

.border-success {
  border-color: #2cdd9b !important;
}

.border-info {
  border-color: #188ef4 !important;
}

.border-warning {
  border-color: #fec500 !important;
}

.border-danger {
  border-color: #ff4d7e !important;
}

.border-light {
  border-color: #f4f8fa !important;
}

.border-dark {
  border-color: #263238 !important;
}

.border-white {
  border-color: #ffffff !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.text-justify {
  text-align: justify !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #ffffff !important;
}

.text-primary {
  color: #316ce8 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(23.1004366812, 82.3580786026, 206.8995633188) !important;
}

.text-secondary {
  color: #727b84 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(90.3658536585, 97.5, 104.6341463415) !important;
}

.text-success {
  color: #2cdd9b !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(29.6979591837, 184.3020408163, 126.6530612245) !important;
}

.text-info {
  color: #188ef4 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(9.8636363636, 115.673553719, 207.1363636364) !important;
}

.text-warning {
  color: #fec500 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(203, 157.4448818898, 0) !important;
}

.text-danger {
  color: #ff4d7e !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(255, 26, 89.0393258427) !important;
}

.text-light {
  color: #f4f8fa !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(208.9375, 225.6875, 234.0625) !important;
}

.text-dark {
  color: #263238 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(17.3829787234, 22.8723404255, 25.6170212766) !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #ffffff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}
/*
Template Name: Wrapkit
Author: wrappixel
Email: niravjoshi87@gmail.com
File: scss
*/
/*Theme Colors*/
/*bootstrap Color*/
/*Light colors*/
/*Normal Color*/
/*Extra Variable*/
/*Gradiant*/
/*******************
topbar color
*******************/
.topbar.fixed-header {
  background: #263238;
}

/*******************
Static slide 10
*******************/
.static-slider-head {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
  background-size: cover;
  background-position: center center;
}
.static-slider-head .title {
  color: #ffffff;
  font-weight: 700;
  font-size: 70px;
  line-height: 1000px;
}
.static-slider-head .subtitle {
  color: #ffffff;
  line-height: 30px;
}

/*******************
Header 1
*******************/
.h1-nav {
  padding: 15px 0;
}
.h1-nav .navbar-nav .nav-item {
  margin: 0 20px;
}
.h1-nav .navbar-nav .nav-item .nav-link {
  padding: 12px 0px;
  color: #8d97ad;
  font-weight: 400;
}
.h1-nav .navbar-nav .nav-item .nav-link:hover {
  color: #2cdd9b;
}
.h1-nav .navbar-nav .nav-item:last-child {
  margin-right: 0px;
}

/*******************
Header 2
*******************/
.h2-nav {
  padding: 15px 0;
}
.h2-nav .navbar-nav .nav-item {
  margin: 0 20px;
}
.h2-nav .navbar-nav .nav-item .nav-link {
  padding: 12px 0px;
  color: #ffffff;
  font-weight: 400;
}
.h2-nav .navbar-nav .nav-item .nav-link:hover {
  color: #188ef4;
}
.h2-nav .navbar-nav .nav-item:last-child {
  margin-right: 0px;
}

/*******************
Static slide 10
*******************/
.static-slider10 {
  padding: 10% 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: cover;
  background-position: center center;
}
.static-slider10 .title {
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 48px;
  line-height: 50px;
}
.static-slider10 .subtitle {
  color: #ffffff;
}

@media (max-width: 900px) {
  .static-slider10 .title {
    font-size: 40px;
    line-height: 45px;
  }
}
/*******************
Static slide 3
*******************/
.static-slider3 {
  padding: 10% 0;
}
.static-slider3 h1 {
  font-weight: 300;
  line-height: 50px;
}
.static-slider3 h1 span {
  border-bottom: 3px solid #2cdd9b;
}

@media (max-width: 767px) {
  .static-slider3 h1 {
    line-height: 30px;
    font-size: 24px;
  }
}
/*******************
form-banner 1
*******************/
#banner1 {
  background: right -3em center no-repeat #e9f3f8;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
#banner1 h2 {
  font-size: 48px;
  line-height: 1;
  letter-spacing: -1px;
}
#banner1 input {
  line-height: 72px;
  padding: 0;
  margin: 0;
  border: none;
  display: inline-block;
  vertical-align: top;
}
#banner1 input[type=text] {
  color: #8d97ad;
  border-radius: 36px 0 0 36px;
  text-indent: 35px;
  padding-right: 15px;
  width: 61%;
  font-weight: 300;
  box-shadow: -5px 0 30px 0 rgba(0, 0, 0, 0.05);
  text-overflow: ellipsis;
}
#banner1 input[type=submit] {
  border-radius: 0 36px 36px 0;
  width: auto;
  padding: 0 30px;
  cursor: pointer;
  margin-left: -4px;
  box-shadow: 5px 0 30px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.5s ease-in-out;
}
#banner1 input[type=submit]:hover {
  opacity: 0.7;
}

@media (min-width: 2301px) and (max-width: 2700px) {
  #banner1 {
    background-position: 70% center;
  }
}
@media (min-width: 1900px) and (max-width: 2300px) {
  #banner1 {
    background-position: 80% center;
  }
}
@media (min-width: 1500px) and (max-width: 1680px) {
  #banner1 {
    background-position: right center;
  }
}
@media (max-width: 1100px) {
  #banner1 {
    background-position: right -14em center;
  }
  #banner1 h2 {
    font-size: 40px;
  }
  #banner1 input[type=text] {
    width: 59%;
  }
  #banner1 input[type=submit] {
    padding: 0 20px;
  }
}
@media (max-width: 992px) {
  .banner {
    height: auto !important;
    padding: 100px 0;
  }
  #banner1 {
    background-position: right -6em center;
    background-size: 80%;
  }
  #banner1 h2 {
    font-size: 30px;
  }
}
@media (max-width: 767px) {
  .banner {
    padding: 30px 0;
  }
  #banner1 {
    background-size: 100%;
    background-position: right center;
  }
  #banner1 input[type=submit] {
    padding: 0 30px;
  }
  #banner1 img {
    margin-top: 25px;
  }
}
@media (max-width: 590px) {
  #banner1 {
    background-image: none;
  }
}
@media (max-width: 428px) {
  #banner1 input {
    font-size: 14px;
    line-height: 50px;
  }
  #banner1 input[type=text] {
    border-radius: 25px 0 0 25px;
    text-indent: 20px;
  }
  #banner1 input[type=submit] {
    border-radius: 0 25px 25px 0;
    padding: 0 15px;
  }
}
@media (max-width: 320px) {
  #banner1 input[type=submit] {
    padding: 0 10px;
  }
}
/*******************
Feature 4
*******************/
.wrap-feature4-box .icon-round {
  font-size: 45px;
  width: 80px;
  color: #631117;
  line-height: 80px;
  text-align: center;
  display: inline-block;
  margin: 20px 0 30px;
  border-radius: 100%;
}

/*******************
Feature 20
*******************/
.wrap-feature-20 {
  margin-top: 60px;
}
.wrap-feature-20 [class*=col-lg-6] .card {
  overflow: hidden;
}
.wrap-feature-20 .linking {
  width: 100%;
  display: block;
  padding: 35px 0;
}

/*******************
Feature 30
*******************/
.feature30 {
  position: relative;
}

.wrap-feature30-box {
  position: absolute;
  top: 20%;
  right: 0px;
}

/*******************
Portfolio 1
*******************/
.img-ho {
  overflow: hidden;
}
.img-ho img {
  transition: 0.1s ease-in;
}
.img-ho img:hover {
  transform: scale(1.1);
}

/*******************
Pricing 8
*******************/
.pricing8 .pricing-box sup {
  top: -20px;
  font-size: 16px;
}
.pricing8 .pricing-box .btn {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

/*******************
team 2
*******************/
.team2 .pro-pic {
  min-height: 200px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.team2 .pro-pic.t1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.team2 .pro-pic.t2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.team2 .pro-pic.t3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.team2 .pro-pic.t4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.team2 .pro-pic .card-img-overlay {
  background: rgba(26, 139, 243, 0.87);
  display: none;
}
.team2 .pro-pic .card-img-overlay ul {
  position: relative;
  top: 50%;
  text-align: center;
}
.team2 .pro-pic .card-img-overlay ul li a {
  color: #ffffff;
  padding: 0 10px;
  transition: 0.1s ease-in;
  display: block;
}
.team2 .pro-pic .card-img-overlay ul li a:hover {
  transform: translate3d(0px, -5px, 0px);
}
.team2 .pro-pic:hover .card-img-overlay {
  display: block;
}
.team2 .title {
  margin: 30px 0 0 0;
}
.team2 .subtitle {
  margin: 0 0 20px 0;
  font-size: 13px;
}

/*******************
Testimonial 3
*******************/
.testimonial3 .testi3 .card-body {
  padding: 40px;
}
.testimonial3 .testi3 h6 {
  line-height: 26px;
}
.testimonial3 .testi3 .thumb-img img {
  width: 60px;
}
.testimonial3 .testi3 .customer {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
}

/*******************
Blog homepage 2
*******************/
.blog-home2 [class*=col-] {
  transition: 0.2s ease-in;
}
.blog-home2 [class*=col-]:hover {
  transform: translateY(-10px);
}
.blog-home2 .date-pos {
  padding: 10px;
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 10px;
  color: #ffffff;
  border-radius: 4px;
  text-align: center;
}
.blog-home2 .date-pos span {
  display: block;
  font-size: 30px;
  line-height: 30px;
}

/*******************
Responsive
*******************/
@media (max-width: 1024px) {
  .static-slider10 .title {
    font-size: 60px;
    line-height: 60px;
  }
  .topbar {
    background: #263238;
  }
}
/*
Template Name: Wrakit UI Kit
Author: wrappixel
Email: niravjoshi87@gmail.com
File: scss
*/
/*
Template Name: Wrapkit
Author: wrappixel
Email: niravjoshi87@gmail.com
File: scss
*/
/*Theme Colors*/
/*bootstrap Color*/
/*Light colors*/
/*Normal Color*/
/*Extra Variable*/
/*Gradiant*/
/******************* 
This is the font import from the google api 
*******************/
/******************* 
Global Styles 
*******************/
* {
  outline: none;
}

body {
  background: #ffffff;
  font-family: "Montserrat", sans-serif;
  margin: 0;
  overflow-x: hidden;
  color: #8d97ad;
  font-weight: 300;
}

html {
  position: relative;
  min-height: 100%;
  background: #ffffff;
}

a:hover,
a:focus {
  text-decoration: none;
}

a.link {
  color: #3e4555;
}
a.link:hover, a.link:focus {
  color: #631117;
}

a.white-link {
  color: #ffffff;
}
a.white-link:hover, a.white-link:focus {
  color: #263238;
}

.img-responsive {
  width: 100%;
  height: auto;
  display: inline-block;
}

.img-rounded {
  border-radius: 4px;
}

html body .mdi:before,
html body .mdi-set {
  line-height: initial;
}

/*******************
Headings
*******************/
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #3e4555;
  font-family: "Montserrat", sans-serif;
}

h1 {
  line-height: 40px;
  font-size: 36px;
}

h2 {
  line-height: 36px;
  font-size: 30px;
}

h3 {
  line-height: 30px;
  font-size: 24px;
}

h4 {
  line-height: 26px;
  font-size: 21px;
}

h5 {
  line-height: 22px;
  font-size: 18px;
  font-weight: 400;
}

h6 {
  line-height: 20px;
  font-size: 16px;
  font-weight: 400;
}

.display-5 {
  font-size: 3rem;
}

.display-6 {
  font-size: 36px;
}

.display-7 {
  font-size: 26px;
}

.box {
  border-radius: 4px;
  padding: 10px;
}

html body .dl {
  display: inline-block;
}
html body .db {
  display: block;
}

.no-wrap td,
.no-wrap th {
  white-space: nowrap;
}

.circle {
  border-radius: 100%;
}

/*******************
Blockquote
*******************/
html body blockquote {
  border-left: 5px solid #631117;
  border: 1px solid rgba(120, 130, 140, 0.13);
  padding: 15px;
}

.clear {
  clear: both;
}

ol li {
  margin: 5px 0;
}

/*******************
Paddings
*******************/
html body .p-0 {
  padding: 0px;
}
html body .p-10 {
  padding: 10px;
}
html body .p-15 {
  padding: 15px;
}
html body .p-20 {
  padding: 20px;
}
html body .p-30 {
  padding: 30px;
}
html body .p-40 {
  padding: 40px;
}
html body .p-l-0 {
  padding-left: 0px;
}
html body .p-l-10 {
  padding-left: 10px;
}
html body .p-l-20 {
  padding-left: 20px;
}
html body .p-r-0 {
  padding-right: 0px;
}
html body .p-r-10 {
  padding-right: 10px;
}
html body .p-r-20 {
  padding-right: 20px;
}
html body .p-r-30 {
  padding-right: 30px;
}
html body .p-r-40 {
  padding-right: 40px;
}
html body .p-t-0 {
  padding-top: 0px;
}
html body .p-t-10 {
  padding-top: 10px;
}
html body .p-t-20 {
  padding-top: 20px;
}
html body .p-t-30 {
  padding-top: 30px;
}
html body .p-b-0 {
  padding-bottom: 0px;
}
html body .p-b-5 {
  padding-bottom: 5px;
}
html body .p-b-10 {
  padding-bottom: 10px;
}
html body .p-b-20 {
  padding-bottom: 20px;
}
html body .p-b-30 {
  padding-bottom: 30px;
}
html body .p-b-40 {
  padding-bottom: 40px;
}

/*******************
Margin
*******************/
html body .m-0 {
  margin: 0px;
}
html body .m-l-5 {
  margin-left: 5px;
}
html body .m-l-10 {
  margin-left: 10px;
}
html body .m-l-15 {
  margin-left: 15px;
}
html body .m-l-20 {
  margin-left: 20px;
}
html body .m-l-30 {
  margin-left: 30px;
}
html body .m-l-40 {
  margin-left: 40px;
}
html body .m-r-5 {
  margin-right: 5px;
}
html body .m-r-10 {
  margin-right: 10px;
}
html body .m-r-15 {
  margin-right: 15px;
}
html body .m-r-20 {
  margin-right: 20px;
}
html body .m-r-30 {
  margin-right: 30px;
}
html body .m-r-40 {
  margin-right: 40px;
}
html body .m-t-0 {
  margin-top: 0px;
}
html body .m-t-5 {
  margin-top: 5px;
}
html body .m-t-10 {
  margin-top: 10px;
}
html body .m-t-15 {
  margin-top: 15px;
}
html body .m-t-20 {
  margin-top: 20px;
}
html body .m-t-30 {
  margin-top: 30px;
}
html body .m-t-40 {
  margin-top: 40px;
}
html body .m-b-0 {
  margin-bottom: 0px;
}
html body .m-b-5 {
  margin-bottom: 5px;
}
html body .m-b-10 {
  margin-bottom: 10px;
}
html body .m-b-15 {
  margin-bottom: 15px;
}
html body .m-b-20 {
  margin-bottom: 20px;
}
html body .m-b-30 {
  margin-bottom: 30px;
}
html body .m-b-40 {
  margin-bottom: 40px;
}

/*******************
vertical alignment
*******************/
html body .vt {
  vertical-align: top;
}
html body .vm {
  vertical-align: middle;
}
html body .vb {
  vertical-align: bottom;
}

/*******************
Opacity
*******************/
.op-8 {
  opacity: 0.8;
}

.op-7 {
  opacity: 0.7;
}

.op-5 {
  opacity: 0.5;
}

.op-3 {
  opacity: 0.3;
}

/*******************
font weight
*******************/
html body .font-bold {
  font-weight: 700;
}
html body .font-semibold {
  font-weight: 600;
}
html body .font-normal {
  font-weight: normal;
}
html body .font-light {
  font-weight: 300;
}
html body .font-medium {
  font-weight: 500;
}
html body .font-16 {
  font-size: 16px;
}
html body .font-14 {
  font-size: 14px;
}
html body .font-13 {
  font-size: 13px;
}
html body .font-10 {
  font-size: 10px;
}
html body .font-18 {
  font-size: 18px;
}
html body .font-20 {
  font-size: 20px;
}
html body .font-stylish {
  font-family: "Calafia-Regular";
}

/*******************
Border
*******************/
html body .b-0 {
  border: none !important;
}
html body .b-r {
  border-right: 1px solid rgba(120, 130, 140, 0.13);
}
html body .b-l {
  border-left: 1px solid rgba(120, 130, 140, 0.13);
}
html body .b-b {
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
}
html body .b-t {
  border-top: 1px solid rgba(120, 130, 140, 0.13);
}
html body .b-all {
  border: 1px solid rgba(120, 130, 140, 0.13) !important;
}

/*******************
Thumb size
*******************/
.thumb-sm {
  height: 32px;
  width: 32px;
}

.thumb-md {
  height: 48px;
  width: 48px;
}

.thumb-lg {
  height: 88px;
  width: 88px;
}

.hide {
  display: none;
}

.img-circle {
  border-radius: 100%;
}

.radius {
  border-radius: 4px;
}

/*******************
Text Colors
*******************/
.text-white {
  color: #ffffff !important;
}

.text-danger {
  color: #ff4d7e !important;
}

.text-muted {
  color: #8d97ad !important;
}

.text-warning {
  color: #fec500 !important;
}

.text-success {
  color: #2cdd9b !important;
}

.text-info {
  color: #188ef4 !important;
}

.text-inverse {
  color: #3e4555 !important;
}

.text-success-gradiant {
  background: #2cdd9b;
  background: linear-gradient(to right, #2cdd9b 0%, #1dc8cc 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
}

.text-info-gradiant {
  background: #188ef4;
  background: linear-gradient(to right, #188ef4 0%, #316ce8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
}

html body .text-blue {
  color: #02bec9;
}
html body .text-purple {
  color: #7460ee;
}
html body .text-primary {
  color: #316ce8 !important;
}
html body .text-megna {
  color: #1dc8cd;
}
html body .text-dark {
  color: #8d97ad;
}
html body .text-themecolor {
  color: #631117;
}

/*******************
Background Colors
*******************/
.bg-primary {
  background-color: #316ce8 !important;
}

.bg-success {
  background-color: #2cdd9b !important;
}

.bg-info {
  background-color: #188ef4 !important;
}

.bg-warning {
  background-color: #fec500 !important;
}

.bg-danger {
  background-color: #ff4d7e !important;
}

.bg-orange {
  background-color: #ff6a5b !important;
}

.bg-yellow {
  background-color: #fed700;
}

.bg-facebook {
  background-color: #3b5a9a;
}

.bg-twitter {
  background-color: #56adf2;
}

.bg-success-gradiant {
  background: #2cdd9b;
  background: linear-gradient(to right, #2cdd9b 0%, #1dc8cc 100%);
}

.bg-info-gradiant {
  background: #188ef4;
  background: linear-gradient(to right, #188ef4 0%, #316ce8 100%);
}

.bg-danger-gradiant {
  background: #ff4d7e;
  background: linear-gradient(to right, #ff4d7e 0%, #ff6a5b 100%);
}

html body .bg-megna {
  background-color: #1dc8cd;
}
html body .bg-theme {
  background-color: #631117;
}
html body .bg-inverse {
  background-color: #3e4555;
}
html body .bg-purple {
  background-color: #7460ee;
}
html body .bg-light {
  background-color: #f4f8fa !important;
}
html body .bg-light-primary {
  background-color: #f1effd;
}
html body .bg-light-success {
  background-color: #e8fdeb;
}
html body .bg-light-info {
  background-color: #cfecfe;
}
html body .bg-light-extra {
  background-color: #ebf3f5;
}
html body .bg-light-warning {
  background-color: #fff8ec;
}
html body .bg-light-danger {
  background-color: #f9e7eb;
}
html body .bg-light-inverse {
  background-color: #f6f6f6;
}
html body .bg-light {
  background-color: #f4f8fa;
}
html body .bg-white {
  background-color: #ffffff;
}

/*******************
Rounds
*******************/
.round {
  line-height: 48px;
  color: #ffffff;
  width: 50px;
  height: 50px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  border-radius: 100%;
  background: #188ef4;
}
.round img {
  border-radius: 100%;
}

.round-lg {
  line-height: 65px;
  width: 60px;
  height: 60px;
  font-size: 30px;
}

.round.round-info {
  background: #188ef4;
}

.round.round-warning {
  background: #fec500;
}

.round.round-danger {
  background: #ff4d7e;
}

.round.round-success {
  background: #2cdd9b;
}

.round.round-primary {
  background: #316ce8;
}

/*******************
Labels
*******************/
.label {
  padding: 3px 15px;
  line-height: 13px;
  color: #ffffff;
  font-weight: 400;
  border-radius: 4px;
  font-size: 75%;
}

.label-rounded {
  border-radius: 60px;
}

.label-custom {
  background-color: #1dc8cd;
}

.label-success {
  background-color: #2cdd9b;
}

.label-info {
  background-color: #188ef4;
}

.label-warning {
  background-color: #fec500;
}

.label-danger {
  background-color: #ff4d7e;
}

.label-megna {
  background-color: #1dc8cd;
}

.label-primary {
  background-color: #316ce8;
}

.label-purple {
  background-color: #7460ee;
}

.label-red {
  background-color: #fb3a3a;
}

.label-inverse {
  background-color: #3e4555;
}

.label-default {
  background-color: #f4f8fa;
}

.label-white {
  background-color: #ffffff;
}

.label-light-success {
  background-color: #e8fdeb;
  color: #2cdd9b;
}

.label-light-info {
  background-color: #cfecfe;
  color: #188ef4;
}

.label-light-warning {
  background-color: #fff8ec;
  color: #fec500;
}

.label-light-danger {
  background-color: #f9e7eb;
  color: #ff4d7e;
}

.label-light-megna {
  background-color: #e0f2f4;
  color: #1dc8cd;
}

.label-light-primary {
  background-color: #f1effd;
  color: #316ce8;
}

.label-light-inverse {
  background-color: #f6f6f6;
  color: #3e4555;
}

/*******************
 Badge
******************/
.badge {
  font-weight: 400;
}

.badge-xs {
  font-size: 9px;
}

.badge-xs,
.badge-sm {
  transform: translate(0, -2px);
}

.badge-success {
  background-color: #2cdd9b;
}

.badge-info {
  background-color: #188ef4;
}

.badge-primary {
  background-color: #316ce8;
}

.badge-warning {
  background-color: #fec500;
}

.badge-danger {
  background-color: #ff4d7e;
}

.badge-purple {
  background-color: #7460ee;
}

.badge-red {
  background-color: #fb3a3a;
}

.badge-inverse {
  background-color: #3e4555;
}

/*******************
List-style-none
******************/
ul.list-style-none {
  margin: 0px;
  padding: 0px;
}
ul.list-style-none li {
  list-style: none;
}
ul.list-style-none li a {
  color: #8d97ad;
  padding: 8px 0px;
  display: block;
  text-decoration: none;
}
ul.list-style-none li a:hover {
  color: #631117;
}

/*******************
dropdown-item
******************/
.dropdown-item {
  padding: 8px 1rem;
  color: #8d97ad;
}

/*******************
Buttons
******************/
.btn {
  color: #ffffff;
  padding: 10px 25px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.14);
  transition: 0s;
}
.btn:hover {
  color: #ffffff;
}
.btn:focus {
  box-shadow: none;
}

.btn-link {
  box-shadow: none;
  color: #263238;
  padding: 10px 15px;
}
.btn-link .underline {
  border-bottom: 1px solid #263238;
}
.btn-link:hover {
  color: #2cdd9b;
}

.btn-light {
  color: #263238;
}
.btn-light:hover {
  background: #263238;
  color: #ffffff;
  border-color: #263238;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
}

.btn-md {
  padding: 15px 45px;
  font-size: 16px;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 12px;
}

.btn-xs {
  padding: 0.25rem 0.5rem;
  font-size: 10px;
}

.btn-circle {
  border-radius: 100%;
  width: 40px;
  height: 40px;
  padding: 10px;
}
.btn-circle.btn-md {
  padding: 22px 25px;
}

.btn-circle.btn-sm, .btn-group-sm > .btn-circle.btn {
  width: 35px;
  height: 35px;
  padding: 8px 10px;
  font-size: 14px;
}

.btn-circle.btn-lg, .btn-group-lg > .btn-circle.btn {
  width: 50px;
  height: 50px;
  padding: 14px 15px;
  font-size: 18px;
  line-height: 23px;
}

.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 14px 15px;
  font-size: 24px;
}

.btn-rounded {
  border-radius: 60px;
  -webkit-border-radius: 60px;
}

.btn-arrow {
  position: relative;
}
.btn-arrow span {
  display: inline-block;
  position: relative;
  transition: all 300ms ease-out;
  will-change: transform;
}
.btn-arrow:hover span, .btn-arrow:focus span {
  transform: translate3d(-1rem, 0, 0);
}
.btn-arrow i {
  position: absolute;
  width: 1.1em;
  right: 0px;
  right: 0rem;
  opacity: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 300ms ease-out;
  will-change: right, opacity;
}
.btn-arrow:hover i, .btn-arrow:focus i {
  opacity: 1;
  right: -2rem;
}

.btn-primary,
.btn-primary.disabled {
  background: #316ce8;
  border: 1px solid #316ce8;
  transition: 0.2s ease-in;
}
.btn-primary:hover,
.btn-primary.disabled:hover {
  background: #345bcb;
  border: 1px solid #345bcb;
}
.btn-primary.active, .btn-primary:active, .btn-primary:focus,
.btn-primary.disabled.active,
.btn-primary.disabled:active,
.btn-primary.disabled:focus {
  background: #345bcb;
}

.btn-themecolor,
.btn-themecolor.disabled {
  background: #631117;
  color: #ffffff;
  border: 1px solid #631117;
}
.btn-themecolor:hover,
.btn-themecolor.disabled:hover {
  background: #028ee1;
  border: 1px solid #028ee1;
}
.btn-themecolor.active, .btn-themecolor:active, .btn-themecolor:focus,
.btn-themecolor.disabled.active,
.btn-themecolor.disabled:active,
.btn-themecolor.disabled:focus {
  background: #028ee1;
}

.btn-success,
.btn-success.disabled {
  background: #2cdd9b;
  border: 1px solid #2cdd9b;
}
.btn-success:hover,
.btn-success.disabled:hover {
  background: #1dc8cc;
  border: 1px solid #1dc8cc;
}
.btn-success.active, .btn-success:active, .btn-success:focus,
.btn-success.disabled.active,
.btn-success.disabled:active,
.btn-success.disabled:focus {
  background: #1dc8cc;
}

.btn-info,
.btn-info.disabled {
  background: #188ef4;
  border: 1px solid #188ef4;
  transition: 0.2s ease-in;
}
.btn-info:hover,
.btn-info.disabled:hover {
  background: #2c73cb;
  border: 1px solid #2c73cb;
}
.btn-info.active, .btn-info:active, .btn-info:focus,
.btn-info.disabled.active,
.btn-info.disabled:active,
.btn-info.disabled:focus {
  background: #2c73cb;
}

.btn-warning,
.btn-warning.disabled {
  background: #fec500;
  color: #ffffff;
  border: 1px solid #fec500;
}
.btn-warning:hover,
.btn-warning.disabled:hover {
  background: #dcaf17;
  color: #ffffff;
  border: 1px solid #dcaf17;
}
.btn-warning.active, .btn-warning:active, .btn-warning:focus,
.btn-warning.disabled.active,
.btn-warning.disabled:active,
.btn-warning.disabled:focus {
  background: #dcaf17;
  color: #ffffff;
}

.btn-danger,
.btn-danger.disabled {
  background: #ff4d7e;
  border: 1px solid #ff4d7e;
  transition: 0.2s ease-in;
}
.btn-danger:hover,
.btn-danger.disabled:hover {
  background: #d73e6b;
  border: 1px solid #d73e6b;
}
.btn-danger.active, .btn-danger:active, .btn-danger:focus,
.btn-danger.disabled.active,
.btn-danger.disabled:active,
.btn-danger.disabled:focus {
  background: #d73e6b;
}

.btn-inverse,
.btn-inverse.disabled {
  background: #3e4555;
  border: 1px solid #3e4555;
  color: #ffffff;
}
.btn-inverse:hover,
.btn-inverse.disabled:hover {
  background: #232a37;
  color: #ffffff;
  border: 1px solid #232a37;
}
.btn-inverse.active, .btn-inverse:active, .btn-inverse:focus,
.btn-inverse.disabled.active,
.btn-inverse.disabled:active,
.btn-inverse.disabled:focus {
  background: #232a37;
  color: #ffffff;
}

.btn-red,
.btn-red.disabled {
  background: #fb3a3a;
  border: 1px solid #fb3a3a;
  color: #ffffff;
}
.btn-red:hover,
.btn-red.disabled:hover {
  border: 1px solid #d61f1f;
  background: #d61f1f;
}
.btn-red.active, .btn-red:active, .btn-red:focus,
.btn-red.disabled.active,
.btn-red.disabled:active,
.btn-red.disabled:focus {
  background: #d73e6b;
}

.btn-success-gradiant {
  background: #2cdd9b;
  background: linear-gradient(to right, #2cdd9b 0%, #1dc8cc 100%);
  border: 0px;
}
.btn-success-gradiant:hover {
  background: #1dc8cc;
  background: linear-gradient(to right, #1dc8cc 0%, #2cdd9b 100%);
}
.btn-success-gradiant.active, .btn-success-gradiant:active, .btn-success-gradiant:focus {
  box-shadow: 0px;
  opacity: 1;
}

.btn-danger-gradiant {
  background: #ff4d7e;
  background: linear-gradient(to right, #ff4d7e 0%, #ff6a5b 100%);
  border: 0px;
}
.btn-danger-gradiant:hover {
  background: #ff6a5b;
  background: linear-gradient(to right, #ff6a5b 0%, #ff4d7e 100%);
}
.btn-danger-gradiant.active, .btn-danger-gradiant:active, .btn-danger-gradiant:focus {
  box-shadow: 0px;
  opacity: 1;
}

.btn-info-gradiant {
  background: #188ef4;
  background: linear-gradient(to right, #188ef4 0%, #316ce8 100%);
  border: 0px;
}
.btn-info-gradiant:hover {
  background: #316ce8;
  background: linear-gradient(to right, #316ce8 0%, #188ef4 100%);
}
.btn-info-gradiant.active, .btn-info-gradiant:active, .btn-info-gradiant:focus {
  box-shadow: 0px;
  opacity: 1;
}

.btn-outline-secondary {
  background-color: #ffffff;
  color: #727b84;
  transition: 0.2s ease-in;
}
.btn-outline-secondary.active, .btn-outline-secondary:active, .btn-outline-secondary:focus {
  background: #263238;
}

.btn-outline-primary {
  color: #316ce8;
  background-color: #ffffff;
  border-color: #316ce8;
  transition: 0.2s ease-in;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary.focus {
  background: #316ce8;
  color: #ffffff;
  border-color: #316ce8;
}
.btn-outline-primary.active, .btn-outline-primary:active, .btn-outline-primary:focus {
  background: #345bcb;
}

.btn-outline-success,
a.btn-outline-success {
  color: #2cdd9b;
  background-color: transparent;
  border-color: #2cdd9b;
  transition: 0.2s ease-in;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success.focus,
a.btn-outline-success:hover,
a.btn-outline-success:focus,
a.btn-outline-success.focus {
  background: #2cdd9b;
  border-color: #2cdd9b;
  color: #ffffff;
}
.btn-outline-success.active, .btn-outline-success:active, .btn-outline-success:focus,
a.btn-outline-success.active,
a.btn-outline-success:active,
a.btn-outline-success:focus {
  background: #1dc8cc;
}

.btn-outline-info {
  color: #188ef4;
  background-color: transparent;
  border-color: #188ef4;
  transition: 0.2s ease-in;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info.focus {
  background: #188ef4;
  border-color: #188ef4;
  color: #ffffff;
}
.btn-outline-info.active, .btn-outline-info:active, .btn-outline-info:focus {
  background: #2c73cb;
}

.btn-outline-warning {
  color: #fec500;
  background-color: transparent;
  border-color: #fec500;
  transition: 0.2s ease-in;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning.focus {
  background: #fec500;
  border-color: #fec500;
  color: #ffffff;
}
.btn-outline-warning.active, .btn-outline-warning:active, .btn-outline-warning:focus {
  background: #dcaf17;
}

.btn-outline-danger {
  color: #ff4d7e;
  background-color: transparent;
  border-color: #ff4d7e;
  transition: 0.2s ease-in;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger.focus {
  background: #ff4d7e;
  border-color: #ff4d7e;
  color: #ffffff;
}
.btn-outline-danger.active, .btn-outline-danger:active, .btn-outline-danger:focus {
  background: #d73e6b;
}

.btn-outline-red {
  color: #fb3a3a;
  background-color: transparent;
  border-color: #fb3a3a;
}
.btn-outline-red:hover, .btn-outline-red:focus, .btn-outline-red.focus {
  background: #fb3a3a;
  border-color: #fb3a3a;
  color: #ffffff;
}
.btn-outline-red.active, .btn-outline-red:active, .btn-outline-red:focus {
  background: #d73e6b;
}

.btn-outline-inverse {
  color: #3e4555;
  background-color: transparent;
  border-color: #3e4555;
}
.btn-outline-inverse:hover, .btn-outline-inverse:focus, .btn-outline-inverse.focus {
  background: #3e4555;
  border-color: #3e4555;
  color: #ffffff;
}

.btn-outline-light:hover {
  color: #263238 !important;
}

.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary.focus:active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover,
.btn-primary.focus,
.btn-primary:focus {
  background-color: #345bcb;
  border: 1px solid #345bcb;
}

.btn-success.active.focus,
.btn-success.active:focus,
.btn-success.active:hover,
.btn-success.focus:active,
.btn-success:active:focus,
.btn-success:active:hover,
.open > .dropdown-toggle.btn-success.focus,
.open > .dropdown-toggle.btn-success:focus,
.open > .dropdown-toggle.btn-success:hover,
.btn-success.focus,
.btn-success:focus {
  background-color: #1dc8cc;
  border: 1px solid #1dc8cc;
}

.btn-info.active.focus,
.btn-info.active:focus,
.btn-info.active:hover,
.btn-info.focus:active,
.btn-info:active:focus,
.btn-info:active:hover,
.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover,
.btn-info.focus,
.btn-info:focus {
  background-color: #2c73cb;
  border: 1px solid #2c73cb;
}

.btn-warning.active.focus,
.btn-warning.active:focus,
.btn-warning.active:hover,
.btn-warning.focus:active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover,
.btn-warning.focus,
.btn-warning:focus {
  background-color: #dcaf17;
  border: 1px solid #dcaf17;
}

.btn-danger.active.focus,
.btn-danger.active:focus,
.btn-danger.active:hover,
.btn-danger.focus:active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover,
.btn-danger.focus,
.btn-danger:focus {
  background-color: #d73e6b;
  border: 1px solid #d73e6b;
}

.btn-inverse:hover,
.btn-inverse:focus,
.btn-inverse:active,
.btn-inverse.active,
.btn-inverse.focus,
.btn-inverse:active,
.btn-inverse:focus,
.btn-inverse:hover,
.open > .dropdown-toggle.btn-inverse {
  background-color: #232a37;
  border: 1px solid #232a37;
}

.btn-red:hover,
.btn-red:focus,
.btn-red:active,
.btn-red.active,
.btn-red.focus,
.btn-red:active,
.btn-red:focus,
.btn-red:hover,
.open > .dropdown-toggle.btn-red {
  background-color: #d61f1f;
  border: 1px solid #d61f1f;
  color: #ffffff;
}

.btn span.btn-devider {
  display: inline-block;
  padding-left: 10px;
}

/*-------------------*/
/*On off switch*/
/*-------------------*/
.onoffswitch {
  position: relative;
  width: 70px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin: 0 auto;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 20px;
}

.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner:before, .onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 30px;
  padding: 0;
  line-height: 30px;
  font-size: 14px;
  color: white;
  box-sizing: border-box;
}
.onoffswitch-inner:before {
  content: "";
  padding-right: 27px;
  background-color: #2cdd9b;
  color: #FFFFFF;
}
.onoffswitch-inner:after {
  content: "";
  padding-right: 24px;
  background-color: #3e4555;
  color: #999999;
  text-align: right;
}

.onoffswitch-switch {
  display: block;
  width: 23px;
  margin: 6px;
  background: #FFFFFF;
  height: 23px;
  position: absolute;
  top: -1px;
  bottom: 0;
  right: 35px;
  border-radius: 20px;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}

/*-------------------*/
/*Bootstrap 4 hack*/
/*-------------------*/
.card-columns {
  column-gap: 30px;
}
.card-columns .card {
  margin-bottom: 30px;
}

.invisible {
  visibility: hidden !important;
}

.hidden-xs-up {
  display: none !important;
}

@media (max-width: 575px) {
  .hidden-xs-down {
    display: none !important;
  }
}
@media (min-width: 576px) {
  .hidden-sm-up {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .hidden-sm-down {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .hidden-md-up {
    display: none !important;
  }
}
@media (max-width: 991px) {
  .hidden-md-down {
    display: none !important;
  }
}
@media (min-width: 992px) {
  .hidden-lg-up {
    display: none !important;
  }
}
@media (max-width: 1199px) {
  .hidden-lg-down {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-xl-up {
    display: none !important;
  }
}
.hidden-xl-down {
  display: none !important;
}

.coming-soon {
  min-height: 400px;
  overflow: auto;
  background-size: cover;
  background-position: top 20% center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

/*
Template Name: Wrakit UI Kit
Author: wrappixel
Email: niravjoshi87@gmail.com
File: scss
*/
/******************* 
Topbar
*******************/
.topbar {
  padding: 0px;
  transition: 0.2s ease-in;
  width: 100%;
  position: absolute;
  z-index: 20;
}

/*******************
Header 6
*******************/
.header6 .navbar-toggler {
  color: #ffffff;
}
.header6 .navbar-brand {
  line-height: 80px;
}

.h6-nav-bar {
  padding: 0px;
}
.h6-nav-bar .navbar-nav .nav-link {
  padding: 35px 15px;
  color: rgba(255, 255, 255, 0.5);
  transition-duration: 1.2s;
  transition-timing-function: cubic-bezier(0.1, 0.7, 1, 0.1);
}
.h6-nav-bar .navbar-nav .nav-item:hover .nav-link,
.h6-nav-bar .navbar-nav .nav-item.active .nav-link {
  color: rgb(255, 255, 255);
}
.h6-nav-bar .act-buttons .btn {
  margin: 10px 0 10px 10px;
}

@media (max-width: 1023px) {
  .h6-nav-bar .navbar-nav .nav-link {
    padding: 15px 15px;
  }
  .h6-nav-bar .act-buttons .btn {
    margin: 10px 0 10px 0px;
  }
}
.static-slider-head {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
  background-size: cover;
  background-position: center center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.static-slider-head .title {
  color: #ffffff;
  font-weight: 700;
  font-size: 70px;
  line-height: 100px;
}
.static-slider-head .subtitle {
  color: #ffffff;
  line-height: 30px;
}

.carousel-item > img {
  width: 100%;
}

/******************* 
Main & Page wrapper
*******************/
.page-wrapper {
  padding-top: 0px;
}

#main-wrapper {
  overflow: hidden;
}

/******************* 
container fluid
*******************/
.container-fluid {
  padding: 0px;
}

/******************* 
footer
*******************/
.footer {
  padding: 20px 0;
  text-align: center;
}

/******************* 
Fix-width
*******************/
.fix-width {
  width: 100%;
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 15px;
}

/******************* 
Spacer
*******************/
.spacer {
  padding: 90px 0;
}

.mini-spacer {
  padding: 40px 0;
}

/******************* 
Title
*******************/
.title {
  margin: 20px 0 15px;
}

/******************* 
Subtitle
*******************/
.subtitle {
  color: #8d97ad;
  line-height: 24px;
}

/******************* 
card
*******************/
.card {
  border: 0px;
  margin-bottom: 30px;
}
.card.card-shadow {
  box-shadow: 0px 0px 30px rgba(115, 128, 157, 0.1);
}

.card-group .card {
  border: 1px solid rgba(120, 130, 140, 0.13);
  margin-bottom: 30px;
}

/******************* 
Icon space
*******************/
.icon-space {
  margin: 20px 0;
}

.linking {
  color: #3e4555;
}
.linking i {
  font-size: 14px;
  margin-left: 10px;
  transition: 0.2s ease-in;
}
.linking:hover {
  color: #631117;
}
.linking:hover i {
  margin-left: 15px;
}

/******************* 
Listing
*******************/
.list-block {
  margin: 0px;
  padding: 0px;
}
.list-block li {
  list-style: none;
  padding: 10px 0;
  display: flex;
}
.list-block li i {
  margin-right: 10px;
  flex-shrink: 0px;
  margin-top: 3px;
}
.list-block.with-underline li {
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
  padding: 15px 0;
}

/******************* 
Listing
*******************/
.img-inline {
  margin: 0px;
  padding: 0px;
}
.img-inline li {
  list-style: none;
}
.img-inline li.half-width {
  width: 49%;
  display: inline-block;
  vertical-align: top;
}

/******************* 
Image shadow
*******************/
.img-shadow {
  box-shadow: 0px 0px 30px rgba(115, 128, 157, 0.3);
}

/******************* 
Image shadow
*******************/
.icon-round {
  width: 80px;
  line-height: 80px;
  text-align: center;
  border-radius: 100%;
  display: inline-block;
}

.no-shrink {
  flex-shrink: 0;
}

/******************* 
up section
*******************/
.up {
  z-index: 10;
  position: relative;
}

.bt-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 100;
  visibility: hidden;
}

/******************* 
both space
*******************/
.both-space {
  margin: 80px 0;
}

/******************* 
Side text content
*******************/
.side-content {
  padding: 40px 60px;
}

/******************* 
background cover
*******************/
.bg-cover {
  background-size: cover;
  min-height: 200px;
}

/******************* 
Owl carousel
*******************/
.owl-carousel {
  display: block;
  width: 100%;
}
.owl-carousel .owl-stage-outer {
  position: relative;
  overflow: hidden;
}
.owl-carousel .owl-stage {
  position: relative;
}
.owl-carousel .owl-item {
  float: left;
}
.owl-carousel .owl-nav.disabled {
  display: none;
}

/******************* 
Max width
*******************/
.max-300 {
  max-width: 300px;
}

.max-400 {
  max-width: 400px;
}

.max-500 {
  max-width: 500px;
}

.max-600 {
  max-width: 600px;
}

/******************* 
line sticks
*******************/
.stick-bottom {
  position: relative;
  margin-bottom: 30px;
}
.stick-bottom > span {
  width: 30px;
  height: 2px;
  position: absolute;
  bottom: -7px;
  left: 0px;
  display: inline-block;
}

/******************* 
position
*******************/
.po-absolute {
  position: absolute;
}

.po-relative {
  position: relative;
}

/*-------------------*/
/*Bootstrap 4 hack*/
/*-------------------*/
.invisible {
  visibility: hidden !important;
}

.hidden-xs-up {
  display: none !important;
}

@media (max-width: 575px) {
  .hidden-xs-down {
    display: none !important;
  }
}
@media (min-width: 576px) {
  .hidden-sm-up {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .hidden-sm-down {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .hidden-md-up {
    display: none !important;
  }
}
@media (max-width: 991px) {
  .hidden-md-down {
    display: none !important;
  }
}
@media (min-width: 992px) {
  .hidden-lg-up {
    display: none !important;
  }
}
@media (max-width: 1199px) {
  .hidden-lg-down {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-xl-up {
    display: none !important;
  }
}
.hidden-xl-down {
  display: none !important;
}

/*************/
/* Dropdown*/
/*************/
.navbar-nav .dropdown-toggle::after {
  display: none;
}

.navbar-nav .dropdown-menu.b-none {
  border: 0px;
  box-shadow: 0px 0px 30px rgba(115, 128, 157, 0.1);
}

.navbar-nav {
  font-weight: 400;
}

.navbar-nav .dropdown-menu.b-none {
  border: 0px;
  box-shadow: 0px 0px 30px rgba(115, 128, 157, 0.1);
}

.pre-scroll {
  position: relative;
}

.mega-dropdown {
  position: relative;
}
.mega-dropdown .dropdown-menu {
  width: 100%;
  min-width: 400px !important;
  padding: 30px;
  margin-top: 0px;
  overflow: hidden;
  right: 0;
  left: unset;
}
.mega-dropdown .list-style-none {
  font-size: 14px;
}
.mega-dropdown .inside-bg {
  margin: -30px 0 -30px -30px;
}
.mega-dropdown .inside-bg-right {
  margin: -30px -30px -30px 0;
}
.mega-dropdown .bg-img {
  background-size: cover;
  height: 100%;
  padding: 30px;
}
.mega-dropdown h6 {
  margin: 15px 0;
  font-size: 15px;
}

/*************/
/* General Listing*/
/*************/
.general-listing {
  padding: 0px;
  margin: 0px;
}
.general-listing li {
  list-style: none;
}
.general-listing li a {
  color: #8d97ad;
  display: flex;
  padding: 10px 0;
  transition: 0.2s ease-in;
  align-items: center;
}
.general-listing li:hover a {
  color: #631117;
  padding-left: 10px;
}
.general-listing li i {
  margin-right: 7px;
  vertical-align: middle;
}
.general-listing.two-part li {
  width: 49%;
  display: inline-block;
}
.general-listing.only-li li {
  padding: 5px 0;
}

/*************/
/* form dark*/
/*************/
.form-control-dark {
  background: rgba(120, 130, 140, 0.13);
  color: #ffffff;
  border-color: rgba(120, 130, 140, 0.13);
}
.form-control-dark:focus {
  background: rgba(120, 130, 140, 0.13);
  color: #ffffff;
}

/*************/
/* social-round */
/*************/
.round-social a {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: inline-block;
  border-radius: 100%;
  margin: 0 5px;
  transition: 0.2s ease-in;
}
.round-social a:hover {
  transform: translate3d(0px, -5px, 0px);
}
.round-social.light a {
  color: #263238;
  background: #f4f8fa;
}
.round-social.light a:hover {
  background: #263238;
  color: #ffffff;
}

/*************/
/* Form Banner */
/*************/
.banner {
  position: relative;
  max-height: 700px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  width: 100%;
  display: table;
}
.banner .banner-content {
  display: table-cell;
  vertical-align: middle;
  width: 100%;
}

@media (max-width: 992px) {
  .banner {
    height: auto !important;
    padding: 100px 0;
  }
}
@media (max-width: 767px) {
  .banner {
    padding: 30px 0;
  }
}
.form-control {
  padding: 0.75rem;
  border: 2px solid rgba(120, 130, 140, 0.13);
}

select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 12px);
}

/*******************
UI-Elements
******************/
/*******************
Buttons
******************/
.button-group .btn {
  margin-bottom: 7px;
}

/*******************
Grid page
******************/
.show-grid {
  margin-bottom: 10px;
  padding: 0 15px;
}

.show-grid [class^=col-] {
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid rgba(120, 130, 140, 0.13);
  background-color: #f4f8fa;
}

/*******************
list and media
******************/
.list-group a.list-group-item:hover {
  background: #f4f8fa;
}

.list-group-item.active,
.list-group .list-group-item.active:hover {
  background: #631117;
  border-color: #631117;
}

.list-group-item.disabled {
  color: #8d97ad;
  background: #f4f8fa;
}

.media {
  border: 1px solid rgba(120, 130, 140, 0.13);
  margin-bottom: 10px;
  padding: 15px;
}

/*******************
Notification page Jquery toaster
******************/
.alert-rounded {
  border-radius: 60px;
}

/*******************
Progress bar
******************/
.progress.active .progress-bar,
.progress-bar.active {
  animation: progress-bar-stripes 2s linear infinite;
}

.progress-vertical {
  min-height: 250px;
  height: 250px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
  transform: rotate(180deg);
}

.progress-animated {
  -webkit-animation-duration: 5s;
  -webkit-animation-name: myanimation;
  -webkit-transition: 5s all;
  animation-duration: 5s;
  animation-name: myanimation;
  transition: 5s all;
}
@keyframes myanimation {
  from {
    width: 0;
  }
}
/*******************
Vertical tabs
******************/
.vtabs {
  display: table;
}
.vtabs .tabs-vertical {
  width: 150px;
  border-bottom: 0px;
  border-right: 1px solid rgba(120, 130, 140, 0.13);
  display: table-cell;
  vertical-align: top;
}
.vtabs .tabs-vertical li .nav-link {
  color: #263238;
  margin-bottom: 10px;
  border: 0px;
  border-radius: 4px 0 0 4px;
}
.vtabs .tab-content {
  display: table-cell;
  padding: 20px;
  vertical-align: top;
}

.tabs-vertical li .nav-link.active,
.tabs-vertical li .nav-link:hover,
.tabs-vertical li .nav-link.active:focus {
  background: #631117;
  border: 0px;
  color: #ffffff;
}

/*Custom vertical tab*/
.customvtab .tabs-vertical li .nav-link.active,
.customvtab .tabs-vertical li .nav-link:hover,
.customvtab .tabs-vertical li .nav-link:focus {
  background: #ffffff;
  border: 0px;
  border-right: 2px solid #631117;
  margin-right: -1px;
  color: #631117;
}

.tabcontent-border {
  border: 1px solid #ddd;
  border-top: 0px;
}

.customtab2 li a.nav-link {
  border: 0px;
  margin-right: 3px;
  color: #8d97ad;
}
.customtab2 li a.nav-link.active {
  background: #631117;
  color: #ffffff;
}
.customtab2 li a.nav-link:hover {
  color: #ffffff;
  background: #631117;
}

/*******************
Timeline page
******************/
.timeline {
  position: relative;
  padding: 20px 0 20px;
  list-style: none;
  max-width: 1200px;
  margin: 0 auto;
}

.timeline:before {
  content: " ";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 3px;
  margin-left: -1.5px;
  background-color: #f4f8fa;
}

.timeline > li {
  position: relative;
  margin-bottom: 20px;
}

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid rgba(120, 130, 140, 0.13);
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}

.timeline > li > .timeline-panel:before {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 26px;
  right: -8px;
  border-top: 8px solid transparent;
  border-right: 0 solid rgba(120, 130, 140, 0.13);
  border-bottom: 8px solid transparent;
  border-left: 8px solid rgba(120, 130, 140, 0.13);
}

.timeline > li > .timeline-panel:after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #ffffff;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #ffffff;
}

.timeline > li > .timeline-badge {
  z-index: 10;
  position: absolute;
  top: 16px;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  border-radius: 50% 50% 50% 50%;
  text-align: center;
  font-size: 1.4em;
  line-height: 46px;
  color: #fff;
  overflow: hidden;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}

.timeline > li.timeline-inverted > .timeline-panel:before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0;
}

.timeline > li.timeline-inverted > .timeline-panel:after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #316ce8;
}

.timeline-badge.success {
  background-color: #2cdd9b;
}

.timeline-badge.warning {
  background-color: #fec500;
}

.timeline-badge.danger {
  background-color: #ff4d7e;
}

.timeline-badge.info {
  background-color: #188ef4;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: 400;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

/*============================================================== 
 Ui-bootstrap
 ============================================================== */
ul.list-icons {
  margin: 0px;
  padding: 0px;
}
ul.list-icons li {
  list-style: none;
  line-height: 30px;
  margin: 5px 0;
  transition: 0.2s ease-in;
}
ul.list-icons li a {
  color: #8d97ad;
}
ul.list-icons li a:hover {
  color: #631117;
}
ul.list-icons li i {
  font-size: 13px;
  padding-right: 8px;
}

ul.list-inline li {
  display: inline-block;
}
ul.list-inline li:first-child {
  padding-left: 0px;
}
ul.list-inline li a {
  color: #8d97ad;
}
ul.list-inline li a:hover {
  color: #631117;
}

ul.two-part {
  margin: 0px;
}
ul.two-part li {
  width: 48.8%;
}

/*Accordion*/
html body .accordion .card {
  margin-bottom: 0px;
}

#accordion4 .card-header {
  border: 1px solid rgba(120, 130, 140, 0.13);
  background: transparent;
  margin-bottom: 10px;
}
#accordion4 .card-header a {
  color: #8d97ad;
}
#accordion4 .card-header:hover {
  background-color: #188ef4;
  border: 1px solid #188ef4;
}
#accordion4 .card-header:hover a {
  color: #ffffff;
}
#accordion4 .card.active .card-header {
  background-color: #188ef4;
  border: 1px solid #188ef4;
}
#accordion4 .card.active .card-header a {
  color: #ffffff;
}

/*===================== 
Breadcrumb
=====================*/
.bc-colored .breadcrumb-item,
.bc-colored .breadcrumb-item a {
  color: #ffffff;
}
.bc-colored .breadcrumb-item.active,
.bc-colored .breadcrumb-item a.active {
  opacity: 0.7;
}
.bc-colored .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.4);
}

/*******************
 Card title
*******************/
.card-title {
  font-size: 18px;
}

.card-subtitle {
  color: #8d97ad;
  margin-bottom: 30px;
  font-size: 14px;
}

.card-inverse .card-bodyquote .blockquote-footer,
.card-inverse .card-link,
.card-inverse .card-subtitle,
.card-inverse .card-text {
  color: rgba(255, 255, 255, 0.65);
}

.card-default .card-header {
  background: #ffffff;
  border-bottom: 0px;
}

.card-success {
  background: #2cdd9b;
  border-color: #2cdd9b;
}

.card-danger {
  background: #ff4d7e;
  border-color: #ff4d7e;
}

.card-warning {
  background: #fec500;
  border-color: #fec500;
}

.card-info {
  background: #188ef4;
  border-color: #188ef4;
}

.card-primary {
  background: #316ce8;
  border-color: #316ce8;
}

.card-dark {
  background: #3e4555;
  border-color: #3e4555;
}

.card-megna {
  background: #1dc8cd;
  border-color: #1dc8cd;
}

/*============================================================== 
 Cards page
 ============================================================== */
.card-columns .card {
  margin-bottom: 20px;
}

.collapsing {
  transition: height 0.08s ease;
}

.card-info {
  background: #188ef4;
  border-color: #188ef4;
}

.card-primary {
  background: #316ce8;
  border-color: #316ce8;
}

.card-outline-info {
  border-color: #188ef4;
}
.card-outline-info .card-header {
  background: #188ef4;
  border-color: #188ef4;
}

.card-outline-inverse {
  border-color: #3e4555;
}
.card-outline-inverse .card-header {
  background: #3e4555;
  border-color: #3e4555;
}

.card-outline-warning {
  border-color: #fec500;
}
.card-outline-warning .card-header {
  background: #fec500;
  border-color: #fec500;
}

.card-outline-success {
  border-color: #2cdd9b;
}
.card-outline-success .card-header {
  background: #2cdd9b;
  border-color: #2cdd9b;
}

.card-outline-danger {
  border-color: #ff4d7e;
}
.card-outline-danger .card-header {
  background: #ff4d7e;
  border-color: #ff4d7e;
}

.card-outline-primary {
  border-color: #316ce8;
}
.card-outline-primary .card-header {
  background: #316ce8;
  border-color: #316ce8;
}

/*******************
Custom-select
******************/
.custom-select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) right 0.75rem center no-repeat;
  border: 2px solid rgba(120, 130, 140, 0.13);
  height: calc(2.25rem + 12px);
}

/*******************
textarea
******************/
textarea {
  resize: none;
}

.form-control-danger,
.form-control-success,
.form-control-warning {
  padding-right: 2.25rem;
  background-repeat: no-repeat;
  background-position: center right 0.5625rem;
  background-size: 1.125rem 1.125rem;
}

.has-success .col-form-label,
.has-success .custom-control,
.has-success .form-check-label,
.has-success .form-control-feedback,
.has-success .form-control-label {
  color: #2cdd9b;
}

.has-success .form-control-success {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.has-success .form-control {
  border-color: #2cdd9b;
}

.has-warning .col-form-label,
.has-warning .custom-control,
.has-warning .form-check-label,
.has-warning .form-control-feedback,
.has-warning .form-control-label {
  color: #fec500;
}

.has-warning .form-control-warning {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.has-warning .form-control {
  border-color: #fec500;
}

.has-danger .col-form-label,
.has-danger .custom-control,
.has-danger .form-check-label,
.has-danger .form-control-feedback,
.has-danger .form-control-label {
  color: #ff4d7e;
}

.has-danger .form-control-danger {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.has-danger .form-control {
  border-color: #ff4d7e;
}

.input-group-addon [type=radio]:not(:checked),
.input-group-addon [type=radio]:checked,
.input-group-addon [type=checkbox]:not(:checked),
.input-group-addon [type=checkbox]:checked {
  position: initial;
  opacity: 1;
}

.input-form .btn {
  padding: 14px 12px;
}

.form-control-sm {
  padding: 0.25rem 0.5rem;
}

/*******************
custom modals
******************/
.custom-modal .close-btn {
  position: absolute;
  right: 12px;
  top: 10px;
  color: #8d97ad;
  font-size: 25px;
  background: #ffffff;
  width: 20px;
  height: 20px;
  text-align: center;
  display: block;
  border-radius: 100%;
  line-height: 19px;
}
.custom-modal .modal-body {
  overflow: hidden;
}
.custom-modal .modal-bg-img {
  background-size: cover;
  background-position: center center;
  min-height: 300px;
}

.modal1 .modal-bg {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center top;
  padding: 40px;
}
.modal1 .input-group {
  margin-top: -45px;
}

.modal2 .modal-bg {
  padding: 30px 30px 30px 15px;
}

.modal3 .modal-bg {
  padding: 50px 40px 60px 25px;
}

.modal4 .modal-bg {
  padding: 55px 55px 55px 40px;
}

/*******************
Overlay headers and thrid dropdown
******************/
.header-overlay {
  position: absolute;
  width: 100%;
}

/*******************
common-innerpage-banner
*******************/
.banner-innerpage {
  padding: 150px 0 100px;
  background-size: cover;
  background-position: center center;
}
.banner-innerpage .title {
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 40px;
  line-height: 40px;
}
.banner-innerpage .subtitle {
  color: #ffffff;
}

@media (max-width: 900px) {
  .static-slider10 .title {
    font-size: 40px;
    line-height: 45px;
  }
}
.with-noborder .media {
  border: 0px;
  padding: 0px;
  margin: 50px 0;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #631117;
}

/*******************
Footer 4
*******************/
.footer4 .f4-bottom-bar {
  padding-top: 10px;
  margin-top: 20px;
}
.footer4 .f4-bottom-bar a {
  color: #8d97ad;
}
.footer4 .f4-bottom-bar a:hover {
  color: #188ef4;
}
.footer4 .round-social.light a {
  width: 34px;
  height: 34px;
  line-height: 34px;
}
.footer4 .round-social.light a:hover {
  background: #188ef4;
}

/*******************
Modal in center
*******************/
.modal-dialog {
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
}
@media (max-width: 768px) {
  .modal-dialog {
    min-height: calc(100vh - 20px);
  }
}

.animated {
  animation-duration: 0.5s;
}

/*
Template Name: Admin Press Admin
Author: Themedesigner
Email: niravjoshi87@gmail.com
File: scss
*/
/*============================================================== 
 For Laptop & above all (1650px) 
 ============================================================== */
/*============================================================== 
 For Laptop & above all (1370px) 
 ============================================================== */
/*-- ============================================================== 
 Small Desktop & above all (1024px) 
 ============================================================== */
@media (min-width: 1024px) {
  .contact4 .contact-box {
    padding: 80px 105px 80px 0px;
  }
  .hover-dropdown .navbar-nav > .dropdown:hover > .dropdown-menu {
    display: block;
    margin-top: 0px;
  }
  .navbar-nav > .dropdown .dropdown-menu {
    min-width: 210px;
    margin-top: 0px;
  }
  .dropdown-submenu:hover > .dropdown-menu {
    display: block;
  }
}
@media (max-width: 1023px) {
  .d-flex {
    display: block !important;
  }
  .d-flex.no-block {
    display: flex !important;
  }
  .wrap-feature30-box {
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 50%;
  }
  .wrap-feature31-box .right-image,
  .contact4 .right-image,
  .form6 .right-image {
    position: relative;
    bottom: -95px;
  }
  .wrap-feature31-box .right-image img,
  .contact4 .right-image img,
  .form6 .right-image img {
    width: 100%;
  }
  .contact1 .detail-box {
    margin-top: 40px;
  }
  .contact1 .p-r-40 {
    padding-right: 0;
  }
  .contact4 .contact-box {
    padding: 40px 0px 40px 0px;
  }
  .contact3 .c-detail {
    text-align: center;
  }
  .contact3 .c-detail .m-r-20 {
    margin-right: 0;
  }
  .contact3 .c-detail h6 {
    margin-top: 20px;
  }
  .contact3 .m-l-30 {
    margin-left: 0;
  }
  .contact3 .contact-box {
    margin-top: 30px;
  }
  .wrap-feature34-box .left-image {
    position: relative;
    top: -90px;
  }
  .po-absolute {
    position: relative;
  }
  .contact2 .bg-image {
    margin-right: 15px;
    margin-left: 15px;
  }
  .topbar {
    background: #631117;
    position: relative;
  }
  .topbar.animated {
    animation-duration: 0s;
  }
  .topbar.animated.slideInDown {
    animation-name: none;
  }
}
/*-- ============================================================== 
 Ipad & above all(768px) 
 ============================================================== */
/*-- ============================================================== 
 Phone and below ipad(767px) 
 ============================================================== */
@media (max-width: 767px) {
  /*This is for the Global*/
  .b-l, .b-r {
    border-left: 0px;
    border-right: 0px;
    border-bottom: 1px solid rgba(120, 130, 140, 0.13);
  }
  .img-inline li.half-width {
    width: 100%;
  }
  .both-space {
    margin: 10px 0;
  }
  .side-content {
    padding: 40px 20px;
  }
  .general-listing.two-part li {
    width: 100%;
    display: block;
  }
  /*This is for the feature 12*/
  .wrap-feature-12 .uneven-box {
    margin-top: 0px;
  }
  /*This is for the feature 16*/
  .wrap-feature-16 .with-text {
    margin-left: 0px;
  }
  /*This is for the feature 18*/
  .wrap-feature-18 .icon-position .icon-round {
    top: 157px;
    right: 30px;
  }
  /*This is for the feature 22*/
  .wrap-feature-22 .text-box, .wrap-feature23-box .text-box {
    padding: 20px 0px;
  }
  .wrap-feature30-box {
    position: relative;
  }
  .contact3 .p-l-0 {
    padding-left: 20px;
  }
  .contact4 .contact-box {
    padding-left: 15px;
    padding-right: 15px;
  }
  .modal2 .modal-bg {
    padding: 30px;
  }
  .modal3 .modal-bg {
    padding: 50px 40px 60px;
  }
  .modal4 .modal-bg {
    padding: 40px;
  }
  .dropdown-submenu > .dropdown-menu.show {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/variable.scss","webpack://./src/assets/scss/bootstrap/bootstrap.scss","webpack://./src/assets/scss/bootstrap/_root.scss","webpack://./src/assets/scss/bootstrap/_reboot.scss","webpack://./src/assets/scss/bootstrap/_variables.scss","webpack://./src/assets/scss/bootstrap/mixins/_hover.scss","webpack://./src/assets/scss/bootstrap/_type.scss","webpack://./src/assets/scss/bootstrap/mixins/_lists.scss","webpack://./src/assets/scss/bootstrap/_images.scss","webpack://./src/assets/scss/bootstrap/mixins/_image.scss","webpack://./src/assets/scss/bootstrap/mixins/_border-radius.scss","webpack://./src/assets/scss/bootstrap/_code.scss","webpack://./src/assets/scss/bootstrap/_grid.scss","webpack://./src/assets/scss/bootstrap/mixins/_grid.scss","webpack://./src/assets/scss/bootstrap/mixins/_breakpoints.scss","webpack://./src/assets/scss/bootstrap/mixins/_grid-framework.scss","webpack://./src/assets/scss/bootstrap/_tables.scss","webpack://./src/assets/scss/bootstrap/mixins/_table-row.scss","webpack://./src/assets/scss/bootstrap/_forms.scss","webpack://./src/assets/scss/bootstrap/mixins/_transition.scss","webpack://./src/assets/scss/bootstrap/mixins/_forms.scss","webpack://./src/assets/scss/bootstrap/mixins/_gradients.scss","webpack://./src/assets/scss/bootstrap/_buttons.scss","webpack://./src/assets/scss/bootstrap/mixins/_buttons.scss","webpack://./src/assets/scss/bootstrap/_transitions.scss","webpack://./src/assets/scss/bootstrap/_dropdown.scss","webpack://./src/assets/scss/bootstrap/mixins/_caret.scss","webpack://./src/assets/scss/bootstrap/mixins/_nav-divider.scss","webpack://./src/assets/scss/bootstrap/_button-group.scss","webpack://./src/assets/scss/bootstrap/_input-group.scss","webpack://./src/assets/scss/bootstrap/_custom-forms.scss","webpack://./src/assets/scss/bootstrap/_nav.scss","webpack://./src/assets/scss/bootstrap/_navbar.scss","webpack://./src/assets/scss/bootstrap/_card.scss","webpack://./src/assets/scss/bootstrap/_breadcrumb.scss","webpack://./src/assets/scss/bootstrap/_pagination.scss","webpack://./src/assets/scss/bootstrap/mixins/_pagination.scss","webpack://./src/assets/scss/bootstrap/_badge.scss","webpack://./src/assets/scss/bootstrap/mixins/_badge.scss","webpack://./src/assets/scss/bootstrap/_jumbotron.scss","webpack://./src/assets/scss/bootstrap/_alert.scss","webpack://./src/assets/scss/bootstrap/mixins/_alert.scss","webpack://./src/assets/scss/bootstrap/_progress.scss","webpack://./src/assets/scss/bootstrap/_media.scss","webpack://./src/assets/scss/bootstrap/_list-group.scss","webpack://./src/assets/scss/bootstrap/mixins/_list-group.scss","webpack://./src/assets/scss/bootstrap/_close.scss","webpack://./src/assets/scss/bootstrap/_modal.scss","webpack://./src/assets/scss/bootstrap/_tooltip.scss","webpack://./src/assets/scss/bootstrap/mixins/_reset-text.scss","webpack://./src/assets/scss/bootstrap/_popover.scss","webpack://./src/assets/scss/bootstrap/_carousel.scss","webpack://./src/assets/scss/bootstrap/utilities/_align.scss","webpack://./src/assets/scss/bootstrap/mixins/_background-variant.scss","webpack://./src/assets/scss/bootstrap/utilities/_background.scss","webpack://./src/assets/scss/bootstrap/utilities/_borders.scss","webpack://./src/assets/scss/bootstrap/mixins/_clearfix.scss","webpack://./src/assets/scss/bootstrap/utilities/_display.scss","webpack://./src/assets/scss/bootstrap/utilities/_embed.scss","webpack://./src/assets/scss/bootstrap/utilities/_flex.scss","webpack://./src/assets/scss/bootstrap/utilities/_float.scss","webpack://./src/assets/scss/bootstrap/mixins/_float.scss","webpack://./src/assets/scss/bootstrap/utilities/_position.scss","webpack://./src/assets/scss/bootstrap/utilities/_screenreaders.scss","webpack://./src/assets/scss/bootstrap/mixins/_screen-reader.scss","webpack://./src/assets/scss/bootstrap/utilities/_shadows.scss","webpack://./src/assets/scss/bootstrap/utilities/_sizing.scss","webpack://./src/assets/scss/bootstrap/utilities/_spacing.scss","webpack://./src/assets/scss/bootstrap/utilities/_text.scss","webpack://./src/assets/scss/bootstrap/mixins/_text-truncate.scss","webpack://./src/assets/scss/bootstrap/mixins/_text-emphasis.scss","webpack://./src/assets/scss/bootstrap/mixins/_text-hide.scss","webpack://./src/assets/scss/bootstrap/utilities/_visibility.scss","webpack://./src/assets/scss/bootstrap/mixins/_visibility.scss","webpack://./src/assets/scss/bootstrap/_print.scss","webpack://./src/assets/scss/ui/ui.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/common.scss","webpack://./src/assets/scss/responsive.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;CAAA;AAOA;;;;;;;;;;;EAAA;ACPA;;;;;CAAA;AAcA,eAAA;AAQA,kBAAA;AAeA,eAAA;AAoBA,eAAA;AAQA,iBAAA;AAOA,WAAA;ACxEA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kMAAA;EACA,6GAAA;AHqDF;;AIlDA;;;EAGE,sBAAA;AJqDF;;AIlDA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6BAAA;EACA,6CAAA;AJqDF;AIzCA;EACE,cAAA;AJ+CF;;AIpCA;EACE,SAAA;EACA,qLCgM4B;ED/L5B,eCoM4B;EDnM5B,gBCwM4B;EDvM5B,gBC2M4B;ED1M5B,cC3CS;ED4CT,gBAAA;EACA,yBHNM;AD6CR;;AI/BA;EACE,qBAAA;AJkCF;;AIzBA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AJ4BF;;AIfA;EACE,aAAA;EACA,qBC6K4B;AL3J9B;;AIVA;EACE,aAAA;EACA,mBCkE0B;ALrD5B;;AIHA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;AJMF;;AIHA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJMF;;AIHA;;;EAGE,aAAA;EACA,mBAAA;AJMF;;AIHA;;;;EAIE,gBAAA;AJMF;;AIHA;EACE,gBCgH4B;AL1G9B;;AIHA;EACE,qBAAA;EACA,cAAA;AJMF;;AIHA;EACE,gBAAA;AJMF;;AIHA;EACE,kBAAA;AJMF;;AIFA;;EAEE,mBAAA;AJKF;;AIDA;EACE,cAAA;AJIF;;AIIA;;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;AJDF;;AIIA;EAAM,eAAA;AJAN;;AICA;EAAM,WAAA;AJGN;;AIIA;EACE,cC/B0B;EDgC1B,qBC/B0B;EDgC1B,6BAAA;EACA,qCAAA;AJDF;AM5LE;EFgME,oDCnCwB;EDoCxB,0BCnCwB;ALkC5B;;AIWA;EACE,cAAA;EACA,qBAAA;AJRF;AMjME;EF4ME,cAAA;EACA,qBAAA;AJRJ;AIWE;EACE,UAAA;AJTJ;;AIkBA;;;;EAIE,iGCa4B;EDZ5B,cAAA;AJfF;;AIkBA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AJpBF;;AI4BA;EAEE,gBAAA;AJ1BF;;AIkCA;EACE,sBAAA;EACA,kBAAA;AJ/BF;;AIkCA;EAGE,gBAAA;EACA,sBAAA;AJjCF;;AIyCA;EACE,yBAAA;AJtCF;;AIyCA;EACE,oBC+B4B;ED9B5B,uBC8B4B;ED7B5B,cCrRS;EDsRT,gBAAA;EACA,oBAAA;AJtCF;;AIyCA;EAGE,mBAAA;AJxCF;;AIgDA;EAEE,qBAAA;EACA,qBCgGsC;AL9IxC;;AIoDA;EACE,gBAAA;AJjDF;;AIwDA;EACE,mBAAA;EACA,0CAAA;AJrDF;;AIwDA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AJrDF;;AIwDA;;EAEE,iBAAA;AJrDF;;AIwDA;;EAEE,oBAAA;AJrDF;;AI2DA;;;;EAIE,0BAAA;AJxDF;;AI4DA;;;;EAIE,UAAA;EACA,kBAAA;AJzDF;;AI4DA;;EAEE,sBAAA;EACA,UAAA;AJzDF;;AI6DA;;;;EASE,2BAAA;AJ/DF;;AIkEA;EACE,cAAA;EAEA,gBAAA;AJhEF;;AImEA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AJtEF;;AI2EA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AJxEF;;AI2EA;EACE,wBAAA;AJxEF;;AI4EA;;EAEE,YAAA;AJzEF;;AI4EA;EAKE,oBAAA;EACA,wBAAA;AJ7EF;;AIoFA;;EAEE,wBAAA;AJjFF;;AIyFA;EACE,aAAA;EACA,0BAAA;AJtFF;;AI6FA;EACE,qBAAA;AJ1FF;;AI6FA;EACE,kBAAA;EACA,eAAA;AJ1FF;;AI6FA;EACE,aAAA;AJ1FF;;AI+FA;EACE,wBAAA;AJ5FF;;AO/XA;;EAEE,qBFyQ4B;EExQ5B,oBFyQ4B;EExQ5B,gBFyQ4B;EExQ5B,gBFyQ4B;EExQ5B,cFyQ4B;ALyH9B;;AO/XA;EAAU,iBF2PoB;ALwI9B;;AOlYA;EAAU,eF2PoB;AL2I9B;;AOrYA;EAAU,kBF2PoB;AL8I9B;;AOxYA;EAAU,iBF2PoB;ALiJ9B;;AO3YA;EAAU,kBF2PoB;ALoJ9B;;AO9YA;EAAU,eF2OoB;ALuK9B;;AOhZA;EACE,kBF4Q4B;EE3Q5B,gBF4Q4B;ALuI9B;;AO/YA;EACE,eF0P4B;EEzP5B,gBF+P4B;EE9P5B,gBFqP4B;AL6J9B;;AOhZA;EACE,iBFsP4B;EErP5B,gBF2P4B;EE1P5B,gBFgP4B;ALmK9B;;AOjZA;EACE,iBFkP4B;EEjP5B,gBFuP4B;EEtP5B,gBF2O4B;ALyK9B;;AOlZA;EACE,iBF8O4B;EE7O5B,gBFmP4B;EElP5B,gBFsO4B;AL+K9B;;AO7YA;EACE,gBFwEO;EEvEP,mBFuEO;EEtEP,SAAA;EACA,wCAAA;APgZF;;AOxYA;;EAEE,cFkO4B;EEjO5B,gBF+L4B;AL4M9B;;AOxYA;;EAEE,cFsO4B;EErO5B,yBF8O4B;AL6J9B;;AOnYA;EC/EE,eAAA;EACA,gBAAA;ARsdF;;AOnYA;ECpFE,eAAA;EACA,gBAAA;AR2dF;;AOrYA;EACE,qBAAA;APwYF;AOtYE;EACE,oBFwN0B;ALgL9B;;AO9XA;EACE,cAAA;EACA,yBAAA;APiYF;;AO7XA;EACE,mBFeO;EEdP,kBF0L4B;ALsM9B;;AO7XA;EACE,cAAA;EACA,cAAA;EACA,cFvGS;ALueX;AO9XE;EACE,aAAA;APgYJ;;ASnfA;ECIE,eAAA;EAGA,YAAA;AVifF;;ASlfA;EACE,gBJ81BkC;EI71BlC,yBR2CM;EQ1CN,yBAAA;EEZE,sBN+N0B;EKxN5B,eAAA;EAGA,YAAA;AV0fF;;AS5eA;EAEE,qBAAA;AT8eF;;AS3eA;EACE,qBAAA;EACA,cAAA;AT8eF;;AS3eA;EACE,cJ+0BkC;EI90BlC,cJxBS;ALsgBX;;AYrhBA;EACE,gBPu6BkC;EOt6BlC,cPwCQ;EOvCR,sBAAA;AZwhBF;AYrhBE;EACE,cAAA;AZuhBJ;;AYlhBA;EACE,sBAAA;EACA,gBP05BkC;EOz5BlC,cX0CM;EWzCN,yBPES;EMfP,qBNiO0B;ALkU9B;AYlhBE;EACE,UAAA;EACA,eAAA;EACA,gBP6O0B;ALuS9B;;AY9gBA;EACE,cAAA;EACA,gBPy4BkC;EOx4BlC,cPdS;AL+hBX;AY9gBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AZghBJ;;AY3gBA;EACE,iBPs4BkC;EOr4BlC,kBAAA;AZ8gBF;;AavjBE;ECAA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Ad2jBF;AexgBI;EFvDF;ICYI,gBTuLiB;ELgYrB;AACF;Ae7gBI;EFvDF;ICYI,gBTuLiB;ELqYrB;AACF;AelhBI;EFvDF;ICYI,gBTuLiB;EL0YrB;AACF;AevhBI;EFvDF;ICYI,iBTuLiB;EL+YrB;AACF;;AavkBE;ECZA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdulBF;;AarkBE;ECJA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;Ad6kBF;;AatkBE;EACE,eAAA;EACA,cAAA;AbykBJ;AavkBI;;EAEE,gBAAA;EACA,eAAA;AbykBN;;AgB1mBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhBknBJ;;AgB/lBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AhBkmBR;;AgBhmBM;EACE,cAAA;EACA,WAAA;EACA,eAAA;AhBmmBR;;AgB/lBQ;EFFN,uBAAA;EAIA,wBAAA;AdkmBF;;AgBpmBQ;EFFN,wBAAA;EAIA,yBAAA;AdumBF;;AgBzmBQ;EFFN,aAAA;EAIA,cAAA;Ad4mBF;;AgB9mBQ;EFFN,wBAAA;EAIA,yBAAA;AdinBF;;AgBnnBQ;EFFN,wBAAA;EAIA,yBAAA;AdsnBF;;AgBxnBQ;EFFN,aAAA;EAIA,cAAA;Ad2nBF;;AgB7nBQ;EFFN,wBAAA;EAIA,yBAAA;AdgoBF;;AgBloBQ;EFFN,wBAAA;EAIA,yBAAA;AdqoBF;;AgBvoBQ;EFFN,aAAA;EAIA,cAAA;Ad0oBF;;AgB5oBQ;EFFN,wBAAA;EAIA,yBAAA;Ad+oBF;;AgBjpBQ;EFFN,wBAAA;EAIA,yBAAA;AdopBF;;AgBtpBQ;EFFN,cAAA;EAIA,eAAA;AdypBF;;AgBtpBM;EAAwB,SAAA;AhB0pB9B;;AgBxpBM;EAAuB,SAAA;AhB4pB7B;;AgBzpBQ;EAAwB,QADb;AhB8pBnB;;AgB7pBQ;EAAwB,QADb;AhBkqBnB;;AgBjqBQ;EAAwB,QADb;AhBsqBnB;;AgBrqBQ;EAAwB,QADb;AhB0qBnB;;AgBzqBQ;EAAwB,QADb;AhB8qBnB;;AgB7qBQ;EAAwB,QADb;AhBkrBnB;;AgBjrBQ;EAAwB,QADb;AhBsrBnB;;AgBrrBQ;EAAwB,QADb;AhB0rBnB;;AgBzrBQ;EAAwB,QADb;AhB8rBnB;;AgB7rBQ;EAAwB,QADb;AhBksBnB;;AgBjsBQ;EAAwB,SADb;AhBssBnB;;AgBrsBQ;EAAwB,SADb;AhB0sBnB;;AgBzsBQ;EAAwB,SADb;AhB8sBnB;;AgBvsBU;EFTR,0BAAA;AdotBF;;AgB3sBU;EFTR,2BAAA;AdwtBF;;AgB/sBU;EFTR,gBAAA;Ad4tBF;;AgBntBU;EFTR,2BAAA;AdguBF;;AgBvtBU;EFTR,2BAAA;AdouBF;;AgB3tBU;EFTR,gBAAA;AdwuBF;;AgB/tBU;EFTR,2BAAA;Ad4uBF;;AgBnuBU;EFTR,2BAAA;AdgvBF;;AgBvuBU;EFTR,gBAAA;AdovBF;;AgB3uBU;EFTR,2BAAA;AdwvBF;;AgB/uBU;EFTR,2BAAA;Ad4vBF;;AelvBI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBmxBN;EgBjxBI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhBmxBN;EgB/wBM;IFFN,uBAAA;IAIA,wBAAA;EdixBA;EgBnxBM;IFFN,wBAAA;IAIA,yBAAA;EdqxBA;EgBvxBM;IFFN,aAAA;IAIA,cAAA;EdyxBA;EgB3xBM;IFFN,wBAAA;IAIA,yBAAA;Ed6xBA;EgB/xBM;IFFN,wBAAA;IAIA,yBAAA;EdiyBA;EgBnyBM;IFFN,aAAA;IAIA,cAAA;EdqyBA;EgBvyBM;IFFN,wBAAA;IAIA,yBAAA;EdyyBA;EgB3yBM;IFFN,wBAAA;IAIA,yBAAA;Ed6yBA;EgB/yBM;IFFN,aAAA;IAIA,cAAA;EdizBA;EgBnzBM;IFFN,wBAAA;IAIA,yBAAA;EdqzBA;EgBvzBM;IFFN,wBAAA;IAIA,yBAAA;EdyzBA;EgB3zBM;IFFN,cAAA;IAIA,eAAA;Ed6zBA;EgB1zBI;IAAwB,SAAA;EhB6zB5B;EgB3zBI;IAAuB,SAAA;EhB8zB3B;EgB3zBM;IAAwB,QADb;EhB+zBjB;EgB9zBM;IAAwB,QADb;EhBk0BjB;EgBj0BM;IAAwB,QADb;EhBq0BjB;EgBp0BM;IAAwB,QADb;EhBw0BjB;EgBv0BM;IAAwB,QADb;EhB20BjB;EgB10BM;IAAwB,QADb;EhB80BjB;EgB70BM;IAAwB,QADb;EhBi1BjB;EgBh1BM;IAAwB,QADb;EhBo1BjB;EgBn1BM;IAAwB,QADb;EhBu1BjB;EgBt1BM;IAAwB,QADb;EhB01BjB;EgBz1BM;IAAwB,SADb;EhB61BjB;EgB51BM;IAAwB,SADb;EhBg2BjB;EgB/1BM;IAAwB,SADb;EhBm2BjB;EgB51BQ;IFTR,cAAA;Edw2BA;EgB/1BQ;IFTR,0BAAA;Ed22BA;EgBl2BQ;IFTR,2BAAA;Ed82BA;EgBr2BQ;IFTR,gBAAA;Edi3BA;EgBx2BQ;IFTR,2BAAA;Edo3BA;EgB32BQ;IFTR,2BAAA;Edu3BA;EgB92BQ;IFTR,gBAAA;Ed03BA;EgBj3BQ;IFTR,2BAAA;Ed63BA;EgBp3BQ;IFTR,2BAAA;Edg4BA;EgBv3BQ;IFTR,gBAAA;Edm4BA;EgB13BQ;IFTR,2BAAA;Eds4BA;EgB73BQ;IFTR,2BAAA;Edy4BA;AACF;Aeh4BI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBg6BN;EgB95BI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhBg6BN;EgB55BM;IFFN,uBAAA;IAIA,wBAAA;Ed85BA;EgBh6BM;IFFN,wBAAA;IAIA,yBAAA;Edk6BA;EgBp6BM;IFFN,aAAA;IAIA,cAAA;Eds6BA;EgBx6BM;IFFN,wBAAA;IAIA,yBAAA;Ed06BA;EgB56BM;IFFN,wBAAA;IAIA,yBAAA;Ed86BA;EgBh7BM;IFFN,aAAA;IAIA,cAAA;Edk7BA;EgBp7BM;IFFN,wBAAA;IAIA,yBAAA;Eds7BA;EgBx7BM;IFFN,wBAAA;IAIA,yBAAA;Ed07BA;EgB57BM;IFFN,aAAA;IAIA,cAAA;Ed87BA;EgBh8BM;IFFN,wBAAA;IAIA,yBAAA;Edk8BA;EgBp8BM;IFFN,wBAAA;IAIA,yBAAA;Eds8BA;EgBx8BM;IFFN,cAAA;IAIA,eAAA;Ed08BA;EgBv8BI;IAAwB,SAAA;EhB08B5B;EgBx8BI;IAAuB,SAAA;EhB28B3B;EgBx8BM;IAAwB,QADb;EhB48BjB;EgB38BM;IAAwB,QADb;EhB+8BjB;EgB98BM;IAAwB,QADb;EhBk9BjB;EgBj9BM;IAAwB,QADb;EhBq9BjB;EgBp9BM;IAAwB,QADb;EhBw9BjB;EgBv9BM;IAAwB,QADb;EhB29BjB;EgB19BM;IAAwB,QADb;EhB89BjB;EgB79BM;IAAwB,QADb;EhBi+BjB;EgBh+BM;IAAwB,QADb;EhBo+BjB;EgBn+BM;IAAwB,QADb;EhBu+BjB;EgBt+BM;IAAwB,SADb;EhB0+BjB;EgBz+BM;IAAwB,SADb;EhB6+BjB;EgB5+BM;IAAwB,SADb;EhBg/BjB;EgBz+BQ;IFTR,cAAA;Edq/BA;EgB5+BQ;IFTR,0BAAA;Edw/BA;EgB/+BQ;IFTR,2BAAA;Ed2/BA;EgBl/BQ;IFTR,gBAAA;Ed8/BA;EgBr/BQ;IFTR,2BAAA;EdigCA;EgBx/BQ;IFTR,2BAAA;EdogCA;EgB3/BQ;IFTR,gBAAA;EdugCA;EgB9/BQ;IFTR,2BAAA;Ed0gCA;EgBjgCQ;IFTR,2BAAA;Ed6gCA;EgBpgCQ;IFTR,gBAAA;EdghCA;EgBvgCQ;IFTR,2BAAA;EdmhCA;EgB1gCQ;IFTR,2BAAA;EdshCA;AACF;Ae7gCI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB6iCN;EgB3iCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhB6iCN;EgBziCM;IFFN,uBAAA;IAIA,wBAAA;Ed2iCA;EgB7iCM;IFFN,wBAAA;IAIA,yBAAA;Ed+iCA;EgBjjCM;IFFN,aAAA;IAIA,cAAA;EdmjCA;EgBrjCM;IFFN,wBAAA;IAIA,yBAAA;EdujCA;EgBzjCM;IFFN,wBAAA;IAIA,yBAAA;Ed2jCA;EgB7jCM;IFFN,aAAA;IAIA,cAAA;Ed+jCA;EgBjkCM;IFFN,wBAAA;IAIA,yBAAA;EdmkCA;EgBrkCM;IFFN,wBAAA;IAIA,yBAAA;EdukCA;EgBzkCM;IFFN,aAAA;IAIA,cAAA;Ed2kCA;EgB7kCM;IFFN,wBAAA;IAIA,yBAAA;Ed+kCA;EgBjlCM;IFFN,wBAAA;IAIA,yBAAA;EdmlCA;EgBrlCM;IFFN,cAAA;IAIA,eAAA;EdulCA;EgBplCI;IAAwB,SAAA;EhBulC5B;EgBrlCI;IAAuB,SAAA;EhBwlC3B;EgBrlCM;IAAwB,QADb;EhBylCjB;EgBxlCM;IAAwB,QADb;EhB4lCjB;EgB3lCM;IAAwB,QADb;EhB+lCjB;EgB9lCM;IAAwB,QADb;EhBkmCjB;EgBjmCM;IAAwB,QADb;EhBqmCjB;EgBpmCM;IAAwB,QADb;EhBwmCjB;EgBvmCM;IAAwB,QADb;EhB2mCjB;EgB1mCM;IAAwB,QADb;EhB8mCjB;EgB7mCM;IAAwB,QADb;EhBinCjB;EgBhnCM;IAAwB,QADb;EhBonCjB;EgBnnCM;IAAwB,SADb;EhBunCjB;EgBtnCM;IAAwB,SADb;EhB0nCjB;EgBznCM;IAAwB,SADb;EhB6nCjB;EgBtnCQ;IFTR,cAAA;EdkoCA;EgBznCQ;IFTR,0BAAA;EdqoCA;EgB5nCQ;IFTR,2BAAA;EdwoCA;EgB/nCQ;IFTR,gBAAA;Ed2oCA;EgBloCQ;IFTR,2BAAA;Ed8oCA;EgBroCQ;IFTR,2BAAA;EdipCA;EgBxoCQ;IFTR,gBAAA;EdopCA;EgB3oCQ;IFTR,2BAAA;EdupCA;EgB9oCQ;IFTR,2BAAA;Ed0pCA;EgBjpCQ;IFTR,gBAAA;Ed6pCA;EgBppCQ;IFTR,2BAAA;EdgqCA;EgBvpCQ;IFTR,2BAAA;EdmqCA;AACF;Ae1pCI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB0rCN;EgBxrCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhB0rCN;EgBtrCM;IFFN,uBAAA;IAIA,wBAAA;EdwrCA;EgB1rCM;IFFN,wBAAA;IAIA,yBAAA;Ed4rCA;EgB9rCM;IFFN,aAAA;IAIA,cAAA;EdgsCA;EgBlsCM;IFFN,wBAAA;IAIA,yBAAA;EdosCA;EgBtsCM;IFFN,wBAAA;IAIA,yBAAA;EdwsCA;EgB1sCM;IFFN,aAAA;IAIA,cAAA;Ed4sCA;EgB9sCM;IFFN,wBAAA;IAIA,yBAAA;EdgtCA;EgBltCM;IFFN,wBAAA;IAIA,yBAAA;EdotCA;EgBttCM;IFFN,aAAA;IAIA,cAAA;EdwtCA;EgB1tCM;IFFN,wBAAA;IAIA,yBAAA;Ed4tCA;EgB9tCM;IFFN,wBAAA;IAIA,yBAAA;EdguCA;EgBluCM;IFFN,cAAA;IAIA,eAAA;EdouCA;EgBjuCI;IAAwB,SAAA;EhBouC5B;EgBluCI;IAAuB,SAAA;EhBquC3B;EgBluCM;IAAwB,QADb;EhBsuCjB;EgBruCM;IAAwB,QADb;EhByuCjB;EgBxuCM;IAAwB,QADb;EhB4uCjB;EgB3uCM;IAAwB,QADb;EhB+uCjB;EgB9uCM;IAAwB,QADb;EhBkvCjB;EgBjvCM;IAAwB,QADb;EhBqvCjB;EgBpvCM;IAAwB,QADb;EhBwvCjB;EgBvvCM;IAAwB,QADb;EhB2vCjB;EgB1vCM;IAAwB,QADb;EhB8vCjB;EgB7vCM;IAAwB,QADb;EhBiwCjB;EgBhwCM;IAAwB,SADb;EhBowCjB;EgBnwCM;IAAwB,SADb;EhBuwCjB;EgBtwCM;IAAwB,SADb;EhB0wCjB;EgBnwCQ;IFTR,cAAA;Ed+wCA;EgBtwCQ;IFTR,0BAAA;EdkxCA;EgBzwCQ;IFTR,2BAAA;EdqxCA;EgB5wCQ;IFTR,gBAAA;EdwxCA;EgB/wCQ;IFTR,2BAAA;Ed2xCA;EgBlxCQ;IFTR,2BAAA;Ed8xCA;EgBrxCQ;IFTR,gBAAA;EdiyCA;EgBxxCQ;IFTR,2BAAA;EdoyCA;EgB3xCQ;IFTR,2BAAA;EduyCA;EgB9xCQ;IFTR,gBAAA;Ed0yCA;EgBjyCQ;IFTR,2BAAA;Ed6yCA;EgBpyCQ;IFTR,2BAAA;EdgzCA;AACF;AiB/1CA;EACE,WAAA;EACA,mBZyHO;EYxHP,6BZ8T4B;ALmiC9B;AiB/1CE;;EAEE,gBZuT0B;EYtT1B,mBAAA;EACA,6BAAA;AjBi2CJ;AiB91CE;EACE,sBAAA;EACA,gCAAA;AjBg2CJ;AiB71CE;EACE,6BAAA;AjB+1CJ;AiB51CE;EACE,yBhBgCI;AD8zCR;;AiBp1CE;;EAEE,eZ6R0B;AL0jC9B;;AiB90CA;EACE,yBAAA;AjBi1CF;AiB/0CE;;EAEE,yBAAA;AjBi1CJ;AiB70CI;;EAEE,wBAAA;AjB+0CN;;AiBz0CE;;;;EAIE,SAAA;AjB40CJ;;AiBn0CE;EACE,qCZwP0B;AL8kC9B;;AMx4CE;EW8EI,sCZ6OwB;ALilC9B;;AkBl5CI;;;EAGE,6CD6F+B;AjBwzCrC;;AMl5CE;EYQM,qEAJe;AlBk5CvB;AkB54CQ;;EAEE,qEARa;AlBs5CvB;;AkBh6CI;;;EAGE,6CD6F+B;AjBs0CrC;;AMh6CE;EYQM,6DAJe;AlBg6CvB;AkB15CQ;;EAEE,6DARa;AlBo6CvB;;AkB96CI;;;EAGE,0CD6F+B;AjBo1CrC;;AM96CE;EYQM,qEAJe;AlB86CvB;AkBx6CQ;;EAEE,qEARa;AlBk7CvB;;AkB57CI;;;EAGE,6CD6F+B;AjBk2CrC;;AM57CE;EYQM,qEAJe;AlB47CvB;AkBt7CQ;;EAEE,qEARa;AlBg8CvB;;AkB18CI;;;EAGE,4CD6F+B;AjBg3CrC;;AM18CE;EYQM,iEAJe;AlB08CvB;AkBp8CQ;;EAEE,iEARa;AlB88CvB;;AkBx9CI;;;EAGE,0CD6F+B;AjB83CrC;;AMx9CE;EYQM,kDAJe;AlBw9CvB;AkBl9CQ;;EAEE,kDARa;AlB49CvB;;AkBt+CI;;;EAGE,4CD6F+B;AjB44CrC;;AMt+CE;EYQM,sDAJe;AlBs+CvB;AkBh+CQ;;EAEE,sDARa;AlB0+CvB;;AkBp/CI;;;EAGE,4CD6F+B;AjB05CrC;;AMp/CE;EYQM,qEAJe;AlBo/CvB;AkB9+CQ;;EAEE,qEARa;AlBw/CvB;;AkBlgDI;;;EAGE,sCb8TwB;ALusC9B;;AMlgDE;EYQM,sCAJe;AlBkgDvB;AkB5/CQ;;EAEE,sCARa;AlBsgDvB;;AiBn6CI;EACE,chB1DE;EgB2DF,yBZlGK;EYmGL,uDZ6NwB;ALysC9B;AiBj6CI;EACE,cZ3GK;EY4GL,yBZjHK;EYkHL,qBZjHK;ALohDX;;AiB95CA;EACE,chB1EM;EgB2EN,yBZlHS;ALmhDX;AiB/5CE;;;EAGE,uDZyM0B;ALwtC9B;AiB95CE;EACE,SAAA;AjBg6CJ;AiB55CI;EACE,2CZ8LwB;ALguC9B;AMriDE;EW8IM,4CZwLsB;ALkuC9B;;Ae3+CI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjB44CN;EiBz4CM;IACE,SAAA;EjB24CR;AACF;Aex/CI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjBw5CN;EiBr5CM;IACE,SAAA;EjBu5CR;AACF;AepgDI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjBo6CN;EiBj6CM;IACE,SAAA;EjBm6CR;AACF;AehhDI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjBg7CN;EiB76CM;IACE,SAAA;EjB+6CR;AACF;AiB17CI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,4CAAA;AjB27CR;AiBx7CQ;EACE,SAAA;AjB07CV;;AmBzmDA;EACE,cAAA;EACA,WAAA;EACA,2BdqbsC;EcpbtC,yBAAA;EACA,edoP4B;EcnP5B,gBd4P4B;Ec3P5B,cdIS;EcHT,yBlB4CM;EkB3CN,4BAAA;EACA,yBAAA;EAKE,sBd8M0B;Ee9NxB,wEDuBJ;AnBkmDF;AoBrnDE;EDHF;ICII,gBAAA;EpBwnDF;AACF;AmBpmDE;EACE,6BAAA;EACA,SAAA;AnBsmDJ;AqB1nDE;EACE,chBGO;EgBFP,yBpB2CI;EoB1CJ,iEhBmaoC;EgBlapC,UAAA;EAKE,iDhB8UwB;AL0yC9B;AmBtmDE;EACE,cdzBO;Ec2BP,UAAA;AnBumDJ;AmB/lDE;EAEE,yBdzCO;Ec2CP,UAAA;AnB+lDJ;;AmB1lDE;EAME,cdjDO;EckDP,yBlBTI;ADimDR;;AmBnlDA;;EAEE,cAAA;EACA,WAAA;AnBslDF;;AmB5kDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBd8K4B;ALi6C9B;;AmB5kDA;EACE,+BAAA;EACA,kCAAA;EACA,kBdgK4B;Ec/J5B,gBd4H4B;ALm9C9B;;AmB5kDA;EACE,gCAAA;EACA,mCAAA;EACA,mBd0J4B;EczJ5B,gBdsH4B;ALy9C9B;;AmBtkDA;EACE,cAAA;EACA,WAAA;EACA,qBd0O4B;EczO5B,wBdyO4B;EcxO5B,gBAAA;EACA,gBdiJ4B;EchJ5B,cdrGS;EcsGT,6BAAA;EACA,yBAAA;EACA,mBAAA;AnBykDF;AmBvkDE;EAEE,gBAAA;EACA,eAAA;AnBwkDJ;;AmB5jDA;EACE,6BdoTsC;EcnTtC,uBAAA;EACA,mBdkH4B;EcjH5B,gBd8E4B;EM1N1B,qBNiO0B;AL2+C9B;;AmB5jDA;EACE,4Bd+SsC;Ec9StC,oBAAA;EACA,kBdyG4B;EcxG5B,gBdqE4B;EMzN1B,qBNgO0B;ALo/C9B;;AmB1jDE;EAEE,YAAA;AnB4jDJ;;AmBxjDA;EACE,YAAA;AnB2jDF;;AmBljDA;EACE,mBdkSsC;ALmxCxC;;AmBljDA;EACE,cAAA;EACA,mBdoRsC;ALiyCxC;;AmB7iDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AnBgjDF;AmB9iDE;;EAEE,kBAAA;EACA,iBAAA;AnBgjDJ;;AmBviDA;EACE,kBAAA;EACA,cAAA;EACA,qBdyPsC;ALizCxC;;AmBviDA;EACE,kBAAA;EACA,kBdqPsC;EcpPtC,qBAAA;AnB0iDF;AmBxiDE;EACE,cd1MO;ALovDX;;AmBtiDA;EACE,gBAAA;AnByiDF;;AmBtiDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBdwOsC;ALi0CxC;AmBtiDE;EACE,gBAAA;EACA,aAAA;EACA,uBdmOoC;EclOpC,cAAA;AnBwiDJ;;AqBxvDE;EACE,aAAA;EACA,WAAA;EACA,mBhBwaoC;EgBvapC,chBqQ0B;EgBpQ1B,chB6hBgC;AL8tCpC;;AqBxvDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBhBoN0B;EgBnN1B,gBhB0N0B;EgBzN1B,cAAA;EACA,yCAAA;EV5CA,sBN+N0B;ALykD9B;;AqBtvDI;;;EAEE,qBhBugB8B;ALmvCpC;AqBxvDM;;;EACE,qBhBogB4B;EgBngB5B,iDAAA;ArB4vDR;AqBzvDM;;;;;;;EAEE,cAAA;ArBgwDR;;AqBxvDM;;;EAEE,cAAA;ArB4vDR;;AqBpvDM;EACE,chB2e4B;AL4wCpC;AqBpvDM;;;EAEE,cAAA;ArBuvDR;;AqB/uDM;EACE,chB6d4B;ALqxCpC;AqBhvDQ;EACE,mEAAA;ArBkvDV;AqB9uDM;;;EAEE,cAAA;ArBivDR;AqB7uDQ;ECzGJ,oED0G2B;ArB+uD/B;AqB1uDQ;EACE,oEAAA;ArB4uDV;;AqBluDM;EACE,qBhB8b4B;ALuyCpC;AqBnuDQ;EAAW,qBAAA;ArBsuDnB;AqBnuDM;;;EAEE,cAAA;ArBsuDR;AqBluDQ;EACE,iDAAA;ArBouDV;;AqBp1DE;EACE,aAAA;EACA,WAAA;EACA,mBhBwaoC;EgBvapC,chBqQ0B;EgBpQ1B,chB8hBgC;ALyzCpC;;AqBp1DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBhBoN0B;EgBnN1B,gBhB0N0B;EgBzN1B,cAAA;EACA,yCAAA;EV5CA,sBN+N0B;ALqqD9B;;AqBl1DI;;;EAEE,qBhBwgB8B;AL80CpC;AqBp1DM;;;EACE,qBhBqgB4B;EgBpgB5B,iDAAA;ArBw1DR;AqBr1DM;;;;;;;EAEE,cAAA;ArB41DR;;AqBp1DM;;;EAEE,cAAA;ArBw1DR;;AqBh1DM;EACE,chB4e4B;ALu2CpC;AqBh1DM;;;EAEE,cAAA;ArBm1DR;;AqB30DM;EACE,chB8d4B;ALg3CpC;AqB50DQ;EACE,iDAAA;ArB80DV;AqB10DM;;;EAEE,cAAA;ArB60DR;AqBz0DQ;ECzGJ,+CD0G2B;ArB20D/B;AqBt0DQ;EACE,oEAAA;ArBw0DV;;AqB9zDM;EACE,qBhB+b4B;ALk4CpC;AqB/zDQ;EAAW,qBAAA;ArBk0DnB;AqB/zDM;;;EAEE,cAAA;ArBk0DR;AqB9zDQ;EACE,iDAAA;ArBg0DV;;AmBxsDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AnB2sDF;AmBtsDE;EACE,WAAA;AnBwsDJ;Ae15DI;EIuNA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EnBssDJ;EmBlsDE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EnBosDJ;EmBhsDE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EnBksDJ;EmB9rDE;IACE,qBAAA;EnBgsDJ;EmB7rDE;;IAEE,WAAA;EnB+rDJ;EmB1rDE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EnB4rDJ;EmB1rDE;IACE,kBAAA;IACA,aAAA;IACA,qBd4IkC;Ic3IlC,cAAA;EnB4rDJ;EmBzrDE;IACE,mBAAA;IACA,uBAAA;EnB2rDJ;EmBzrDE;IACE,gBAAA;EnB2rDJ;AACF;;AuB//DA;EACE,qBAAA;EACA,gBlB4P4B;EkB3P5B,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;ECsFA,yBAAA;EACA,enB2J4B;EmB1J5B,gBnBmK4B;EmBhK1B,sBnB2H0B;Ee9NxB,qIGUJ;AvBqgEF;AoB3gEE;EGHF;IHII,gBAAA;EpB8gEF;AACF;AMzgEE;EiBGE,qBAAA;AvBygEJ;AuBtgEE;EAEE,UAAA;EACA,iDlB2U0B;AL4rD9B;AuBngEE;EAEE,alBwW0B;AL4pD9B;AuB//DE;EACE,eAAA;AvBigEJ;AuBn/DA;;EAEE,oBAAA;AvBq/DF;;AuB5+DE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;AL69Df;AMpiEE;EkBAE,cAAA;EFNA,kEED2D;EAS3D,+DATqG;AxBgjEzG;AwBpiEE;EAMI,gDAAA;AxBiiEN;AwB5hEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;AL0+Df;AwB1hEE;EAGE,cAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;AxB6jE7L;AwBrhEI;EAKI,gDAAA;AxBmhER;;AuBvgEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;ALw/Df;AM/jEE;EkBAE,cAAA;EFNA,6DED2D;EAS3D,sDATqG;AxB2kEzG;AwB/jEE;EAMI,iDAAA;AxB4jEN;AwBvjEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;ALqgEf;AwBrjEE;EAGE,cAAA;EACA,0DAlC+I;EAsC/I,uDAtCyL;AxBwlE7L;AwBhjEI;EAKI,iDAAA;AxB8iER;;AuBliEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;ALmhEf;AM1lEE;EkBAE,cAAA;EFNA,oEED2D;EAS3D,gEATqG;AxBsmEzG;AwB1lEE;EAMI,gDAAA;AxBulEN;AwBllEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;ALgiEf;AwBhlEE;EAGE,cAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;AxBmnE7L;AwB3kEI;EAKI,gDAAA;AxBykER;;AuB7jEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;AL8iEf;AMrnEE;EkBAE,cAAA;EFNA,oEED2D;EAS3D,8DATqG;AxBioEzG;AwBrnEE;EAMI,gDAAA;AxBknEN;AwB7mEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;AL2jEf;AwB3mEE;EAGE,cAAA;EACA,kEAlC+I;EAsC/I,+DAtCyL;AxB8oE7L;AwBtmEI;EAKI,gDAAA;AxBomER;;AuBxlEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;ALykEf;AMhpEE;EkBAE,cAAA;EFNA,gDED2D;EAS3D,yCATqG;AxB4pEzG;AwBhpEE;EAMI,+CAAA;AxB6oEN;AwBxoEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;ALslEf;AwBtoEE;EAGE,cAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;AxByqE7L;AwBjoEI;EAKI,+CAAA;AxB+nER;;AuBnnEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;ALomEf;AM3qEE;EkBAE,cAAA;EFNA,+CED2D;EAS3D,yCATqG;AxBurEzG;AwB3qEE;EAMI,gDAAA;AxBwqEN;AwBnqEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;ALinEf;AwBjqEE;EAGE,cAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;AxBosE7L;AwB5pEI;EAKI,gDAAA;AxB0pER;;AuB9oEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;AL+nEf;AMtsEE;EkBAE,cAAA;EFNA,yDED2D;EAS3D,+CATqG;AxBktEzG;AwBtsEE;EAMI,iDAAA;AxBmsEN;AwB9rEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;AL4oEf;AwB5rEE;EAGE,cAAA;EACA,mDAlC+I;EAsC/I,qDAtCyL;AxB+tE7L;AwBvrEI;EAKI,iDAAA;AxBqrER;;AuBzqEE;ECxDA,cAAA;EFAE,yBjB6EW;EmB3Eb,qBnB2Ea;AL0pEf;AMjuEE;EkBAE,cAAA;EFNA,kEED2D;EAS3D,8DATqG;AxB6uEzG;AwBjuEE;EAMI,8CAAA;AxB8tEN;AwBztEE;EAEE,cAAA;EACA,yBnBoDW;EmBnDX,qBnBmDW;ALuqEf;AwBvtEE;EAGE,cAAA;EACA,kEAlC+I;EAsC/I,8DAtCyL;AxB0vE7L;AwBltEI;EAKI,8CAAA;AxBgtER;;AuB9rEE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;ALsrEf;AwB3sEE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;AL2rEf;AwB1sEE;EAEE,gDAAA;AxB2sEJ;AwBxsEE;EAEE,cnBQW;EmBPX,6BAAA;AxBysEJ;AwBtsEE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;ALusEf;AwBpsEI;EAKI,gDAAA;AxBksER;;AuBztEE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;ALitEf;AwBtuEE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;ALstEf;AwBruEE;EAEE,iDAAA;AxBsuEJ;AwBnuEE;EAEE,cnBQW;EmBPX,6BAAA;AxBouEJ;AwBjuEE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;ALkuEf;AwB/tEI;EAKI,iDAAA;AxB6tER;;AuBpvEE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;AL4uEf;AwBjwEE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;ALivEf;AwBhwEE;EAEE,gDAAA;AxBiwEJ;AwB9vEE;EAEE,cnBQW;EmBPX,6BAAA;AxB+vEJ;AwB5vEE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;AL6vEf;AwB1vEI;EAKI,gDAAA;AxBwvER;;AuB/wEE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;ALuwEf;AwB5xEE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;AL4wEf;AwB3xEE;EAEE,gDAAA;AxB4xEJ;AwBzxEE;EAEE,cnBQW;EmBPX,6BAAA;AxB0xEJ;AwBvxEE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;ALwxEf;AwBrxEI;EAKI,gDAAA;AxBmxER;;AuB1yEE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;ALkyEf;AwBvzEE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;ALuyEf;AwBtzEE;EAEE,+CAAA;AxBuzEJ;AwBpzEE;EAEE,cnBQW;EmBPX,6BAAA;AxBqzEJ;AwBlzEE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;ALmzEf;AwBhzEI;EAKI,+CAAA;AxB8yER;;AuBr0EE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;AL6zEf;AwBl1EE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;ALk0Ef;AwBj1EE;EAEE,gDAAA;AxBk1EJ;AwB/0EE;EAEE,cnBQW;EmBPX,6BAAA;AxBg1EJ;AwB70EE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;AL80Ef;AwB30EI;EAKI,gDAAA;AxBy0ER;;AuBh2EE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;ALw1Ef;AwB72EE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;AL61Ef;AwB52EE;EAEE,iDAAA;AxB62EJ;AwB12EE;EAEE,cnBQW;EmBPX,6BAAA;AxB22EJ;AwBx2EE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;ALy2Ef;AwBt2EI;EAKI,iDAAA;AxBo2ER;;AuB33EE;ECXA,cnB0Ba;EmBzBb,6BAAA;EACA,sBAAA;EACA,qBnBuBa;ALm3Ef;AwBx4EE;EACE,cAPgD;EAQhD,yBnBmBW;EmBlBX,qBnBkBW;ALw3Ef;AwBv4EE;EAEE,8CAAA;AxBw4EJ;AwBr4EE;EAEE,cnBQW;EmBPX,6BAAA;AxBs4EJ;AwBn4EE;EAGE,cAAA;EACA,yBAAA;EACA,qBnBDW;ALo4Ef;AwBj4EI;EAKI,8CAAA;AxB+3ER;;AuB34EA;EACE,gBlBoL4B;EkBnL5B,clBsF0B;EkBrF1B,6BAAA;AvB84EF;AMp9EE;EiByEE,oDlBoFwB;EkBnFxB,0BlBoFwB;EkBnFxB,6BAAA;EACA,yBAAA;AvB84EJ;AuB34EE;EAEE,0BlB6EwB;EkB5ExB,yBAAA;EACA,gBAAA;AvB44EJ;AuBz4EE;EAEE,clBpFO;EkBqFP,oBAAA;AvB04EJ;;AuB/3EA;ECbE,oBAAA;EACA,kBnB4J4B;EmB3J5B,gBnBwH4B;EmBrH1B,qBnB4H0B;ALkxE9B;;AuBl4EA;ECjBE,uBAAA;EACA,mBnB6J4B;EmB5J5B,gBnByH4B;EmBtH1B,qBnB6H0B;ALwxE9B;;AuBh4EA;EACE,cAAA;EACA,WAAA;AvBm4EF;AuBh4EE;EACE,kBlByQ0B;ALynE9B;;AuB13EE;;;EACE,WAAA;AvB+3EJ;;AyBzgFA;ELGM,gCKFJ;AzB4gFF;AoBtgFE;EKPF;ILQI,gBAAA;EpBygFF;AACF;AyB/gFE;EACE,UAAA;AzBihFJ;;AyB5gFE;EACE,aAAA;AzB+gFJ;;AyB3gFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELdI,6BKeJ;AzB8gFF;AoBzhFE;EKOF;ILNI,gBAAA;EpB4hFF;AACF;;A0BtiFA;;;;EAIE,kBAAA;A1ByiFF;;A2BjhFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EAlCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A3BujFF;A2B9/EI;EACE,cAAA;A3BggFN;;A0BhjFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,arBmlBkC;EqBllBlC,aAAA;EACA,WAAA;EACA,gBrBkjBkC;EqBjjBlC,iBAAA;EACA,oBAAA;EACA,erBuO4B;EqBtO5B,crBNS;EqBOT,gBAAA;EACA,gBAAA;EACA,yBzB8BM;EyB7BN,4BAAA;EACA,qCAAA;Ef1BE,sBN+N0B;AL+2E9B;;A0B/iFA;EACE,QAAA;EACA,UAAA;A1BkjFF;;A0B5iFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBrB0hBgC;ALqhEpC;A2BjkFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EA3BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A3B+lFF;A2B7iFI;EACE,cAAA;A3B+iFN;;A0BrjFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBrB4gBgC;AL4iEpC;A2BxlFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EApBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A3B+mFF;A2BpkFI;EACE,cAAA;A3BskFN;A0BlkFI;EACE,iBAAA;A1BokFN;;A0B9jFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBrB2fgC;ALskEpC;A2BlnFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;A3BonFN;A2BzmFM;EACE,aAAA;A3B2mFR;A2BxmFM;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EAlCN,mCAAA;EACA,yBAAA;EACA,sCAAA;A3B6oFF;A2BxmFI;EACE,cAAA;A3B0mFN;A0BrlFI;EACE,iBAAA;A1BulFN;;A0B/kFE;EAIE,WAAA;EACA,YAAA;A1B+kFJ;;A0BzkFA;EElGE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A5B+qFF;;A0BzkFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBrBiJ4B;EqBhJ5B,crBjGS;EqBkGT,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;A1B4kFF;AMprFE;EoB2GE,+CrBudgC;EqBtdhC,qBAAA;EJtHA,yBjBKO;AL8rFX;A0BzkFE;EAEE,czBxEI;EyByEJ,qBAAA;EJ7HA,yBjBsO0B;ALk+E9B;A0BvkFE;EAEE,crBzHO;EqB0HP,6BAAA;A1BwkFJ;;A0BhkFA;EACE,cAAA;A1BmkFF;;A0B/jFA;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBrBsG4B;EqBrG5B,crB5IS;EqB6IT,mBAAA;A1BkkFF;;A0B9jFA;EACE,cAAA;EACA,uBAAA;EACA,crBjJS;ALktFX;;A6BluFA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A7BquFF;A6BnuFE;;EACE,kBAAA;EACA,cAAA;A7BsuFJ;AMruFE;;EuBII,UAAA;A7BquFN;A6BnuFI;;;;EAGE,UAAA;A7BsuFN;A6BjuFE;;;;;;;;EAIE,iBAAA;A7BuuFJ;;A6BluFA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A7BquFF;A6BnuFE;EACE,WAAA;A7BquFJ;;A6BhuFE;EACE,cAAA;A7BmuFJ;A6B/tFE;;ElBlCE,0BkBoC6B;ElBnC7B,6BkBmC6B;A7BkuFjC;A6B/tFE;;ElBzBE,yBkB2B4B;ElB1B5B,4BkB0B4B;A7BkuFhC;;A6BltFA;EACE,wBAAA;EACA,uBAAA;A7BqtFF;A6BntFE;EAGE,cAAA;A7BmtFJ;A6BhtFE;EACE,eAAA;A7BktFJ;;A6B9sFA;EACE,uBAAA;EACA,sBAAA;A7BitFF;;A6B9sFA;EACE,sBAAA;EACA,qBAAA;A7BitFF;;A6B7rFA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A7BgsFF;A6B9rFE;;EAEE,WAAA;A7BgsFJ;A6B7rFE;;;;EAIE,gBAAA;EACA,cAAA;A7B+rFJ;A6B3rFE;;ElB/GE,6BkBiH8B;ElBhH9B,4BkBgH8B;A7B8rFlC;A6B3rFE;;ElBlIE,yBkBoI2B;ElBnI3B,0BkBmI2B;A7B8rF/B;;A6B5qFE;;EAEE,gBAAA;A7B+qFJ;A6B7qFI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A7BirFN;;A8Bn1FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9Bs1FF;A8Bp1FE;;;EAGE,kBAAA;EACA,cAAA;EAGA,SAAA;EACA,gBAAA;A9Bo1FJ;A8Bl1FI;;;;;;;;;EAGE,iBAAA;A9B01FN;A8Br1FE;;;EAGE,UAAA;A9Bu1FJ;A8Bn1FE;EACE,UAAA;A9Bq1FJ;A8Bh1FI;;EnB3BA,0BmB2BkD;EnB1BlD,6BmB0BkD;A9Bq1FtD;A8Bp1FI;;EnBdA,yBmBckD;EnBblD,4BmBakD;A9By1FtD;A8Bp1FE;EACE,aAAA;EACA,mBAAA;A9Bs1FJ;A8Bp1FI;EnBrCA,0BmBsC4E;EnBrC5E,6BmBqC4E;A9Bu1FhF;A8Bt1FI;EnBzBA,yBmByBqE;EnBxBrE,4BmBwBqE;A9B01FzE;;A8B/0FA;;EAEE,aAAA;A9Bk1FF;A8B70FE;;EACE,kBAAA;EACA,UAAA;A9Bg1FJ;A8B70FE;;;;;;;;EAIE,iBAAA;A9Bm1FJ;;A8B/0FA;EAAuB,kBAAA;A9Bm1FvB;;A8Bl1FA;EAAsB,iBAAA;A9Bs1FtB;;A8B90FA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,ezB0J4B;EyBzJ5B,gBzB8J4B;EyB7J5B,gBzBiK4B;EyBhK5B,czBvFS;EyBwFT,kBAAA;EACA,mBAAA;EACA,yBzB/FS;EyBgGT,yBAAA;EnBxGE,sBN+N0B;AL2tF9B;A8B90FE;;EAEE,aAAA;A9Bg1FJ;;A8Bt0FA;;;;;EAKE,4BzBmUsC;EyBlUtC,oBAAA;EACA,kBzB6H4B;EyB5H5B,gBzByF4B;EMzN1B,qBNgO0B;AL0uF9B;;A8Bt0FA;;;;;EAKE,6BzBoTsC;EyBnTtC,uBAAA;EACA,mBzBkH4B;EyBjH5B,gBzB8E4B;EM1N1B,qBNiO0B;ALqvF9B;;A8B9zFA;;;;;;EnB3II,0BmBiJ2B;EnBhJ3B,6BmBgJ2B;A9Bk0F/B;;A8B/zFA;;;;;;EnBtII,yBmB4I0B;EnB3I1B,4BmB2I0B;A9Bm0F9B;;A+Br+FA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oB1B4csC;AL4hFxC;;A+Br+FA;EACE,oBAAA;EACA,kB1BwcsC;ALgiFxC;;A+Br+FA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;A/Bw+FF;A+Bt+FE;EACE,c9B+BI;EqBpDJ,yBjBsO0B;ALwxF9B;A+Bp+FE;EAEE,oE1Buc4C;AL8hFhD;A+Bl+FE;EACE,c9BoBI;E8BnBJ,qE1Bqc4C;AL+hFhD;A+B/9FI;EACE,c1B7BK;AL8/FX;A+B/9FM;EACE,yB1BpCG;ALqgGX;;A+Bv9FA;EACE,kBAAA;EACA,gBAAA;A/B09FF;A+Bv9FE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W1BwZoC;E0BvZpC,Y1BuZoC;E0BtZpC,oBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yB1B5DO;ALqhGX;A+Bp9FE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W1ByYoC;E0BxYpC,Y1BwYoC;E0BvYpC,WAAA;EACA,4BAAA;EACA,kCAAA;EACA,wB1BsYoC;ALglFxC;;A+B58FE;EpB9FE,sBN+N0B;AL+0F9B;A+B38FI;ETjGA,yBjBsO0B;ALy0F9B;A+B38FI;EACE,yD1BqY0C;ALwkFhD;A+Bx8FI;ET1GA,yBjBsO0B;AL+0F9B;A+Bv8FI;EACE,yD1B+XgD;AL0kFtD;A+Bp8FI;EACE,yC1B2W0C;AL2lFhD;A+Bp8FI;EACE,yC1BwW0C;AL8lFhD;;A+B57FE;EACE,kB1B8W4C;ALilFhD;A+B37FI;ETvIA,yBjBsO0B;AL+1F9B;A+B37FI;EACE,yD1BuW0C;ALslFhD;A+Bx7FI;EACE,yC1B+U0C;AL2mFhD;;A+B96FA;EACE,qBAAA;EACA,WAAA;EACA,2B1BwRsC;E0BvRtC,0CAAA;EACA,gB1BgG4B;E0B/F5B,c1BxJS;E0ByJT,sBAAA;EACA,0FAAA;EACA,yB1BuVkC;E0BtVlC,yBAAA;EAEE,sB1BoD0B;E0B/C5B,gBAAA;A/B46FF;A+B16FE;EACE,iE1B4PoC;E0B3PpC,UAAA;EAIE,kF1BiV8B;ALwlFpC;A+Bt6FI;EAME,c1BpLK;E0BqLL,yB9B5IE;AD+iGR;A+B/5FE;EAEE,YAAA;EACA,sB1B8SgC;E0B7ShC,sBAAA;A/Bg6FJ;A+B75FE;EACE,c1BlMO;E0BmMP,yB1BvMO;ALsmGX;A+B35FE;EACE,UAAA;A/B65FJ;;A+Bz5FA;EACE,6B1BoOsC;E0BnOtC,qB1B4RkC;E0B3RlC,wB1B2RkC;E0B1RlC,c1B+SkC;AL6mFpC;;A+Bz5FA;EACE,4B1BgOsC;E0B/NtC,qB1BqRkC;E0BpRlC,wB1BoRkC;E0BnRlC,e1B2SkC;ALinFpC;;A+Bp5FA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,2B1B2MsC;E0B1MtC,gBAAA;A/Bu5FF;;A+Bp5FA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2B1BmMsC;E0BlMtC,SAAA;EACA,UAAA;A/Bu5FF;A+Br5FE;EACE,iE1BmLoC;E0BlLpC,iD1BmG0B;ALozF9B;A+Br5FI;EACE,iE1B+KkC;ALwuFxC;A+Bn5FE;EACE,yB1B7PO;ALkpGX;A+Bj5FI;EACE,iB1BySa;AL0mFnB;;A+B94FA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,2B1BqKsC;E0BpKtC,yBAAA;EACA,gB1BnB4B;E0BoB5B,c1B3QS;E0B4QT,yB9BnOM;E8BoON,yBAAA;EpB1RE,sBN+N0B;AL68F9B;A+B94FE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,e1BoJoC;E0BnJpC,yBAAA;EACA,gB1BnC0B;E0BoC1B,c1B3RO;E0B4RP,iBAAA;ETvSA,yBjBMO;E0BmSP,8BAAA;EpB3SA,kCoB4SuB;A/Bg5F3B;;A+Bt4FA;EACE,WAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;A/By4FF;A+Bv4FE;EACE,aAAA;A/By4FJ;A+Br4FI;EAA0B,oE1B6Ne;AL2qF7C;A+Bv4FI;EAA0B,oE1B4Ne;AL8qF7C;A+Bz4FI;EAA0B,oE1B2Ne;ALirF7C;A+Bz4FE;EACE,SAAA;A/B24FJ;A+Bx4FE;EACE,W1B6MyC;E0B5MzC,Y1B4MyC;E0B3MzC,oBAAA;ET3UA,yBjBsO0B;E0BuG1B,S1B4MyC;EM3hBzC,mBN4hByC;Ee3hBvC,oHWiVF;EXjVE,4GWiVF;A/By4FJ;AoBttGE;EWqUA;IXpUE,wBAAA;IAAA,gBAAA;EpBytGF;AACF;A+Bt5FE;EASE,gBAAA;A/Bg5FJ;A+B94FI;ETnVA,qEjB8hByC;ALssF7C;A+B54FE;EACE,W1BsLgC;E0BrLhC,c1BsLgC;E0BrLhC,kBAAA;EACA,e1BqLgC;E0BpLhC,yB1BtVO;E0BuVP,yBAAA;EpBhWA,mBNqhBgC;AL0tFpC;A+B14FE;EACE,W1BkLyC;E0BjLzC,Y1BiLyC;EiBthBzC,yBjBsO0B;E0BiI1B,S1BkLyC;EM3hBzC,mBN4hByC;Ee3hBvC,iHW2WF;EX3WE,4GW2WF;A/B24FJ;AoBlvGE;EWgWA;IX/VE,qBAAA;IAAA,gBAAA;EpBqvGF;AACF;A+Bv5FE;EAQE,gBAAA;A/Bk5FJ;A+Bh5FI;ET7WA,qEjB8hByC;ALkuF7C;A+B94FE;EACE,W1B4JgC;E0B3JhC,c1B4JgC;E0B3JhC,kBAAA;EACA,e1B2JgC;E0B1JhC,yB1BhXO;E0BiXP,yBAAA;EpB1XA,mBNqhBgC;ALsvFpC;A+B54FE;EACE,W1BwJyC;E0BvJzC,Y1BuJyC;E0BtJzC,aAAA;EACA,oB1BrC0B;E0BsC1B,mB1BtC0B;EiB5V1B,yBjBsO0B;E0B8J1B,S1BqJyC;EM3hBzC,mBN4hByC;Ee3hBvC,gHWwYF;EXxYE,4GWwYF;A/B64FJ;AoBjxGE;EW0XA;IXzXE,oBAAA;IAAA,gBAAA;EpBoxGF;AACF;A+B55FE;EAWE,gBAAA;A/Bo5FJ;A+Bl5FI;ET1YA,qEjB8hByC;ALiwF7C;A+Bh5FE;EACE,W1B+HgC;E0B9HhC,c1B+HgC;E0B9HhC,kBAAA;EACA,e1B8HgC;E0B7HhC,6BAAA;EACA,yBAAA;EACA,oBAAA;A/Bk5FJ;A+B94FE;EACE,yB1BpZO;EMTP,mBNqhBgC;ALyxFpC;A+B74FE;EACE,kBAAA;EACA,yB1B1ZO;EMTP,mBNqhBgC;AL8xFpC;;A+B34FA;;;EXvaM,4GW0aJ;A/B84FF;AoBpzGE;EWmaF;;;IXlaI,gBAAA;EpByzGF;AACF;;AgC/zGA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhCk0GF;;AgC/zGA;EACE,cAAA;EACA,oBAAA;AhCk0GF;AMj0GE;E0BEE,qBAAA;AhCk0GJ;AgC9zGE;EACE,c3BPO;ALu0GX;;AgCxzGA;EACE,gCAAA;AhC2zGF;AgCzzGE;EACE,mBAAA;AhC2zGJ;AgCxzGE;EACE,6BAAA;ErB7BA,+BNyN0B;EMxN1B,gCNwN0B;ALgoG9B;AMn1GE;E0B2BI,qC3B2kB8B;ALgvFpC;AgCxzGI;EACE,c3B/BK;E2BgCL,6BAAA;EACA,yBAAA;AhC0zGN;AgCtzGE;;EAEE,c3BtCO;E2BuCP,yB/BEI;E+BDJ,qC3BgkBgC;ALwvFpC;AgCrzGE;EAEE,gBAAA;ErBpDA,yBqBsD2B;ErBrD3B,0BqBqD2B;AhCszG/B;;AgC5yGE;ErBtEE,sBN+N0B;ALupG9B;AgC5yGE;;EAEE,c/BtBI;E+BuBJ,yB3B2J0B;ALmpG9B;;AgCpyGE;EACE,cAAA;EACA,kBAAA;AhCuyGJ;;AgClyGE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AhCqyGJ;;AgC3xGE;EACE,aAAA;AhC8xGJ;AgC5xGE;EACE,cAAA;AhC8xGJ;;AiCh4GA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AjCm4GF;AiC/3GE;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AjCi4GJ;;AiCx3GA;EACE,qBAAA;EACA,sB5BkmBkC;E4BjmBlC,yB5BimBkC;E4BhmBlC,kB5BkFO;E4BjFP,kB5BkN4B;E4BjN5B,oBAAA;EACA,mBAAA;AjC23GF;AM35GE;E2BmCE,qBAAA;AjC23GJ;;AiCl3GA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjCq3GF;AiCn3GE;EACE,gBAAA;EACA,eAAA;AjCq3GJ;AiCl3GE;EACE,gBAAA;EACA,WAAA;AjCo3GJ;;AiC32GA;EACE,qBAAA;EACA,mB5B0hBkC;E4BzhBlC,sB5ByhBkC;ALq1FpC;;AiCl2GA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AjCm2GF;;AiC/1GA;EACE,wBAAA;EACA,kB5BmJ4B;E4BlJ5B,cAAA;EACA,6BAAA;EACA,6BAAA;EtB5GE,sBN+N0B;ALgvG9B;AMn8GE;E2BoGE,qBAAA;AjCk2GJ;AiC91GE;EACE,eAAA;AjCg2GJ;;AiC11GA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,0BAAA;AjC61GF;;Ae15GI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjCq1GR;AACF;Ae/6GI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjCq1GN;EiCn1GM;IACE,mBAAA;EjCq1GR;EiCn1GQ;IACE,kBAAA;EjCq1GV;EiCl1GQ;IACE,qB5BkewB;I4BjexB,oB5BiewB;ELm3FlC;EiC/0GM;;IAEE,iBAAA;EjCi1GR;EiC90GM;IACE,wBAAA;IAGA,gBAAA;EjC80GR;EiC30GM;IACE,aAAA;EjC60GR;AACF;Ae77GI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjCu3GR;AACF;Aej9GI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjCu3GN;EiCr3GM;IACE,mBAAA;EjCu3GR;EiCr3GQ;IACE,kBAAA;EjCu3GV;EiCp3GQ;IACE,qB5BkewB;I4BjexB,oB5BiewB;ELq5FlC;EiCj3GM;;IAEE,iBAAA;EjCm3GR;EiCh3GM;IACE,wBAAA;IAGA,gBAAA;EjCg3GR;EiC72GM;IACE,aAAA;EjC+2GR;AACF;Ae/9GI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjCy5GR;AACF;Aen/GI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjCy5GN;EiCv5GM;IACE,mBAAA;EjCy5GR;EiCv5GQ;IACE,kBAAA;EjCy5GV;EiCt5GQ;IACE,qB5BkewB;I4BjexB,oB5BiewB;ELu7FlC;EiCn5GM;;IAEE,iBAAA;EjCq5GR;EiCl5GM;IACE,wBAAA;IAGA,gBAAA;EjCk5GR;EiC/4GM;IACE,aAAA;EjCi5GR;AACF;AejgHI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjC27GR;AACF;AerhHI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjC27GN;EiCz7GM;IACE,mBAAA;EjC27GR;EiCz7GQ;IACE,kBAAA;EjC27GV;EiCx7GQ;IACE,qB5BkewB;I4BjexB,oB5BiewB;ELy9FlC;EiCr7GM;;IAEE,iBAAA;EjCu7GR;EiCp7GM;IACE,wBAAA;IAGA,gBAAA;EjCo7GR;EiCj7GM;IACE,aAAA;EjCm7GR;AACF;AiC19GQ;;EAEE,gBAAA;EACA,eAAA;AjC49GV;AiCj+GI;EAUI,qBAAA;EACA,2BAAA;AjC09GR;AiCx9GQ;EACE,mBAAA;AjC09GV;AiCx9GU;EACE,kBAAA;AjC09GZ;AiCv9GU;EACE,qB5BkewB;E4BjexB,oB5BiewB;ALw/FpC;AiCp9GQ;;EAEE,iBAAA;AjCs9GV;AiCn9GQ;EACE,wBAAA;EAGA,gBAAA;AjCm9GV;AiCh9GQ;EACE,aAAA;AjCk9GV;;AiCp8GE;EACE,yB5BsdgC;ALi/FpC;AM9nHE;E2B0LI,yB5Bmd8B;ALo/FpC;AiCl8GI;EACE,yB5B2c8B;ALy/FpC;AMpoHE;E2BmMM,yB5Byc4B;AL2/FpC;AiCj8GM;EACE,yB5Buc4B;AL4/FpC;AiC/7GI;;;;EAIE,yB5B8b8B;ALmgGpC;AiC77GE;EACE,yB5BubgC;E4BtbhC,gC5B2bgC;ALogGpC;AiC57GE;EACE,yD5BsbgC;ALwgGpC;AiC37GE;EACE,yB5B8agC;AL+gGpC;AiC57GI;EACE,yB5B8a8B;ALghGpC;AM7pHE;E2BkOM,yB5B2a4B;ALmhGpC;;AiCt7GE;EACE,chCjMI;AD0nHR;AMpqHE;E2B8OI,chCpME;AD6nHR;AiCp7GI;EACE,+B5BgZ8B;ALsiGpC;AM1qHE;E2BuPM,gC5B8Y4B;ALwiGpC;AiCn7GM;EACE,gC5B4Y4B;ALyiGpC;AiCj7GI;;;;EAIE,chCzNE;AD4oHR;AiC/6GE;EACE,+B5B4XgC;E4B3XhC,sC5BgYgC;ALijGpC;AiC96GE;EACE,yD5B2XgC;ALqjGpC;AiC76GE;EACE,+B5BmXgC;AL4jGpC;AiC96GI;EACE,chCzOE;ADypHR;AMnsHE;E2BsRM,chC5OA;AD4pHR;;AkCltHA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBjCgDM;EiC/CN,2BAAA;EACA,sCAAA;EvBRE,sBN+N0B;AL+/G9B;AkCntHE;EACE,eAAA;EACA,cAAA;AlCqtHJ;AkCjtHI;EvBXA,+BNyN0B;EMxN1B,gCNwN0B;ALugH9B;AkC/sHI;EvBHA,mCN2M0B;EM1M1B,kCN0M0B;AL2gH9B;;AkC7sHA;EAGE,cAAA;EACA,gB7BqqBkC;ALyiGpC;;AkC3sHA;EACE,sB7BgqBkC;AL8iGpC;;AkC3sHA;EACE,qBAAA;EACA,gBAAA;AlC8sHF;;AkC3sHA;EACE,gBAAA;AlC8sHF;;AMpvHE;E4B2CE,qBAAA;AlC6sHJ;AkC1sHE;EACE,oB7B+oBgC;AL6jGpC;;AkCpsHA;EACE,wBAAA;EACA,gBAAA;EACA,qC7ByoBkC;E6BxoBlC,6CAAA;AlCusHF;AkCrsHE;EvBrEE,0DuBsEuB;AlCusH3B;AkCnsHI;EACE,aAAA;AlCqsHN;;AkChsHA;EACE,wBAAA;EACA,qC7BynBkC;E6BxnBlC,0CAAA;AlCmsHF;AkCjsHE;EvBrFE,0DuBsFuB;AlCmsH3B;;AkC1rHA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AlC6rHF;;AkC1rHA;EACE,uBAAA;EACA,sBAAA;AlC6rHF;;AkCzrHA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB7B4lBkC;ALgmGpC;;AkCzrHA;EACE,WAAA;EvBtHE,kCN0sBgC;ALymGpC;;AkCxrHA;EACE,WAAA;EvBtHE,2CNosBgC;EMnsBhC,4CNmsBgC;AL+mGpC;;AkCzrHA;EACE,WAAA;EvB7GE,+CNsrBgC;EMrrBhC,8CNqrBgC;ALqnGpC;;AkCvrHA;EACE,aAAA;EACA,sBAAA;AlC0rHF;AkCxrHE;EACE,mB7BmkBgC;ALunGpC;Ae/wHI;EmBgFJ;IASI,mBAAA;IACA,mBAAA;IACA,kBAAA;ElC0rHF;EkCxrHE;IACE,aAAA;IAEA,SAAA;IACA,sBAAA;IACA,kB7BsjB8B;I6BrjB9B,gBAAA;IACA,iB7BojB8B;ELqoGlC;AACF;;AkChrHA;EACE,aAAA;EACA,sBAAA;AlCmrHF;AkC/qHE;EACE,mB7BmiBgC;AL8oGpC;AetyHI;EmB8GJ;IAWI,mBAAA;ElCirHF;EkC9qHE;IAEE,SAAA;IACA,gBAAA;ElC+qHJ;EkC7qHI;IACE,cAAA;IACA,cAAA;ElC+qHN;EkC1qHM;IvBnLJ,0BuBoLmC;IvBnLnC,6BuBmLmC;ElC6qHrC;EkC3qHQ;;IAEE,0BAAA;ElC6qHV;EkC3qHQ;;IAEE,6BAAA;ElC6qHV;EkCzqHM;IvBlLJ,yBuBmLkC;IvBlLlC,4BuBkLkC;ElC4qHpC;EkC1qHQ;;IAEE,yBAAA;ElC4qHV;EkC1qHQ;;IAEE,4BAAA;ElC4qHV;EkCxqHM;IvB1NJ,sBN+N0B;ELsqH5B;EkCxqHQ;;IvBvNN,+BNyN0B;IMxN1B,gCNwN0B;EL2qH5B;EkCzqHQ;;IvB7MN,mCN2M0B;IM1M1B,kCN0M0B;ELgrH5B;EkCxqHM;IvBvOJ,gBuBwO6B;ElC0qH/B;EkCxqHQ;;;;IvB1ON,gBuB8O+B;ElC0qHjC;AACF;;AkC7pHE;EACE,sB7BwcgC;ALwtGpC;Aer2HI;EmBmMJ;IAMI,e7BkdgC;I6BjdhC,mB7BkdgC;I6BjdhC,UAAA;IACA,SAAA;ElCgqHF;EkC9pHE;IACE,qBAAA;IACA,WAAA;ElCgqHJ;AACF;;AkCtpHE;EACE,gBAAA;EACA,gBAAA;AlCypHJ;AkCrpHI;EACE,gBAAA;AlCupHN;AkCnpHE;EACE,gBAAA;EACA,6BAAA;EACA,4BAAA;AlCqpHJ;AkClpHE;EACE,yBAAA;EACA,0BAAA;AlCopHJ;;AmC97HA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB9B43BkC;E8B33BlC,gBAAA;EACA,yB9BMS;EMRP,sBN+N0B;ALquH9B;;AmC57HE;EACE,oB9Bi3BgC;AL8kGpC;AmC77HI;EACE,qBAAA;EACA,qB9B62B8B;E8B52B9B,c9BFK;E8BGL,Y9Bk3B8B;AL6kGpC;AmCr7HE;EACE,0BAAA;AnCu7HJ;AmCp7HE;EACE,qBAAA;AnCs7HJ;AmCn7HE;EACE,c9BtBO;AL28HX;;AoC39HA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGDE,sBN+N0B;AL+vH9B;;AoC59HA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iB/B+pBkC;E+B9pBlC,c/B2J0B;E+B1J1B,yBnC6CM;EmC5CN,yBAAA;ApC+9HF;AoC79HE;EACE,UAAA;EACA,oD/BuJwB;E+BtJxB,qBAAA;EACA,yB/BRO;E+BSP,qB/BRO;ALu+HX;AoC59HE;EACE,UAAA;EACA,U/BwpBgC;E+BvpBhC,iD/ByU0B;ALqpH9B;AoC19HE;EACE,eAAA;ApC49HJ;;AoCt9HI;EACE,cAAA;EzBRF,+BNoM0B;EMnM1B,kCNmM0B;AL+xH9B;AoCt9HI;EzB3BA,gCNkN0B;EMjN1B,mCNiN0B;ALmyH9B;AoCr9HE;EACE,UAAA;EACA,cnCOI;EmCNJ,yB/BwL0B;E+BvL1B,qB/BuL0B;ALgyH9B;AoCp9HE;EACE,c/BzCO;E+B0CP,oBAAA;EAEA,YAAA;EACA,yBnCHI;EmCIJ,qB/BjDO;ALsgIX;;AqChhIE;EACE,uBAAA;EACA,kBhC2P0B;EgC1P1B,gBhCuN0B;AL4zH9B;AqC9gIM;E1BoBF,8BNqM0B;EMpM1B,iCNoM0B;ALyzH9B;AqC7gIM;E1BCF,+BNmN0B;EMlN1B,kCNkN0B;AL6zH9B;;AqC9hIE;EACE,uBAAA;EACA,mBhC4P0B;EgC3P1B,gBhCwN0B;ALy0H9B;AqC5hIM;E1BoBF,8BNsM0B;EMrM1B,iCNqM0B;ALs0H9B;AqC3hIM;E1BCF,+BNoN0B;EMnN1B,kCNmN0B;AL00H9B;;AsC1iIA;EACE,qBAAA;EACA,qBAAA;EACA,cjCiwBkC;EiChwBlC,gBjC4P4B;EiC3P5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BTE,sBN+N0B;ALw1H9B;AsC1iIE;EACE,aAAA;AtC4iIJ;;AsCviIA;EACE,kBAAA;EACA,SAAA;AtC0iIF;;AsCniIA;EACE,oBjC8uBkC;EiC7uBlC,mBjC6uBkC;EM3wBhC,oBN8wBgC;ALuzGpC;;AsC9hIE;EC1CA,cAAA;EACA,yBlCiFa;AL2/Hf;AM9jIE;EiCVI,cAAA;EACA,qBAAA;EACA,mEAAA;AvC2kIN;;AsCxiIE;EC1CA,cAAA;EACA,yBlCiFa;ALqgIf;AMxkIE;EiCVI,cAAA;EACA,qBAAA;EACA,0DAAA;AvCqlIN;;AsCljIE;EC1CA,cAAA;EACA,yBlCiFa;AL+gIf;AMllIE;EiCVI,cAAA;EACA,qBAAA;EACA,oEAAA;AvC+lIN;;AsC5jIE;EC1CA,cAAA;EACA,yBlCiFa;ALyhIf;AM5lIE;EiCVI,cAAA;EACA,qBAAA;EACA,kEAAA;AvCymIN;;AsCtkIE;EC1CA,cAAA;EACA,yBlCiFa;ALmiIf;AMtmIE;EiCVI,cAAA;EACA,qBAAA;EACA,6CAAA;AvCmnIN;;AsChlIE;EC1CA,cAAA;EACA,yBlCiFa;AL6iIf;AMhnIE;EiCVI,cAAA;EACA,qBAAA;EACA,6CAAA;AvC6nIN;;AsC1lIE;EC1CA,cAAA;EACA,yBlCiFa;ALujIf;AM1nIE;EiCVI,cAAA;EACA,qBAAA;EACA,mDAAA;AvCuoIN;;AsCpmIE;EC1CA,cAAA;EACA,yBlCiFa;ALikIf;AMpoIE;EiCVI,cAAA;EACA,qBAAA;EACA,kEAAA;AvCipIN;;AwCzpIA;EACE,kBAAA;EACA,mBnCisBkC;EmChsBlC,yBnCSS;EMRP,qBNgO0B;AL47H9B;AepmII;EyB5DJ;IAOI,kBAAA;ExC6pIF;AACF;;AwC1pIA;EACE,gBAAA;EACA,eAAA;E7BTE,gB6BUqB;AxC6pIzB;;AyCvqIA;EACE,kBAAA;EACA,wBAAA;EACA,mBpCozBkC;EoCnzBlC,6BAAA;E9BJE,sBN+N0B;ALg9H9B;;AyCtqIA;EAEE,cAAA;AzCwqIF;;AyCpqIA;EACE,gBpCiP4B;ALs7H9B;;AyC/pIA;EACE,mBAAA;AzCkqIF;AyC/pIE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,wBAAA;EACA,cAAA;AzCiqIJ;;AyCvpIE;EC9CA,gCD+CqH;EnB1CnH,0CmB0CuB;EC7CzB,yCD6CqE;AzC4pIvE;A0CvsIE;EACE,qEAAA;A1CysIJ;A0CtsIE;EACE,uDAAA;A1CwsIJ;;AyCnqIE;EC9CA,+BD+CqH;EnB1CnH,0CmB0CuB;EC7CzB,yCD6CqE;AzCwqIvE;A0CntIE;EACE,6DAAA;A1CqtIJ;A0CltIE;EACE,+CAAA;A1CotIJ;;AyC/qIE;EC9CA,+BD+CqH;EnB1CnH,wCmB0CuB;EC7CzB,sCD6CqE;AzCorIvE;A0C/tIE;EACE,qEAAA;A1CiuIJ;A0C9tIE;EACE,uDAAA;A1CguIJ;;AyC3rIE;EC9CA,gCD+CqH;EnB1CnH,0CmB0CuB;EC7CzB,yCD6CqE;AzCgsIvE;A0C3uIE;EACE,qEAAA;A1C6uIJ;A0C1uIE;EACE,sDAAA;A1C4uIJ;;AyCvsIE;EC9CA,6BD+CqH;EnB1CnH,wCmB0CuB;EC7CzB,wCD6CqE;AzC4sIvE;A0CvvIE;EACE,iEAAA;A1CyvIJ;A0CtvIE;EACE,mCAAA;A1CwvIJ;;AyCntIE;EC9CA,+BD+CqH;EnB1CnH,wCmB0CuB;EC7CzB,sCD6CqE;AzCwtIvE;A0CnwIE;EACE,kDAAA;A1CqwIJ;A0ClwIE;EACE,qDAAA;A1CowIJ;;AyC/tIE;EC9CA,+BD+CqH;EnB1CnH,wCmB0CuB;EC7CzB,wCD6CqE;AzCouIvE;A0C/wIE;EACE,sDAAA;A1CixIJ;A0C9wIE;EACE,0DAAA;A1CgxIJ;;AyC3uIE;EC9CA,4BD+CqH;EnB1CnH,wCmB0CuB;EC7CzB,wCD6CqE;AzCgvIvE;A0C3xIE;EACE,qEAAA;A1C6xIJ;A0C1xIE;EACE,YAAA;A1C4xIJ;;A2CtyIA;EACE;IAAO,2BAAA;E3C0yIP;E2CzyIA;IAAK,wBAAA;E3C4yIL;AACF;A2C1yIA;EACE,aAAA;EACA,YtCg0BkC;EsC/zBlC,gBAAA;EACA,kBtC+zBkC;EsC9zBlC,yBtCES;EMRP,sBN+N0B;ALolI9B;;A2CxyIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,c1CuCM;E0CtCN,kBAAA;EACA,mBAAA;EACA,yBtCuzBkC;Eex0B9B,2BuBkBJ;A3C2yIF;AoBzzIE;EuBMF;IvBLI,gBAAA;EpB4zIF;AACF;;A2C7yIA;ErBiBE,qMAAA;EqBfA,0BAAA;A3CgzIF;;A2C7yIA;EACE,kDAAA;A3CgzIF;;A4Ch1IA;EACE,aAAA;EACA,uBAAA;A5Cm1IF;;A4Ch1IA;EACE,SAAA;A5Cm1IF;;A6Cr1IA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;A7Cs1IF;;A6C70IA;EACE,WAAA;EACA,cxCJS;EwCKT,mBAAA;A7Cg1IF;AMt1IE;EuCUE,cxCTO;EwCUP,qBAAA;EACA,yBxCjBO;ALg2IX;A6C50IE;EACE,cxCbO;EwCcP,yBxCrBO;ALm2IX;;A6Cr0IA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAEA,mBAAA;EACA,yB5CUM;E4CTN,sCAAA;A7Cu0IF;A6Cr0IE;ElCzCE,+BNyN0B;EMxN1B,gCNwN0B;ALypI9B;A6Cr0IE;EACE,gBAAA;ElChCA,mCN2M0B;EM1M1B,kCN0M0B;AL8pI9B;AMj3IE;EuC6CE,UAAA;EACA,qBAAA;A7Cu0IJ;A6Cp0IE;EAEE,cxCnDO;EwCoDP,yB5CVI;AD+0IR;A6Cj0IE;EACE,UAAA;EACA,c5ChBI;E4CiBJ,yBxCiK0B;EwChK1B,qBxCgK0B;ALmqI9B;;A6CxzIE;EACE,eAAA;EACA,cAAA;ElCrFA,gBkCsFuB;A7C2zI3B;A6CvzII;EACE,aAAA;A7CyzIN;A6CpzII;EACE,gBAAA;A7CszIN;;A8Cx5IE;EACE,gCD6GsE;EC5GtE,6CD4GuC;A7C+yI3C;AMh5IE;EwCPM,gCDwGkE;ECvGlE,qEAAA;A9C05IR;A8Cv5IM;EACE,c7C4CA;E6C3CA,2CDkGkE;ECjGlE,uCDiGkE;A7CwzI1E;;A8Ct6IE;EACE,+BD6GsE;EC5GtE,6CD4GuC;A7C6zI3C;AM95IE;EwCPM,+BDwGkE;ECvGlE,6DAAA;A9Cw6IR;A8Cr6IM;EACE,c7C4CA;E6C3CA,0CDkGkE;ECjGlE,sCDiGkE;A7Cs0I1E;;A8Cp7IE;EACE,+BD6GsE;EC5GtE,0CD4GuC;A7C20I3C;AM56IE;EwCPM,+BDwGkE;ECvGlE,qEAAA;A9Cs7IR;A8Cn7IM;EACE,c7C4CA;E6C3CA,0CDkGkE;ECjGlE,sCDiGkE;A7Co1I1E;;A8Cl8IE;EACE,gCD6GsE;EC5GtE,6CD4GuC;A7Cy1I3C;AM17IE;EwCPM,gCDwGkE;ECvGlE,qEAAA;A9Co8IR;A8Cj8IM;EACE,c7C4CA;E6C3CA,2CDkGkE;ECjGlE,uCDiGkE;A7Ck2I1E;;A8Ch9IE;EACE,6BD6GsE;EC5GtE,4CD4GuC;A7Cu2I3C;AMx8IE;EwCPM,6BDwGkE;ECvGlE,iEAAA;A9Ck9IR;A8C/8IM;EACE,c7C4CA;E6C3CA,wCDkGkE;ECjGlE,oCDiGkE;A7Cg3I1E;;A8C99IE;EACE,+BD6GsE;EC5GtE,0CD4GuC;A7Cq3I3C;AMt9IE;EwCPM,+BDwGkE;ECvGlE,kDAAA;A9Cg+IR;A8C79IM;EACE,c7C4CA;E6C3CA,0CDkGkE;ECjGlE,sCDiGkE;A7C83I1E;;A8C5+IE;EACE,+BD6GsE;EC5GtE,4CD4GuC;A7Cm4I3C;AMp+IE;EwCPM,+BDwGkE;ECvGlE,sDAAA;A9C8+IR;A8C3+IM;EACE,c7C4CA;E6C3CA,0CDkGkE;ECjGlE,sCDiGkE;A7C44I1E;;A8C1/IE;EACE,4BD6GsE;EC5GtE,4CD4GuC;A7Ci5I3C;AMl/IE;EwCPM,4BDwGkE;ECvGlE,qEAAA;A9C4/IR;A8Cz/IM;EACE,c7C4CA;E6C3CA,uCDkGkE;ECjGlE,mCDiGkE;A7C05I1E;;A+C3gJA;EACE,YAAA;EACA,iB1Cg6BkC;E0C/5BlC,gB1CkQ4B;E0CjQ5B,cAAA;EACA,W1CeS;E0CdT,4B1C+5BkC;E0C95BlC,YAAA;A/C8gJF;AMrgJE;EyCJI,W1CQK;E0CPL,qBAAA;EACA,aAAA;A/C4gJN;A+CjhJE;EASE,eAAA;A/C2gJJ;;A+CjgJA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;EACA,wBAAA;A/CogJF;;AgD9hJA;EAEE,gBAAA;AhDgiJF;AgD9hJE;EACE,kBAAA;EACA,gBAAA;AhDgiJJ;;AgD3hJA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3CklBkC;E2CjlBlC,aAAA;EACA,gBAAA;EAGA,UAAA;AhD4hJF;;AgDrhJA;EACE,kBAAA;EACA,WAAA;EACA,c3CovBkC;E2ClvBlC,oBAAA;AhDuhJF;AgDphJE;E5BtCI,mC4BuCF;AhDshJJ;AoBzjJE;E4BkCA;I5BjCE,gBAAA;EpB4jJF;AACF;AgD5hJE;EAEE,6BAAA;AhD6hJJ;AgD3hJE;EACE,0BAAA;AhD6hJJ;;AgDzhJA;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;AhD4hJF;AgDzhJE;EACE,cAAA;EACA,gCAAA;EACA,WAAA;AhD2hJJ;;AgDthJA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,oBAAA;EACA,yB/CfM;E+CgBN,4BAAA;EACA,oCAAA;ErCvEE,qBNgO0B;E2CrJ5B,UAAA;AhDshJF;;AgDlhJA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3C+gBkC;E2C9gBlC,sB3CtES;AL2lJX;AgDlhJE;EAAS,UAAA;AhDqhJX;AgDphJE;EAAS,Y3CysByB;AL80HpC;;AgDlhJA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,a3CqsBkC;E2CpsBlC,gCAAA;ErC9FE,8BN0N0B;EMzN1B,+BNyN0B;AL25I9B;AgDphJE;EACE,a3CgsBgC;E2C9rBhC,8BAAA;AhDqhJJ;;AgDhhJA;EACE,gBAAA;EACA,gB3CmJ4B;ALg4I9B;;AgD9gJA;EACE,kBAAA;EAGA,cAAA;EACA,a3CypBkC;ALs3HpC;;AgD3gJA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,a3CipBkC;E2ChpBlC,6BAAA;AhD8gJF;AgD3gJE;EAAuB,oBAAA;AhD8gJzB;AgD7gJE;EAAsB,qBAAA;AhDghJxB;;AgD5gJA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AhD+gJF;;AexmJI;EiC+FF;IACE,gB3CmpBgC;I2ClpBhC,oBAAA;EhD6gJF;EgD1gJA;IACE,oCAAA;EhD4gJF;EgD1gJE;IACE,iCAAA;EhD4gJJ;EgDngJA;IAAY,gB3CmoBsB;ELm4HlC;AACF;AexnJI;EiCsHF;IAAY,gB3C4nBsB;EL04HlC;AACF;AiDxrJA;EACE,kBAAA;EACA,a5CwmBkC;E4CvmBlC,cAAA;EACA,S5CiuBkC;E6CruBlC,qL7CyP4B;E6CvP5B,kBAAA;EACA,gB7CgQ4B;E6C/P5B,gB7CmQ4B;E6ClQ5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EDNA,mB5CwP4B;E4CtP5B,qBAAA;EACA,UAAA;AjDosJF;AiDlsJE;EAAS,Y5CqtByB;ALg/HpC;AiDnsJE;EACE,kBAAA;EACA,cAAA;EACA,a5CqtBgC;E4CptBhC,c5CqtBgC;ALg/HpC;AiDnsJI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AjDqsJN;;AiDhsJA;EACE,iBAAA;AjDmsJF;AiDjsJE;EACE,SAAA;AjDmsJJ;AiDjsJI;EACE,MAAA;EACA,6BAAA;EACA,sB5CpBK;ALutJX;;AiD9rJA;EACE,iBAAA;AjDisJF;AiD/rJE;EACE,OAAA;EACA,a5CurBgC;E4CtrBhC,c5CqrBgC;AL4gIpC;AiD/rJI;EACE,QAAA;EACA,oCAAA;EACA,wB5CpCK;ALquJX;;AiD5rJA;EACE,iBAAA;AjD+rJF;AiD7rJE;EACE,MAAA;AjD+rJJ;AiD7rJI;EACE,SAAA;EACA,6BAAA;EACA,yB5ClDK;ALivJX;;AiD1rJA;EACE,iBAAA;AjD6rJF;AiD3rJE;EACE,QAAA;EACA,a5CypBgC;E4CxpBhC,c5CupBgC;ALsiIpC;AiD3rJI;EACE,OAAA;EACA,oCAAA;EACA,uB5ClEK;AL+vJX;;AiDxqJA;EACE,gB5CmnBkC;E4ClnBlC,uBAAA;EACA,chDpDM;EgDqDN,kBAAA;EACA,sB5C5FS;EMhBP,sBN+N0B;ALyjJ9B;;AmD5xJA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a9CsmBkC;E8CrmBlC,cAAA;EACA,gB9C2uBkC;E6ChvBlC,qL7CyP4B;E6CvP5B,kBAAA;EACA,gB7CgQ4B;E6C/P5B,gB7CmQ4B;E6ClQ5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;ECLA,mB9CuP4B;E8CrP5B,qBAAA;EACA,yBlD6CM;EkD5CN,4BAAA;EACA,oCAAA;ExCXE,qBNgO0B;ALqlJ9B;AmDtyJE;EACE,kBAAA;EACA,cAAA;EACA,W9C0uBgC;E8CzuBhC,c9C0uBgC;E8CzuBhC,gBAAA;AnDwyJJ;AmDtyJI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDuyJN;;AmDlyJA;EACE,qB9C2tBkC;AL0kIpC;AmDnyJE;EACE,iCAAA;AnDqyJJ;AmDlyJE;;;EAEE,6BAAA;AnDqyJJ;AmDlyJE;EACE,SAAA;EACA,qC9CitBgC;ALmlIpC;AmDjyJE;EACE,W9CyK0B;E8CxK1B,yBlDEI;ADiyJR;;AmD/xJA;EACE,mB9CosBkC;AL8lIpC;AmDhyJE;EACE,+BAAA;EACA,a9CgsBgC;E8C/rBhC,Y9C8rBgC;E8C7rBhC,gBAAA;AnDkyJJ;AmD/xJE;;;EAEE,oCAAA;AnDkyJJ;AmD/xJE;EACE,OAAA;EACA,uC9CurBgC;AL0mIpC;AmD9xJE;EACE,S9C+I0B;E8C9I1B,2BlDxBI;ADwzJR;;AmD5xJA;EACE,kB9C0qBkC;ALqnIpC;AmD7xJE;EACE,8BAAA;AnD+xJJ;AmD5xJE;;;EAEE,oCAAA;AnD+xJJ;AmD5xJE;EACE,MAAA;EACA,wC9CgqBgC;AL8nIpC;AmD3xJE;EACE,Q9CwH0B;E8CvH1B,4BlD/CI;AD40JR;AmDzxJE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,W9C8oBgC;E8C7oBhC,oBAAA;EACA,WAAA;EACA,oDAAA;AnD2xJJ;;AmDvxJA;EACE,oB9CuoBkC;ALmpIpC;AmDxxJE;EACE,gCAAA;EACA,a9CmoBgC;E8CloBhC,Y9CioBgC;E8ChoBhC,gBAAA;AnD0xJJ;AmDvxJE;;;EAEE,oCAAA;AnD0xJJ;AmDvxJE;EACE,QAAA;EACA,sC9C0nBgC;AL+pIpC;AmDtxJE;EACE,U9CkF0B;E8CjF1B,0BlDrFI;AD62JR;;AmDnwJA;EACE,uBAAA;EACA,gBAAA;EACA,e9CwF4B;E8CvF5B,c9C6G4B;E8C5G5B,6C9C8kBkC;E8C7kBlC,iDAAA;ExChKE,0CwCiKoB;ExChKpB,2CwCgKoB;AnDuwJxB;AmDpwJE;EACE,aAAA;AnDswJJ;;AmDlwJA;EACE,uBAAA;EACA,c9ClKS;ALu6JX;;AoDh7JA;EACE,kBAAA;ApDm7JF;;AoDh7JA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ApDm7JF;;AoDh7JA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;ApDm7JF;;AoDh7JA;;;EAGE,cAAA;EhC3BI,+BgC4BJ;ApDm7JF;AoB38JE;EgCoBF;;;IhCnBI,gBAAA;EpBg9JF;AACF;;AoDv7JA;;EAEE,kBAAA;EACA,MAAA;ApD07JF;;AoDv7JA;;EAEE,wBAAA;ApD07JF;AoDx7JE;EAJF;;IAKI,+BAAA;EpD47JF;AACF;;AoDz7JA;;EAEE,2BAAA;ApD47JF;AoD17JE;EAJF;;IAKI,kCAAA;EpD87JF;AACF;;AoD37JA;;EAEE,4BAAA;ApD87JF;AoD57JE;EAJF;;IAKI,mCAAA;EpDg8JF;AACF;;AoDv7JE;EACE,UAAA;EACA,yBAAA;EACA,4BAAA;ApD07JJ;AoDv7JE;;;EAGE,UAAA;ApDy7JJ;AoDt7JE;;EAEE,UAAA;ApDw7JJ;AoDr7JE;;;;;EAKE,wBAAA;ApDu7JJ;AoDr7JI;EAPF;;;;;IAQI,+BAAA;EpD47JJ;AACF;;AoDn7JA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,U/CsxBkC;E+CrxBlC,cnD9DM;EmD+DN,kBAAA;EACA,Y/CoxBkC;ALiqIpC;AM/hKE;;;E8CgHE,cnDtEI;EmDuEJ,qBAAA;EACA,UAAA;EACA,YAAA;ApDo7JJ;;AoDj7JA;EACE,OAAA;ApDo7JF;;AoD/6JA;EACE,QAAA;ApDk7JF;;AoD36JA;;EAEE,qBAAA;EACA,W/CiwBkC;E+ChwBlC,Y/CgwBkC;E+C/vBlC,+CAAA;EACA,0BAAA;ApD86JF;;AoD56JA;EACE,yD/C6vBkC;ALkrIpC;;AoD76JA;EACE,yD/C2vBkC;ALqrIpC;;AoDv6JA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iB/C0tBkC;E+CztBlC,gB/CytBkC;E+CxtBlC,gBAAA;ApDy6JF;AoDv6JE;EACE,kBAAA;EACA,cAAA;EACA,W/CstBgC;E+CrtBhC,W/CstBgC;E+CrtBhC,iB/CstBgC;E+CrtBhC,gB/CqtBgC;E+CptBhC,mBAAA;EACA,eAAA;EACA,0CAAA;ApDy6JJ;AoDt6JI;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ApDw6JN;AoDt6JI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ApDw6JN;AoDp6JE;EACE,yBnD9JI;ADokKR;;AoD75JA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,cnD/KM;EmDgLN,kBAAA;ApDg6JF;;AqDxoKA;EAAqB,mCAAA;ArD4oKrB;;AqD3oKA;EAAqB,8BAAA;ArD+oKrB;;AqD9oKA;EAAqB,iCAAA;ArDkpKrB;;AqDjpKA;EAAqB,iCAAA;ArDqpKrB;;AqDppKA;EAAqB,sCAAA;ArDwpKrB;;AqDvpKA;EAAqB,mCAAA;ArD2pKrB;;AsD7pKE;EACE,oCAAA;AtDgqKJ;;AMtpKE;;;EgDLI,8EAAA;AtDiqKN;;AsDvqKE;EACE,oCAAA;AtD0qKJ;;AMhqKE;;;EgDLI,qEAAA;AtD2qKN;;AsDjrKE;EACE,oCAAA;AtDorKJ;;AM1qKE;;;EgDLI,+EAAA;AtDqrKN;;AsD3rKE;EACE,oCAAA;AtD8rKJ;;AMprKE;;;EgDLI,6EAAA;AtD+rKN;;AsDrsKE;EACE,oCAAA;AtDwsKJ;;AM9rKE;;;EgDLI,wDAAA;AtDysKN;;AsD/sKE;EACE,oCAAA;AtDktKJ;;AMxsKE;;;EgDLI,wDAAA;AtDmtKN;;AsDztKE;EACE,oCAAA;AtD4tKJ;;AMltKE;;;EgDLI,8DAAA;AtD6tKN;;AsDnuKE;EACE,oCAAA;AtDsuKJ;;AM5tKE;;;EgDLI,6EAAA;AtDuuKN;;AuDtuKA;EACE,oCAAA;AvDyuKF;;AuDtuKA;EACE,wCAAA;AvDyuKF;;AwDpvKA;EAAkB,oCAAA;AxDwvKlB;;AwDvvKA;EAAkB,wCAAA;AxD2vKlB;;AwD1vKA;EAAkB,0CAAA;AxD8vKlB;;AwD7vKA;EAAkB,2CAAA;AxDiwKlB;;AwDhwKA;EAAkB,yCAAA;AxDowKlB;;AwDlwKA;EAAmB,oBAAA;AxDswKnB;;AwDrwKA;EAAmB,wBAAA;AxDywKnB;;AwDxwKA;EAAmB,0BAAA;AxD4wKnB;;AwD3wKA;EAAmB,2BAAA;AxD+wKnB;;AwD9wKA;EAAmB,yBAAA;AxDkxKnB;;AwD/wKE;EACE,gCAAA;AxDkxKJ;;AwDnxKE;EACE,gCAAA;AxDsxKJ;;AwDvxKE;EACE,gCAAA;AxD0xKJ;;AwD3xKE;EACE,gCAAA;AxD8xKJ;;AwD/xKE;EACE,gCAAA;AxDkyKJ;;AwDnyKE;EACE,gCAAA;AxDsyKJ;;AwDvyKE;EACE,gCAAA;AxD0yKJ;;AwD3yKE;EACE,gCAAA;AxD8yKJ;;AwD1yKA;EACE,gCAAA;AxD6yKF;;AwDtyKA;EACE,iCAAA;AxDyyKF;;AwDvyKA;EACE,0CAAA;EACA,2CAAA;AxD0yKF;;AwDxyKA;EACE,2CAAA;EACA,8CAAA;AxD2yKF;;AwDzyKA;EACE,8CAAA;EACA,6CAAA;AxD4yKF;;AwD1yKA;EACE,0CAAA;EACA,6CAAA;AxD6yKF;;AwD1yKA;EACE,6BAAA;AxD6yKF;;AwD1yKA;EACE,2BAAA;AxD6yKF;;AyDr2KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDw2KJ;;A0Dl2KI;EAA2B,wBAAA;A1Ds2K/B;;A0Dr2KI;EAA2B,0BAAA;A1Dy2K/B;;A0Dx2KI;EAA2B,gCAAA;A1D42K/B;;A0D32KI;EAA2B,yBAAA;A1D+2K/B;;A0D92KI;EAA2B,yBAAA;A1Dk3K/B;;A0Dj3KI;EAA2B,6BAAA;A1Dq3K/B;;A0Dp3KI;EAA2B,8BAAA;A1Dw3K/B;;A0Dv3KI;EAA2B,wBAAA;A1D23K/B;;A0D13KI;EAA2B,+BAAA;A1D83K/B;;Aep1KI;E2ClDA;IAA2B,wBAAA;E1D24K7B;E0D14KE;IAA2B,0BAAA;E1D64K7B;E0D54KE;IAA2B,gCAAA;E1D+4K7B;E0D94KE;IAA2B,yBAAA;E1Di5K7B;E0Dh5KE;IAA2B,yBAAA;E1Dm5K7B;E0Dl5KE;IAA2B,6BAAA;E1Dq5K7B;E0Dp5KE;IAA2B,8BAAA;E1Du5K7B;E0Dt5KE;IAA2B,wBAAA;E1Dy5K7B;E0Dx5KE;IAA2B,+BAAA;E1D25K7B;AACF;Ael3KI;E2ClDA;IAA2B,wBAAA;E1Dw6K7B;E0Dv6KE;IAA2B,0BAAA;E1D06K7B;E0Dz6KE;IAA2B,gCAAA;E1D46K7B;E0D36KE;IAA2B,yBAAA;E1D86K7B;E0D76KE;IAA2B,yBAAA;E1Dg7K7B;E0D/6KE;IAA2B,6BAAA;E1Dk7K7B;E0Dj7KE;IAA2B,8BAAA;E1Do7K7B;E0Dn7KE;IAA2B,wBAAA;E1Ds7K7B;E0Dr7KE;IAA2B,+BAAA;E1Dw7K7B;AACF;Ae/4KI;E2ClDA;IAA2B,wBAAA;E1Dq8K7B;E0Dp8KE;IAA2B,0BAAA;E1Du8K7B;E0Dt8KE;IAA2B,gCAAA;E1Dy8K7B;E0Dx8KE;IAA2B,yBAAA;E1D28K7B;E0D18KE;IAA2B,yBAAA;E1D68K7B;E0D58KE;IAA2B,6BAAA;E1D+8K7B;E0D98KE;IAA2B,8BAAA;E1Di9K7B;E0Dh9KE;IAA2B,wBAAA;E1Dm9K7B;E0Dl9KE;IAA2B,+BAAA;E1Dq9K7B;AACF;Ae56KI;E2ClDA;IAA2B,wBAAA;E1Dk+K7B;E0Dj+KE;IAA2B,0BAAA;E1Do+K7B;E0Dn+KE;IAA2B,gCAAA;E1Ds+K7B;E0Dr+KE;IAA2B,yBAAA;E1Dw+K7B;E0Dv+KE;IAA2B,yBAAA;E1D0+K7B;E0Dz+KE;IAA2B,6BAAA;E1D4+K7B;E0D3+KE;IAA2B,8BAAA;E1D8+K7B;E0D7+KE;IAA2B,wBAAA;E1Dg/K7B;E0D/+KE;IAA2B,+BAAA;E1Dk/K7B;AACF;A0D1+KA;EACE;IAAwB,wBAAA;E1D6+KxB;E0D5+KA;IAAwB,0BAAA;E1D++KxB;E0D9+KA;IAAwB,gCAAA;E1Di/KxB;E0Dh/KA;IAAwB,yBAAA;E1Dm/KxB;E0Dl/KA;IAAwB,yBAAA;E1Dq/KxB;E0Dp/KA;IAAwB,6BAAA;E1Du/KxB;E0Dt/KA;IAAwB,8BAAA;E1Dy/KxB;E0Dx/KA;IAAwB,wBAAA;E1D2/KxB;E0D1/KA;IAAwB,+BAAA;E1D6/KxB;AACF;A2DhiLA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A3DkiLF;A2DhiLE;EACE,cAAA;EACA,WAAA;A3DkiLJ;A2D/hLE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A3DiiLJ;;A2D5hLE;EACE,2BAAA;A3D+hLJ;;A2D1hLE;EACE,mBAAA;A3D6hLJ;;A2DxhLE;EACE,gBAAA;A3D2hLJ;;A2DthLE;EACE,iBAAA;A3DyhLJ;;A4DhkLI;EAAgC,8BAAA;A5DokLpC;;A4DnkLI;EAAgC,iCAAA;A5DukLpC;;A4DtkLI;EAAgC,sCAAA;A5D0kLpC;;A4DzkLI;EAAgC,yCAAA;A5D6kLpC;;A4D3kLI;EAA8B,0BAAA;A5D+kLlC;;A4D9kLI;EAA8B,4BAAA;A5DklLlC;;A4DjlLI;EAA8B,kCAAA;A5DqlLlC;;A4DplLI;EAA8B,yBAAA;A5DwlLlC;;A4DvlLI;EAA8B,uBAAA;A5D2lLlC;;A4D1lLI;EAA8B,uBAAA;A5D8lLlC;;A4D7lLI;EAA8B,yBAAA;A5DimLlC;;A4DhmLI;EAA8B,yBAAA;A5DomLlC;;A4DlmLI;EAAoC,sCAAA;A5DsmLxC;;A4DrmLI;EAAoC,oCAAA;A5DymLxC;;A4DxmLI;EAAoC,kCAAA;A5D4mLxC;;A4D3mLI;EAAoC,yCAAA;A5D+mLxC;;A4D9mLI;EAAoC,wCAAA;A5DknLxC;;A4DhnLI;EAAiC,kCAAA;A5DonLrC;;A4DnnLI;EAAiC,gCAAA;A5DunLrC;;A4DtnLI;EAAiC,8BAAA;A5D0nLrC;;A4DznLI;EAAiC,gCAAA;A5D6nLrC;;A4D5nLI;EAAiC,+BAAA;A5DgoLrC;;A4D9nLI;EAAkC,oCAAA;A5DkoLtC;;A4DjoLI;EAAkC,kCAAA;A5DqoLtC;;A4DpoLI;EAAkC,gCAAA;A5DwoLtC;;A4DvoLI;EAAkC,uCAAA;A5D2oLtC;;A4D1oLI;EAAkC,sCAAA;A5D8oLtC;;A4D7oLI;EAAkC,iCAAA;A5DipLtC;;A4D/oLI;EAAgC,2BAAA;A5DmpLpC;;A4DlpLI;EAAgC,iCAAA;A5DspLpC;;A4DrpLI;EAAgC,+BAAA;A5DypLpC;;A4DxpLI;EAAgC,6BAAA;A5D4pLpC;;A4D3pLI;EAAgC,+BAAA;A5D+pLpC;;A4D9pLI;EAAgC,8BAAA;A5DkqLpC;;AetpLI;E6ClDA;IAAgC,8BAAA;E5D6sLlC;E4D5sLE;IAAgC,iCAAA;E5D+sLlC;E4D9sLE;IAAgC,sCAAA;E5DitLlC;E4DhtLE;IAAgC,yCAAA;E5DmtLlC;E4DjtLE;IAA8B,0BAAA;E5DotLhC;E4DntLE;IAA8B,4BAAA;E5DstLhC;E4DrtLE;IAA8B,kCAAA;E5DwtLhC;E4DvtLE;IAA8B,yBAAA;E5D0tLhC;E4DztLE;IAA8B,uBAAA;E5D4tLhC;E4D3tLE;IAA8B,uBAAA;E5D8tLhC;E4D7tLE;IAA8B,yBAAA;E5DguLhC;E4D/tLE;IAA8B,yBAAA;E5DkuLhC;E4DhuLE;IAAoC,sCAAA;E5DmuLtC;E4DluLE;IAAoC,oCAAA;E5DquLtC;E4DpuLE;IAAoC,kCAAA;E5DuuLtC;E4DtuLE;IAAoC,yCAAA;E5DyuLtC;E4DxuLE;IAAoC,wCAAA;E5D2uLtC;E4DzuLE;IAAiC,kCAAA;E5D4uLnC;E4D3uLE;IAAiC,gCAAA;E5D8uLnC;E4D7uLE;IAAiC,8BAAA;E5DgvLnC;E4D/uLE;IAAiC,gCAAA;E5DkvLnC;E4DjvLE;IAAiC,+BAAA;E5DovLnC;E4DlvLE;IAAkC,oCAAA;E5DqvLpC;E4DpvLE;IAAkC,kCAAA;E5DuvLpC;E4DtvLE;IAAkC,gCAAA;E5DyvLpC;E4DxvLE;IAAkC,uCAAA;E5D2vLpC;E4D1vLE;IAAkC,sCAAA;E5D6vLpC;E4D5vLE;IAAkC,iCAAA;E5D+vLpC;E4D7vLE;IAAgC,2BAAA;E5DgwLlC;E4D/vLE;IAAgC,iCAAA;E5DkwLlC;E4DjwLE;IAAgC,+BAAA;E5DowLlC;E4DnwLE;IAAgC,6BAAA;E5DswLlC;E4DrwLE;IAAgC,+BAAA;E5DwwLlC;E4DvwLE;IAAgC,8BAAA;E5D0wLlC;AACF;Ae/vLI;E6ClDA;IAAgC,8BAAA;E5DqzLlC;E4DpzLE;IAAgC,iCAAA;E5DuzLlC;E4DtzLE;IAAgC,sCAAA;E5DyzLlC;E4DxzLE;IAAgC,yCAAA;E5D2zLlC;E4DzzLE;IAA8B,0BAAA;E5D4zLhC;E4D3zLE;IAA8B,4BAAA;E5D8zLhC;E4D7zLE;IAA8B,kCAAA;E5Dg0LhC;E4D/zLE;IAA8B,yBAAA;E5Dk0LhC;E4Dj0LE;IAA8B,uBAAA;E5Do0LhC;E4Dn0LE;IAA8B,uBAAA;E5Ds0LhC;E4Dr0LE;IAA8B,yBAAA;E5Dw0LhC;E4Dv0LE;IAA8B,yBAAA;E5D00LhC;E4Dx0LE;IAAoC,sCAAA;E5D20LtC;E4D10LE;IAAoC,oCAAA;E5D60LtC;E4D50LE;IAAoC,kCAAA;E5D+0LtC;E4D90LE;IAAoC,yCAAA;E5Di1LtC;E4Dh1LE;IAAoC,wCAAA;E5Dm1LtC;E4Dj1LE;IAAiC,kCAAA;E5Do1LnC;E4Dn1LE;IAAiC,gCAAA;E5Ds1LnC;E4Dr1LE;IAAiC,8BAAA;E5Dw1LnC;E4Dv1LE;IAAiC,gCAAA;E5D01LnC;E4Dz1LE;IAAiC,+BAAA;E5D41LnC;E4D11LE;IAAkC,oCAAA;E5D61LpC;E4D51LE;IAAkC,kCAAA;E5D+1LpC;E4D91LE;IAAkC,gCAAA;E5Di2LpC;E4Dh2LE;IAAkC,uCAAA;E5Dm2LpC;E4Dl2LE;IAAkC,sCAAA;E5Dq2LpC;E4Dp2LE;IAAkC,iCAAA;E5Du2LpC;E4Dr2LE;IAAgC,2BAAA;E5Dw2LlC;E4Dv2LE;IAAgC,iCAAA;E5D02LlC;E4Dz2LE;IAAgC,+BAAA;E5D42LlC;E4D32LE;IAAgC,6BAAA;E5D82LlC;E4D72LE;IAAgC,+BAAA;E5Dg3LlC;E4D/2LE;IAAgC,8BAAA;E5Dk3LlC;AACF;Aev2LI;E6ClDA;IAAgC,8BAAA;E5D65LlC;E4D55LE;IAAgC,iCAAA;E5D+5LlC;E4D95LE;IAAgC,sCAAA;E5Di6LlC;E4Dh6LE;IAAgC,yCAAA;E5Dm6LlC;E4Dj6LE;IAA8B,0BAAA;E5Do6LhC;E4Dn6LE;IAA8B,4BAAA;E5Ds6LhC;E4Dr6LE;IAA8B,kCAAA;E5Dw6LhC;E4Dv6LE;IAA8B,yBAAA;E5D06LhC;E4Dz6LE;IAA8B,uBAAA;E5D46LhC;E4D36LE;IAA8B,uBAAA;E5D86LhC;E4D76LE;IAA8B,yBAAA;E5Dg7LhC;E4D/6LE;IAA8B,yBAAA;E5Dk7LhC;E4Dh7LE;IAAoC,sCAAA;E5Dm7LtC;E4Dl7LE;IAAoC,oCAAA;E5Dq7LtC;E4Dp7LE;IAAoC,kCAAA;E5Du7LtC;E4Dt7LE;IAAoC,yCAAA;E5Dy7LtC;E4Dx7LE;IAAoC,wCAAA;E5D27LtC;E4Dz7LE;IAAiC,kCAAA;E5D47LnC;E4D37LE;IAAiC,gCAAA;E5D87LnC;E4D77LE;IAAiC,8BAAA;E5Dg8LnC;E4D/7LE;IAAiC,gCAAA;E5Dk8LnC;E4Dj8LE;IAAiC,+BAAA;E5Do8LnC;E4Dl8LE;IAAkC,oCAAA;E5Dq8LpC;E4Dp8LE;IAAkC,kCAAA;E5Du8LpC;E4Dt8LE;IAAkC,gCAAA;E5Dy8LpC;E4Dx8LE;IAAkC,uCAAA;E5D28LpC;E4D18LE;IAAkC,sCAAA;E5D68LpC;E4D58LE;IAAkC,iCAAA;E5D+8LpC;E4D78LE;IAAgC,2BAAA;E5Dg9LlC;E4D/8LE;IAAgC,iCAAA;E5Dk9LlC;E4Dj9LE;IAAgC,+BAAA;E5Do9LlC;E4Dn9LE;IAAgC,6BAAA;E5Ds9LlC;E4Dr9LE;IAAgC,+BAAA;E5Dw9LlC;E4Dv9LE;IAAgC,8BAAA;E5D09LlC;AACF;Ae/8LI;E6ClDA;IAAgC,8BAAA;E5DqgMlC;E4DpgME;IAAgC,iCAAA;E5DugMlC;E4DtgME;IAAgC,sCAAA;E5DygMlC;E4DxgME;IAAgC,yCAAA;E5D2gMlC;E4DzgME;IAA8B,0BAAA;E5D4gMhC;E4D3gME;IAA8B,4BAAA;E5D8gMhC;E4D7gME;IAA8B,kCAAA;E5DghMhC;E4D/gME;IAA8B,yBAAA;E5DkhMhC;E4DjhME;IAA8B,uBAAA;E5DohMhC;E4DnhME;IAA8B,uBAAA;E5DshMhC;E4DrhME;IAA8B,yBAAA;E5DwhMhC;E4DvhME;IAA8B,yBAAA;E5D0hMhC;E4DxhME;IAAoC,sCAAA;E5D2hMtC;E4D1hME;IAAoC,oCAAA;E5D6hMtC;E4D5hME;IAAoC,kCAAA;E5D+hMtC;E4D9hME;IAAoC,yCAAA;E5DiiMtC;E4DhiME;IAAoC,wCAAA;E5DmiMtC;E4DjiME;IAAiC,kCAAA;E5DoiMnC;E4DniME;IAAiC,gCAAA;E5DsiMnC;E4DriME;IAAiC,8BAAA;E5DwiMnC;E4DviME;IAAiC,gCAAA;E5D0iMnC;E4DziME;IAAiC,+BAAA;E5D4iMnC;E4D1iME;IAAkC,oCAAA;E5D6iMpC;E4D5iME;IAAkC,kCAAA;E5D+iMpC;E4D9iME;IAAkC,gCAAA;E5DijMpC;E4DhjME;IAAkC,uCAAA;E5DmjMpC;E4DljME;IAAkC,sCAAA;E5DqjMpC;E4DpjME;IAAkC,iCAAA;E5DujMpC;E4DrjME;IAAgC,2BAAA;E5DwjMlC;E4DvjME;IAAgC,iCAAA;E5D0jMlC;E4DzjME;IAAgC,+BAAA;E5D4jMlC;E4D3jME;IAAgC,6BAAA;E5D8jMlC;E4D7jME;IAAgC,+BAAA;E5DgkMlC;E4D/jME;IAAgC,8BAAA;E5DkkMlC;AACF;A6D/mMI;ECDF,sBAAA;A9DmnMF;;A6DjnMI;ECCF,uBAAA;A9DonMF;;A6DpnMI;ECGF,sBAAA;A9DqnMF;;AelkMI;E8CxDA;ICDF,sBAAA;E9DgoMA;E6D9nME;ICCF,uBAAA;E9DgoMA;E6DhoME;ICGF,sBAAA;E9DgoMA;AACF;Ae9kMI;E8CxDA;ICDF,sBAAA;E9D2oMA;E6DzoME;ICCF,uBAAA;E9D2oMA;E6D3oME;ICGF,sBAAA;E9D2oMA;AACF;AezlMI;E8CxDA;ICDF,sBAAA;E9DspMA;E6DppME;ICCF,uBAAA;E9DspMA;E6DtpME;ICGF,sBAAA;E9DspMA;AACF;AepmMI;E8CxDA;ICDF,sBAAA;E9DiqMA;E6D/pME;ICCF,uBAAA;E9DiqMA;E6DjqME;ICGF,sBAAA;E9DiqMA;AACF;A+DlqME;EAAyB,2BAAA;A/DqqM3B;;A+DrqME;EAAyB,6BAAA;A/DyqM3B;;A+DzqME;EAAyB,6BAAA;A/D6qM3B;;A+D7qME;EAAyB,0BAAA;A/DirM3B;;A+DjrME;EAAyB,2BAAA;A/DqrM3B;;A+DhrMA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DolBkC;AL+lLpC;;A+DhrMA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D4kBkC;ALumLpC;;A+D/qME;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a1DokBgC;EL+mLlC;AACF;;AgEltMA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AjEotMF;;AiE1sME;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AjE4sMJ;;AkExuMA;EAAa,8DAAA;AlE4uMb;;AkE3uMA;EAAU,wDAAA;AlE+uMV;;AkE9uMA;EAAa,uDAAA;AlEkvMb;;AkEjvMA;EAAe,2BAAA;AlEqvMf;;AmEpvMI;EAAuB,qBAAA;AnEwvM3B;;AmExvMI;EAAuB,qBAAA;AnE4vM3B;;AmE5vMI;EAAuB,qBAAA;AnEgwM3B;;AmEhwMI;EAAuB,sBAAA;AnEowM3B;;AmEpwMI;EAAuB,sBAAA;AnEwwM3B;;AmExwMI;EAAuB,sBAAA;AnE4wM3B;;AmE5wMI;EAAuB,sBAAA;AnEgxM3B;;AmEhxMI;EAAuB,sBAAA;AnEoxM3B;;AmEpxMI;EAAuB,uBAAA;AnEwxM3B;;AmExxMI;EAAuB,uBAAA;AnE4xM3B;;AmExxMA;EAAU,0BAAA;AnE4xMV;;AmE3xMA;EAAU,2BAAA;AnE+xMV;;AoE/xMQ;EAAgC,oBAAA;ApEmyMxC;;AoElyMQ;;EAEE,wBAAA;ApEqyMV;;AoEnyMQ;;EAEE,0BAAA;ApEsyMV;;AoEpyMQ;;EAEE,2BAAA;ApEuyMV;;AoEryMQ;;EAEE,yBAAA;ApEwyMV;;AoEvzMQ;EAAgC,0BAAA;ApE2zMxC;;AoE1zMQ;;EAEE,8BAAA;ApE6zMV;;AoE3zMQ;;EAEE,gCAAA;ApE8zMV;;AoE5zMQ;;EAEE,iCAAA;ApE+zMV;;AoE7zMQ;;EAEE,+BAAA;ApEg0MV;;AoE/0MQ;EAAgC,yBAAA;ApEm1MxC;;AoEl1MQ;;EAEE,6BAAA;ApEq1MV;;AoEn1MQ;;EAEE,+BAAA;ApEs1MV;;AoEp1MQ;;EAEE,gCAAA;ApEu1MV;;AoEr1MQ;;EAEE,8BAAA;ApEw1MV;;AoEv2MQ;EAAgC,uBAAA;ApE22MxC;;AoE12MQ;;EAEE,2BAAA;ApE62MV;;AoE32MQ;;EAEE,6BAAA;ApE82MV;;AoE52MQ;;EAEE,8BAAA;ApE+2MV;;AoE72MQ;;EAEE,4BAAA;ApEg3MV;;AoE/3MQ;EAAgC,yBAAA;ApEm4MxC;;AoEl4MQ;;EAEE,6BAAA;ApEq4MV;;AoEn4MQ;;EAEE,+BAAA;ApEs4MV;;AoEp4MQ;;EAEE,gCAAA;ApEu4MV;;AoEr4MQ;;EAEE,8BAAA;ApEw4MV;;AoEv5MQ;EAAgC,uBAAA;ApE25MxC;;AoE15MQ;;EAEE,2BAAA;ApE65MV;;AoE35MQ;;EAEE,6BAAA;ApE85MV;;AoE55MQ;;EAEE,8BAAA;ApE+5MV;;AoE75MQ;;EAEE,4BAAA;ApEg6MV;;AoE/6MQ;EAAgC,qBAAA;ApEm7MxC;;AoEl7MQ;;EAEE,yBAAA;ApEq7MV;;AoEn7MQ;;EAEE,2BAAA;ApEs7MV;;AoEp7MQ;;EAEE,4BAAA;ApEu7MV;;AoEr7MQ;;EAEE,0BAAA;ApEw7MV;;AoEv8MQ;EAAgC,2BAAA;ApE28MxC;;AoE18MQ;;EAEE,+BAAA;ApE68MV;;AoE38MQ;;EAEE,iCAAA;ApE88MV;;AoE58MQ;;EAEE,kCAAA;ApE+8MV;;AoE78MQ;;EAEE,gCAAA;ApEg9MV;;AoE/9MQ;EAAgC,0BAAA;ApEm+MxC;;AoEl+MQ;;EAEE,8BAAA;ApEq+MV;;AoEn+MQ;;EAEE,gCAAA;ApEs+MV;;AoEp+MQ;;EAEE,iCAAA;ApEu+MV;;AoEr+MQ;;EAEE,+BAAA;ApEw+MV;;AoEv/MQ;EAAgC,wBAAA;ApE2/MxC;;AoE1/MQ;;EAEE,4BAAA;ApE6/MV;;AoE3/MQ;;EAEE,8BAAA;ApE8/MV;;AoE5/MQ;;EAEE,+BAAA;ApE+/MV;;AoE7/MQ;;EAEE,6BAAA;ApEggNV;;AoE/gNQ;EAAgC,0BAAA;ApEmhNxC;;AoElhNQ;;EAEE,8BAAA;ApEqhNV;;AoEnhNQ;;EAEE,gCAAA;ApEshNV;;AoEphNQ;;EAEE,iCAAA;ApEuhNV;;AoErhNQ;;EAEE,+BAAA;ApEwhNV;;AoEviNQ;EAAgC,wBAAA;ApE2iNxC;;AoE1iNQ;;EAEE,4BAAA;ApE6iNV;;AoE3iNQ;;EAEE,8BAAA;ApE8iNV;;AoE5iNQ;;EAEE,+BAAA;ApE+iNV;;AoE7iNQ;;EAEE,6BAAA;ApEgjNV;;AoE1iNI;EAAmB,uBAAA;ApE8iNvB;;AoE7iNI;;EAEE,2BAAA;ApEgjNN;;AoE9iNI;;EAEE,6BAAA;ApEijNN;;AoE/iNI;;EAEE,8BAAA;ApEkjNN;;AoEhjNI;;EAEE,4BAAA;ApEmjNN;;AetiNI;EqDjDI;IAAgC,oBAAA;EpE4lNtC;EoE3lNM;;IAEE,wBAAA;EpE6lNR;EoE3lNM;;IAEE,0BAAA;EpE6lNR;EoE3lNM;;IAEE,2BAAA;EpE6lNR;EoE3lNM;;IAEE,yBAAA;EpE6lNR;EoE5mNM;IAAgC,0BAAA;EpE+mNtC;EoE9mNM;;IAEE,8BAAA;EpEgnNR;EoE9mNM;;IAEE,gCAAA;EpEgnNR;EoE9mNM;;IAEE,iCAAA;EpEgnNR;EoE9mNM;;IAEE,+BAAA;EpEgnNR;EoE/nNM;IAAgC,yBAAA;EpEkoNtC;EoEjoNM;;IAEE,6BAAA;EpEmoNR;EoEjoNM;;IAEE,+BAAA;EpEmoNR;EoEjoNM;;IAEE,gCAAA;EpEmoNR;EoEjoNM;;IAEE,8BAAA;EpEmoNR;EoElpNM;IAAgC,uBAAA;EpEqpNtC;EoEppNM;;IAEE,2BAAA;EpEspNR;EoEppNM;;IAEE,6BAAA;EpEspNR;EoEppNM;;IAEE,8BAAA;EpEspNR;EoEppNM;;IAEE,4BAAA;EpEspNR;EoErqNM;IAAgC,yBAAA;EpEwqNtC;EoEvqNM;;IAEE,6BAAA;EpEyqNR;EoEvqNM;;IAEE,+BAAA;EpEyqNR;EoEvqNM;;IAEE,gCAAA;EpEyqNR;EoEvqNM;;IAEE,8BAAA;EpEyqNR;EoExrNM;IAAgC,uBAAA;EpE2rNtC;EoE1rNM;;IAEE,2BAAA;EpE4rNR;EoE1rNM;;IAEE,6BAAA;EpE4rNR;EoE1rNM;;IAEE,8BAAA;EpE4rNR;EoE1rNM;;IAEE,4BAAA;EpE4rNR;EoE3sNM;IAAgC,qBAAA;EpE8sNtC;EoE7sNM;;IAEE,yBAAA;EpE+sNR;EoE7sNM;;IAEE,2BAAA;EpE+sNR;EoE7sNM;;IAEE,4BAAA;EpE+sNR;EoE7sNM;;IAEE,0BAAA;EpE+sNR;EoE9tNM;IAAgC,2BAAA;EpEiuNtC;EoEhuNM;;IAEE,+BAAA;EpEkuNR;EoEhuNM;;IAEE,iCAAA;EpEkuNR;EoEhuNM;;IAEE,kCAAA;EpEkuNR;EoEhuNM;;IAEE,gCAAA;EpEkuNR;EoEjvNM;IAAgC,0BAAA;EpEovNtC;EoEnvNM;;IAEE,8BAAA;EpEqvNR;EoEnvNM;;IAEE,gCAAA;EpEqvNR;EoEnvNM;;IAEE,iCAAA;EpEqvNR;EoEnvNM;;IAEE,+BAAA;EpEqvNR;EoEpwNM;IAAgC,wBAAA;EpEuwNtC;EoEtwNM;;IAEE,4BAAA;EpEwwNR;EoEtwNM;;IAEE,8BAAA;EpEwwNR;EoEtwNM;;IAEE,+BAAA;EpEwwNR;EoEtwNM;;IAEE,6BAAA;EpEwwNR;EoEvxNM;IAAgC,0BAAA;EpE0xNtC;EoEzxNM;;IAEE,8BAAA;EpE2xNR;EoEzxNM;;IAEE,gCAAA;EpE2xNR;EoEzxNM;;IAEE,iCAAA;EpE2xNR;EoEzxNM;;IAEE,+BAAA;EpE2xNR;EoE1yNM;IAAgC,wBAAA;EpE6yNtC;EoE5yNM;;IAEE,4BAAA;EpE8yNR;EoE5yNM;;IAEE,8BAAA;EpE8yNR;EoE5yNM;;IAEE,+BAAA;EpE8yNR;EoE5yNM;;IAEE,6BAAA;EpE8yNR;EoExyNE;IAAmB,uBAAA;EpE2yNrB;EoE1yNE;;IAEE,2BAAA;EpE4yNJ;EoE1yNE;;IAEE,6BAAA;EpE4yNJ;EoE1yNE;;IAEE,8BAAA;EpE4yNJ;EoE1yNE;;IAEE,4BAAA;EpE4yNJ;AACF;AehyNI;EqDjDI;IAAgC,oBAAA;EpEq1NtC;EoEp1NM;;IAEE,wBAAA;EpEs1NR;EoEp1NM;;IAEE,0BAAA;EpEs1NR;EoEp1NM;;IAEE,2BAAA;EpEs1NR;EoEp1NM;;IAEE,yBAAA;EpEs1NR;EoEr2NM;IAAgC,0BAAA;EpEw2NtC;EoEv2NM;;IAEE,8BAAA;EpEy2NR;EoEv2NM;;IAEE,gCAAA;EpEy2NR;EoEv2NM;;IAEE,iCAAA;EpEy2NR;EoEv2NM;;IAEE,+BAAA;EpEy2NR;EoEx3NM;IAAgC,yBAAA;EpE23NtC;EoE13NM;;IAEE,6BAAA;EpE43NR;EoE13NM;;IAEE,+BAAA;EpE43NR;EoE13NM;;IAEE,gCAAA;EpE43NR;EoE13NM;;IAEE,8BAAA;EpE43NR;EoE34NM;IAAgC,uBAAA;EpE84NtC;EoE74NM;;IAEE,2BAAA;EpE+4NR;EoE74NM;;IAEE,6BAAA;EpE+4NR;EoE74NM;;IAEE,8BAAA;EpE+4NR;EoE74NM;;IAEE,4BAAA;EpE+4NR;EoE95NM;IAAgC,yBAAA;EpEi6NtC;EoEh6NM;;IAEE,6BAAA;EpEk6NR;EoEh6NM;;IAEE,+BAAA;EpEk6NR;EoEh6NM;;IAEE,gCAAA;EpEk6NR;EoEh6NM;;IAEE,8BAAA;EpEk6NR;EoEj7NM;IAAgC,uBAAA;EpEo7NtC;EoEn7NM;;IAEE,2BAAA;EpEq7NR;EoEn7NM;;IAEE,6BAAA;EpEq7NR;EoEn7NM;;IAEE,8BAAA;EpEq7NR;EoEn7NM;;IAEE,4BAAA;EpEq7NR;EoEp8NM;IAAgC,qBAAA;EpEu8NtC;EoEt8NM;;IAEE,yBAAA;EpEw8NR;EoEt8NM;;IAEE,2BAAA;EpEw8NR;EoEt8NM;;IAEE,4BAAA;EpEw8NR;EoEt8NM;;IAEE,0BAAA;EpEw8NR;EoEv9NM;IAAgC,2BAAA;EpE09NtC;EoEz9NM;;IAEE,+BAAA;EpE29NR;EoEz9NM;;IAEE,iCAAA;EpE29NR;EoEz9NM;;IAEE,kCAAA;EpE29NR;EoEz9NM;;IAEE,gCAAA;EpE29NR;EoE1+NM;IAAgC,0BAAA;EpE6+NtC;EoE5+NM;;IAEE,8BAAA;EpE8+NR;EoE5+NM;;IAEE,gCAAA;EpE8+NR;EoE5+NM;;IAEE,iCAAA;EpE8+NR;EoE5+NM;;IAEE,+BAAA;EpE8+NR;EoE7/NM;IAAgC,wBAAA;EpEggOtC;EoE//NM;;IAEE,4BAAA;EpEigOR;EoE//NM;;IAEE,8BAAA;EpEigOR;EoE//NM;;IAEE,+BAAA;EpEigOR;EoE//NM;;IAEE,6BAAA;EpEigOR;EoEhhOM;IAAgC,0BAAA;EpEmhOtC;EoElhOM;;IAEE,8BAAA;EpEohOR;EoElhOM;;IAEE,gCAAA;EpEohOR;EoElhOM;;IAEE,iCAAA;EpEohOR;EoElhOM;;IAEE,+BAAA;EpEohOR;EoEniOM;IAAgC,wBAAA;EpEsiOtC;EoEriOM;;IAEE,4BAAA;EpEuiOR;EoEriOM;;IAEE,8BAAA;EpEuiOR;EoEriOM;;IAEE,+BAAA;EpEuiOR;EoEriOM;;IAEE,6BAAA;EpEuiOR;EoEjiOE;IAAmB,uBAAA;EpEoiOrB;EoEniOE;;IAEE,2BAAA;EpEqiOJ;EoEniOE;;IAEE,6BAAA;EpEqiOJ;EoEniOE;;IAEE,8BAAA;EpEqiOJ;EoEniOE;;IAEE,4BAAA;EpEqiOJ;AACF;AezhOI;EqDjDI;IAAgC,oBAAA;EpE8kOtC;EoE7kOM;;IAEE,wBAAA;EpE+kOR;EoE7kOM;;IAEE,0BAAA;EpE+kOR;EoE7kOM;;IAEE,2BAAA;EpE+kOR;EoE7kOM;;IAEE,yBAAA;EpE+kOR;EoE9lOM;IAAgC,0BAAA;EpEimOtC;EoEhmOM;;IAEE,8BAAA;EpEkmOR;EoEhmOM;;IAEE,gCAAA;EpEkmOR;EoEhmOM;;IAEE,iCAAA;EpEkmOR;EoEhmOM;;IAEE,+BAAA;EpEkmOR;EoEjnOM;IAAgC,yBAAA;EpEonOtC;EoEnnOM;;IAEE,6BAAA;EpEqnOR;EoEnnOM;;IAEE,+BAAA;EpEqnOR;EoEnnOM;;IAEE,gCAAA;EpEqnOR;EoEnnOM;;IAEE,8BAAA;EpEqnOR;EoEpoOM;IAAgC,uBAAA;EpEuoOtC;EoEtoOM;;IAEE,2BAAA;EpEwoOR;EoEtoOM;;IAEE,6BAAA;EpEwoOR;EoEtoOM;;IAEE,8BAAA;EpEwoOR;EoEtoOM;;IAEE,4BAAA;EpEwoOR;EoEvpOM;IAAgC,yBAAA;EpE0pOtC;EoEzpOM;;IAEE,6BAAA;EpE2pOR;EoEzpOM;;IAEE,+BAAA;EpE2pOR;EoEzpOM;;IAEE,gCAAA;EpE2pOR;EoEzpOM;;IAEE,8BAAA;EpE2pOR;EoE1qOM;IAAgC,uBAAA;EpE6qOtC;EoE5qOM;;IAEE,2BAAA;EpE8qOR;EoE5qOM;;IAEE,6BAAA;EpE8qOR;EoE5qOM;;IAEE,8BAAA;EpE8qOR;EoE5qOM;;IAEE,4BAAA;EpE8qOR;EoE7rOM;IAAgC,qBAAA;EpEgsOtC;EoE/rOM;;IAEE,yBAAA;EpEisOR;EoE/rOM;;IAEE,2BAAA;EpEisOR;EoE/rOM;;IAEE,4BAAA;EpEisOR;EoE/rOM;;IAEE,0BAAA;EpEisOR;EoEhtOM;IAAgC,2BAAA;EpEmtOtC;EoEltOM;;IAEE,+BAAA;EpEotOR;EoEltOM;;IAEE,iCAAA;EpEotOR;EoEltOM;;IAEE,kCAAA;EpEotOR;EoEltOM;;IAEE,gCAAA;EpEotOR;EoEnuOM;IAAgC,0BAAA;EpEsuOtC;EoEruOM;;IAEE,8BAAA;EpEuuOR;EoEruOM;;IAEE,gCAAA;EpEuuOR;EoEruOM;;IAEE,iCAAA;EpEuuOR;EoEruOM;;IAEE,+BAAA;EpEuuOR;EoEtvOM;IAAgC,wBAAA;EpEyvOtC;EoExvOM;;IAEE,4BAAA;EpE0vOR;EoExvOM;;IAEE,8BAAA;EpE0vOR;EoExvOM;;IAEE,+BAAA;EpE0vOR;EoExvOM;;IAEE,6BAAA;EpE0vOR;EoEzwOM;IAAgC,0BAAA;EpE4wOtC;EoE3wOM;;IAEE,8BAAA;EpE6wOR;EoE3wOM;;IAEE,gCAAA;EpE6wOR;EoE3wOM;;IAEE,iCAAA;EpE6wOR;EoE3wOM;;IAEE,+BAAA;EpE6wOR;EoE5xOM;IAAgC,wBAAA;EpE+xOtC;EoE9xOM;;IAEE,4BAAA;EpEgyOR;EoE9xOM;;IAEE,8BAAA;EpEgyOR;EoE9xOM;;IAEE,+BAAA;EpEgyOR;EoE9xOM;;IAEE,6BAAA;EpEgyOR;EoE1xOE;IAAmB,uBAAA;EpE6xOrB;EoE5xOE;;IAEE,2BAAA;EpE8xOJ;EoE5xOE;;IAEE,6BAAA;EpE8xOJ;EoE5xOE;;IAEE,8BAAA;EpE8xOJ;EoE5xOE;;IAEE,4BAAA;EpE8xOJ;AACF;AelxOI;EqDjDI;IAAgC,oBAAA;EpEu0OtC;EoEt0OM;;IAEE,wBAAA;EpEw0OR;EoEt0OM;;IAEE,0BAAA;EpEw0OR;EoEt0OM;;IAEE,2BAAA;EpEw0OR;EoEt0OM;;IAEE,yBAAA;EpEw0OR;EoEv1OM;IAAgC,0BAAA;EpE01OtC;EoEz1OM;;IAEE,8BAAA;EpE21OR;EoEz1OM;;IAEE,gCAAA;EpE21OR;EoEz1OM;;IAEE,iCAAA;EpE21OR;EoEz1OM;;IAEE,+BAAA;EpE21OR;EoE12OM;IAAgC,yBAAA;EpE62OtC;EoE52OM;;IAEE,6BAAA;EpE82OR;EoE52OM;;IAEE,+BAAA;EpE82OR;EoE52OM;;IAEE,gCAAA;EpE82OR;EoE52OM;;IAEE,8BAAA;EpE82OR;EoE73OM;IAAgC,uBAAA;EpEg4OtC;EoE/3OM;;IAEE,2BAAA;EpEi4OR;EoE/3OM;;IAEE,6BAAA;EpEi4OR;EoE/3OM;;IAEE,8BAAA;EpEi4OR;EoE/3OM;;IAEE,4BAAA;EpEi4OR;EoEh5OM;IAAgC,yBAAA;EpEm5OtC;EoEl5OM;;IAEE,6BAAA;EpEo5OR;EoEl5OM;;IAEE,+BAAA;EpEo5OR;EoEl5OM;;IAEE,gCAAA;EpEo5OR;EoEl5OM;;IAEE,8BAAA;EpEo5OR;EoEn6OM;IAAgC,uBAAA;EpEs6OtC;EoEr6OM;;IAEE,2BAAA;EpEu6OR;EoEr6OM;;IAEE,6BAAA;EpEu6OR;EoEr6OM;;IAEE,8BAAA;EpEu6OR;EoEr6OM;;IAEE,4BAAA;EpEu6OR;EoEt7OM;IAAgC,qBAAA;EpEy7OtC;EoEx7OM;;IAEE,yBAAA;EpE07OR;EoEx7OM;;IAEE,2BAAA;EpE07OR;EoEx7OM;;IAEE,4BAAA;EpE07OR;EoEx7OM;;IAEE,0BAAA;EpE07OR;EoEz8OM;IAAgC,2BAAA;EpE48OtC;EoE38OM;;IAEE,+BAAA;EpE68OR;EoE38OM;;IAEE,iCAAA;EpE68OR;EoE38OM;;IAEE,kCAAA;EpE68OR;EoE38OM;;IAEE,gCAAA;EpE68OR;EoE59OM;IAAgC,0BAAA;EpE+9OtC;EoE99OM;;IAEE,8BAAA;EpEg+OR;EoE99OM;;IAEE,gCAAA;EpEg+OR;EoE99OM;;IAEE,iCAAA;EpEg+OR;EoE99OM;;IAEE,+BAAA;EpEg+OR;EoE/+OM;IAAgC,wBAAA;EpEk/OtC;EoEj/OM;;IAEE,4BAAA;EpEm/OR;EoEj/OM;;IAEE,8BAAA;EpEm/OR;EoEj/OM;;IAEE,+BAAA;EpEm/OR;EoEj/OM;;IAEE,6BAAA;EpEm/OR;EoElgPM;IAAgC,0BAAA;EpEqgPtC;EoEpgPM;;IAEE,8BAAA;EpEsgPR;EoEpgPM;;IAEE,gCAAA;EpEsgPR;EoEpgPM;;IAEE,iCAAA;EpEsgPR;EoEpgPM;;IAEE,+BAAA;EpEsgPR;EoErhPM;IAAgC,wBAAA;EpEwhPtC;EoEvhPM;;IAEE,4BAAA;EpEyhPR;EoEvhPM;;IAEE,8BAAA;EpEyhPR;EoEvhPM;;IAEE,+BAAA;EpEyhPR;EoEvhPM;;IAEE,6BAAA;EpEyhPR;EoEnhPE;IAAmB,uBAAA;EpEshPrB;EoErhPE;;IAEE,2BAAA;EpEuhPJ;EoErhPE;;IAEE,6BAAA;EpEuhPJ;EoErhPE;;IAEE,8BAAA;EpEuhPJ;EoErhPE;;IAEE,4BAAA;EpEuhPJ;AACF;AqEjkPA;EAAkB,iGhEqPY;AL+0O9B;;AqEhkPA;EAAiB,8BAAA;ArEokPjB;;AqEnkPA;EAAiB,8BAAA;ArEukPjB;;AqEtkPA;ECRE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEklPF;;AqEpkPI;EAAwB,2BAAA;ArEwkP5B;;AqEvkPI;EAAwB,4BAAA;ArE2kP5B;;AqE1kPI;EAAwB,6BAAA;ArE8kP5B;;AexiPI;EsDxCA;IAAwB,2BAAA;ErEqlP1B;EqEplPE;IAAwB,4BAAA;ErEulP1B;EqEtlPE;IAAwB,6BAAA;ErEylP1B;AACF;AepjPI;EsDxCA;IAAwB,2BAAA;ErEgmP1B;EqE/lPE;IAAwB,4BAAA;ErEkmP1B;EqEjmPE;IAAwB,6BAAA;ErEomP1B;AACF;Ae/jPI;EsDxCA;IAAwB,2BAAA;ErE2mP1B;EqE1mPE;IAAwB,4BAAA;ErE6mP1B;EqE5mPE;IAAwB,6BAAA;ErE+mP1B;AACF;Ae1kPI;EsDxCA;IAAwB,2BAAA;ErEsnP1B;EqErnPE;IAAwB,4BAAA;ErEwnP1B;EqEvnPE;IAAwB,6BAAA;ErE0nP1B;AACF;AqErnPA;EAAmB,oCAAA;ArEwnPnB;;AqEvnPA;EAAmB,oCAAA;ArE2nPnB;;AqE1nPA;EAAmB,qCAAA;ArE8nPnB;;AqE1nPA;EAAsB,2BAAA;ArE8nPtB;;AqE7nPA;EAAsB,2BAAA;ArEioPtB;;AqEhoPA;EAAsB,2BAAA;ArEooPtB;;AqEnoPA;EAAsB,6BAAA;ArEuoPtB;;AqEnoPA;EAAc,yBAAA;ArEuoPd;;AuE3qPE;EACE,yBAAA;AvE8qPJ;;AMpqPE;EiENI,mEAAA;AvE8qPN;;AuEnrPE;EACE,yBAAA;AvEsrPJ;;AM5qPE;EiENI,0DAAA;AvEsrPN;;AuE3rPE;EACE,yBAAA;AvE8rPJ;;AMprPE;EiENI,oEAAA;AvE8rPN;;AuEnsPE;EACE,yBAAA;AvEssPJ;;AM5rPE;EiENI,kEAAA;AvEssPN;;AuE3sPE;EACE,yBAAA;AvE8sPJ;;AMpsPE;EiENI,6CAAA;AvE8sPN;;AuEntPE;EACE,yBAAA;AvEstPJ;;AM5sPE;EiENI,6CAAA;AvEstPN;;AuE3tPE;EACE,yBAAA;AvE8tPJ;;AMptPE;EiENI,mDAAA;AvE8tPN;;AuEnuPE;EACE,yBAAA;AvEsuPJ;;AM5tPE;EiENI,kEAAA;AvEsuPN;;AqEjsPA;EAAa,yBAAA;ArEqsPb;;AqEpsPA;EAAc,yBAAA;ArEwsPd;;AqEtsPA;EAAiB,oCAAA;ArE0sPjB;;AqEzsPA;EAAiB,0CAAA;ArE6sPjB;;AqEzsPA;EGpDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AxEiwPF;;AyEpwPA;ECCE,8BAAA;A1EuwPF;;AyEpwPA;ECHE,6BAAA;A1E2wPF;;A2ErwPE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E3EqwPJ;E2EjwPI;IACE,0BAAA;E3EmwPN;E2E1vPE;IACE,6BAAA;E3E4vPJ;E2E9uPE;IACE,gCAAA;E3EgvPJ;E2E9uPE;;IAEE,yBAAA;IACA,wBAAA;E3EgvPJ;E2ExuPE;IACE,2BAAA;E3E0uPJ;E2EvuPE;;IAEE,wBAAA;E3EyuPJ;E2EtuPE;;;IAGE,UAAA;IACA,SAAA;E3EwuPJ;E2EruPE;;IAEE,uBAAA;E3EuuPJ;E2E/tPE;IACE,QtE81B8B;ELm4NlC;E2E/tPE;IACE,2BAAA;E3EiuPJ;E2E/tPE;IACE,2BAAA;E3EiuPJ;E2E7tPE;IACE,aAAA;E3E+tPJ;E2E7tPE;IACE,sBAAA;E3E+tPJ;E2E5tPE;IACE,oCAAA;E3E8tPJ;E2E5tPI;;IAEE,oCAAA;E3E8tPN;E2EztPI;;IAEE,oCAAA;E3E2tPN;E2EvtPE;IACE,cAAA;E3EytPJ;E2EvtPI;;;;IAIE,qBtEpHG;EL60PT;E2ErtPE;IACE,cAAA;IACA,qBtE1HK;ELi1PT;AACF;AC/1PA;;;;;CAAA;AAcA,eAAA;AAQA,kBAAA;AAeA,eAAA;AAoBA,eAAA;AAQA,iBAAA;AAOA,WAAA;A2EtEA;;mBAAA;AAGA;EACI,mB3EwBG;ADm1PP;;A4Ex2PA;;mBAAA;AAGA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,kCAAA;A5E22PJ;A4E12PI;EACI,c3EqCA;E2EpCA,gBAAA;EACA,eAAA;EACA,mBAAA;A5E42PR;A4E12PI;EACI,c3E+BA;E2E9BA,iBAAA;A5E42PR;;A4Ez2PA;;mBAAA;AAIA;EACI,eAAA;A5E22PJ;A4E12PI;EACI,cAAA;A5E42PR;A4E32PQ;EACI,iBAAA;EACA,c3EZJ;E2EaI,gBAAA;A5E62PZ;A4E52PY;EACI,c3EpBN;ADk4PV;A4E32PQ;EACI,iBAAA;A5E62PZ;;A4Ez2PA;;mBAAA;AAIA;EACI,eAAA;A5E22PJ;A4E12PI;EACI,cAAA;A5E42PR;A4E32PQ;EACI,iBAAA;EACA,c3EJJ;E2EKI,gBAAA;A5E62PZ;A4E52PY;EACI,c3EtCT;ADo5PP;A4E32PQ;EACI,iBAAA;A5E62PZ;;A4Ex2PA;;mBAAA;AAGA;EACI,cAAA;EACA,yD3EMY;E2ELZ,sBAAA;EACA,kCAAA;A5E22PJ;A4E12PI;EACI,c3EzBA;E2E0BA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A5E42PR;A4E12PI;EACI,c3EhCA;AD44PR;;A4Ez2PA;EAEQ;IACI,eAAA;IACA,iBAAA;E5E22PV;AACF;A4Ev2PA;;mBAAA;AAIA;EACI,cAAA;A5Ew2PJ;A4Ev2PI;EACI,gBAAA;EACA,iBAAA;A5Ey2PR;A4Ex2PQ;EACI,gCAAA;A5E02PZ;;A4Er2PA;EAEQ;IACI,iBAAA;IACA,eAAA;E5Eu2PV;AACF;A4En2PA;;mBAAA;AAIA;EACI,+CAAA;EACA,yD3E9CU;ADk5Pd;A4En2PI;EACI,eAAA;EACA,cAAA;EACA,oBAAA;A5Eq2PR;A4En2PI;EACI,iBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;A5Eq2PR;A4En2PI;EACI,c3ElIG;E2EmIH,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,6CAAA;EACA,uBAAA;A5Eq2PR;A4En2PI;EACI,4BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;EACA,gCAAA;A5Eq2PR;A4En2PQ;EACI,YAAA;A5Eq2PZ;;A4Eh2PA;EACI;IACI,+BAAA;E5Em2PN;AACF;A4Eh2PA;EACI;IACI,+BAAA;E5Ek2PN;AACF;A4E/1PA;EACI;IACI,iCAAA;E5Ei2PN;AACF;A4E91PA;EACI;IACI,uCAAA;E5Eg2PN;E4E91PM;IACI,eAAA;E5Eg2PV;E4E91PM;IACI,UAAA;E5Eg2PV;E4E91PM;IACI,eAAA;E5Eg2PV;AACF;A4E51PA;EACI;IACI,uBAAA;IACA,gBAAA;E5E81PN;E4E51PE;IACI,sCAAA;IACA,oBAAA;E5E81PN;E4E51PM;IACI,eAAA;E5E81PV;AACF;A4E11PA;EACI;IACI,eAAA;E5E41PN;E4E11PE;IACI,qBAAA;IACA,iCAAA;E5E41PN;E4E11PM;IACI,eAAA;E5E41PV;E4E11PM;IACI,gBAAA;E5E41PV;AACF;A4Ex1PA;EACI;IACI,sBAAA;E5E01PN;AACF;A4Ev1PA;EAEQ;IACI,eAAA;IACA,iBAAA;E5Ew1PV;E4Et1PM;IACI,4BAAA;IACA,iBAAA;E5Ew1PV;E4Et1PM;IACI,4BAAA;IACA,eAAA;E5Ew1PV;AACF;A4Ep1PA;EAEQ;IACI,eAAA;E5Eq1PV;AACF;A4Ej1PA;;mBAAA;AAKI;EACI,eAAA;EACA,WAAA;EACA,c3ElQK;E2EmQL,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;A5Ei1PR;;A4E70PA;;mBAAA;AAGA;EACI,gBAAA;A5Eg1PJ;A4E90PQ;EACI,gBAAA;A5Eg1PZ;A4E70PI;EACI,WAAA;EACA,cAAA;EACA,eAAA;A5E+0PR;;A4E30PA;;mBAAA;AAGA;EACI,kBAAA;A5E80PJ;;A4E50PA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;A5E+0PJ;;A4E50PA;;mBAAA;AAGA;EACI,gBAAA;A5E+0PJ;A4E90PI;EACI,wBAAA;A5Eg1PR;A4E/0PQ;EACI,qBAAA;A5Ei1PZ;;A4E50PA;;mBAAA;AAKQ;EACI,UAAA;EACA,eAAA;A5E60PZ;A4E30PQ;EACI,2BAAA;EACA,4BAAA;A5E60PZ;;A4Ex0PA;;mBAAA;AAII;EACI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;A5E00PR;A4Ez0PQ;EACI,0D3E1QP;ADqlQL;A4Ez0PQ;EACI,0D3E5QP;ADulQL;A4Ez0PQ;EACI,0D3E9QP;ADylQL;A4Ez0PQ;EACI,0D3EhRP;AD2lQL;A4Ez0PQ;EACI,oCAAA;EACA,aAAA;A5E20PZ;A4Ez0PY;EACI,kBAAA;EACA,QAAA;EACA,kBAAA;A5E20PhB;A4E10PgB;EACI,c3E3TZ;E2E4TY,eAAA;EACA,wBAAA;EACA,cAAA;A5E40PpB;A4E30PoB;EAEI,sCAAA;A5E40PxB;A4Et0PY;EACI,cAAA;A5Ew0PhB;A4Ep0PI;EACI,kBAAA;A5Es0PR;A4Ep0PI;EACI,kBAAA;EACA,eAAA;A5Es0PR;;A4El0PA;;mBAAA;AAMU;EACI,aAAA;A5Ek0Pd;A4Eh0PU;EACI,iBAAA;A5Ek0Pd;A4E/zPc;EACI,WAAA;A5Ei0PlB;A4E9zPU;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;A5Eg0Pd;;A4E3zPA;;mBAAA;AAKI;EACM,wBAAA;A5E4zPV;A4E3zPU;EACI,4BAAA;A5E6zPd;A4E1zPI;EACI,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,c3E/XA;E2EgYA,kB3ErXC;E2EsXD,kBAAA;A5E4zPR;A4E3zPQ;EACI,cAAA;EACA,eAAA;EACA,iBAAA;A5E6zPZ;;A4ExzPA;;mBAAA;AAGA;EAEQ;IACQ,eAAA;IACA,iBAAA;E5E0zPd;E4EvzPE;IACI,mB3EjbD;ED0uQL;AACF;A6EzwQA;;;;;CAAA;A5EAA;;;;;CAAA;AAcA,eAAA;AAQA,kBAAA;AAeA,eAAA;AAoBA,eAAA;AAQA,iBAAA;AAOA,WAAA;A4EjEA;;mBAAA;AAIA;;mBAAA;AAIA;EACI,aAAA;A7EoxQJ;;A6EjxQA;EACI,mB5ELQ;E4EMR,qC5EZM;E4EaN,SAAA;EACA,kBAAA;EACA,c5EPO;E4EQP,gBAAA;A7EoxQJ;;A6EjxQA;EACI,kBAAA;EACA,gBAAA;EACA,mB5E2BI;ADyvQR;;A6EjxQA;;EAEI,qBAAA;A7EoxQJ;;A6EjxQA;EACI,c5ExBU;AD4yQd;A6ElxQI;EAEI,c5E1BK;AD6yQb;;A6E/wQA;EACI,c5ESI;ADywQR;A6EhxQI;EAEI,c5EvBD;ADwyQP;;A6E7wQA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;A7EgxQJ;;A6E7wQA;EACI,kB5EKK;AD2wQT;;A6E7wQA;;EAEI,oBAAA;A7EgxQJ;;A6E5wQA;;mBAAA;AAIA;;;;;;EAMI,c5EnEU;E4EoEV,qC5EzES;ADu1Qb;;A6E3wQA;EACI,iBAAA;EACA,eAAA;A7E8wQJ;;A6E3wQA;EACI,iBAAA;EACA,eAAA;A7E8wQJ;;A6E3wQA;EACI,iBAAA;EACA,eAAA;A7E8wQJ;;A6E3wQA;EACI,iBAAA;EACA,eAAA;A7E8wQJ;;A6E3wQA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;A7E8wQJ;;A6E3wQA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;A7E8wQJ;;A6E3wQA;EACI,eAAA;A7E8wQJ;;A6E3wQA;EACI,eAAA;A7E8wQJ;;A6E3wQA;EACI,eAAA;A7E8wQJ;;A6E3wQA;EACI,kB5E/DK;E4EgEL,aAAA;A7E8wQJ;;A6E1wQI;EACI,qBAAA;A7E6wQR;A6E1wQI;EACI,cAAA;A7E4wQR;;A6EtwQI;;EAEI,mBAAA;A7EywQR;;A6ErwQA;EACI,mBAAA;A7EwwQJ;;A6ErwQA;;mBAAA;AAIA;EACI,8BAAA;EACA,2CAAA;EACA,aAAA;A7EuwQJ;;A6EpwQA;EACI,WAAA;A7EuwQJ;;A6EpwQA;EACI,aAAA;A7EuwQJ;;A6EnwQA;;mBAAA;AAKI;EACI,YAAA;A7EowQR;A6EjwQI;EACI,aAAA;A7EmwQR;A6EhwQI;EACI,aAAA;A7EkwQR;A6E/vQI;EACI,aAAA;A7EiwQR;A6E9vQI;EACI,aAAA;A7EgwQR;A6E7vQI;EACI,aAAA;A7E+vQR;A6E5vQI;EACI,iBAAA;A7E8vQR;A6E3vQI;EACI,kBAAA;A7E6vQR;A6E1vQI;EACI,kBAAA;A7E4vQR;A6EzvQI;EACI,kBAAA;A7E2vQR;A6ExvQI;EACI,mBAAA;A7E0vQR;A6EvvQI;EACI,mBAAA;A7EyvQR;A6EtvQI;EACI,mBAAA;A7EwvQR;A6ErvQI;EACI,mBAAA;A7EuvQR;A6EpvQI;EACI,gBAAA;A7EsvQR;A6EnvQI;EACI,iBAAA;A7EqvQR;A6ElvQI;EACI,iBAAA;A7EovQR;A6EjvQI;EACI,iBAAA;A7EmvQR;A6EhvQI;EACI,mBAAA;A7EkvQR;A6E/uQI;EACI,mBAAA;A7EivQR;A6E9uQI;EACI,oBAAA;A7EgvQR;A6E7uQI;EACI,oBAAA;A7E+uQR;A6E5uQI;EACI,oBAAA;A7E8uQR;A6E3uQI;EACI,oBAAA;A7E6uQR;;A6ExuQA;;mBAAA;AAKI;EACI,WAAA;A7EyuQR;A6EtuQI;EACI,gBAAA;A7EwuQR;A6EruQI;EACI,iBAAA;A7EuuQR;A6EpuQI;EACI,iBAAA;A7EsuQR;A6EnuQI;EACI,iBAAA;A7EquQR;A6EluQI;EACI,iBAAA;A7EouQR;A6EjuQI;EACI,iBAAA;A7EmuQR;A6EhuQI;EACI,iBAAA;A7EkuQR;A6E/tQI;EACI,kBAAA;A7EiuQR;A6E9tQI;EACI,kBAAA;A7EguQR;A6E7tQI;EACI,kBAAA;A7E+tQR;A6E5tQI;EACI,kBAAA;A7E8tQR;A6E3tQI;EACI,kBAAA;A7E6tQR;A6E1tQI;EACI,eAAA;A7E4tQR;A6EztQI;EACI,eAAA;A7E2tQR;A6ExtQI;EACI,gBAAA;A7E0tQR;A6EvtQI;EACI,gBAAA;A7EytQR;A6EttQI;EACI,gBAAA;A7EwtQR;A6ErtQI;EACI,gBAAA;A7EutQR;A6EptQI;EACI,gBAAA;A7EstQR;A6EntQI;EACI,kBAAA;A7EqtQR;A6EltQI;EACI,kBAAA;A7EotQR;A6EjtQI;EACI,mBAAA;A7EmtQR;A6EhtQI;EACI,mBAAA;A7EktQR;A6E/sQI;EACI,mBAAA;A7EitQR;A6E9sQI;EACI,mBAAA;A7EgtQR;A6E7sQI;EACI,mBAAA;A7E+sQR;;A6E1sQA;;mBAAA;AAKI;EACI,mBAAA;A7E2sQR;A6ExsQI;EACI,sBAAA;A7E0sQR;A6EvsQI;EACI,sBAAA;A7EysQR;;A6EpsQA;;mBAAA;AAGA;EACI,YAAA;A7EusQJ;;A6EpsQA;EACI,YAAA;A7EusQJ;;A6EpsQA;EACI,YAAA;A7EusQJ;;A6EpsQA;EACI,YAAA;A7EusQJ;;A6EpsQA;;mBAAA;AAKI;EACI,gBAAA;A7EqsQR;A6ElsQI;EACI,gBAAA;A7EosQR;A6EjsQI;EACI,mBAAA;A7EmsQR;A6EhsQI;EACI,gBAAA;A7EksQR;A6E/rQI;EACI,gBAAA;A7EisQR;A6E9rQI;EACI,eAAA;A7EgsQR;A6E7rQI;EACI,eAAA;A7E+rQR;A6E5rQI;EACI,eAAA;A7E8rQR;A6E3rQI;EACI,eAAA;A7E6rQR;A6E1rQI;EACI,eAAA;A7E4rQR;A6EzrQI;EACI,eAAA;A7E2rQR;A6ExrQI;EACI,8BAAA;A7E0rQR;;A6ErrQA;;mBAAA;AAKI;EACI,uBAAA;A7EsrQR;A6EnrQI;EACI,iDAAA;A7EqrQR;A6ElrQI;EACI,gDAAA;A7EorQR;A6EjrQI;EACI,kDAAA;A7EmrQR;A6EhrQI;EACI,+CAAA;A7EkrQR;A6E/qQI;EACI,sDAAA;A7EirQR;;A6E5qQA;;mBAAA;AAIA;EACI,YAAA;EACA,WAAA;A7E8qQJ;;A6E3qQA;EACI,YAAA;EACA,WAAA;A7E8qQJ;;A6E3qQA;EACI,YAAA;EACA,WAAA;A7E8qQJ;;A6E3qQA;EACI,aAAA;A7E8qQJ;;A6E3qQA;EACI,mBAAA;A7E8qQJ;;A6E3qQA;EACI,kB5E9dK;AD4oRT;;A6E1qQA;;mBAAA;AAIA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;EACI,yBAAA;A7E4qQJ;;A6EzqQA;E5E5fE,mBAAA;EAEA,+DAAA;E4E4fE,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,4BAAA;A7E8qQJ;;A6E3qQA;E5EpgBE,mBAAA;EAEA,+DAAA;E4EogBE,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,4BAAA;A7EgrQJ;;A6E5qQI;EACI,c5E3hBD;AD0sRP;A6E5qQI;EACI,c5EhiBC;AD8sRT;A6E3qQI;EACI,yBAAA;A7E6qQR;A6E1qQI;EACI,c5EtiBA;ADktRR;A6EzqQI;EACI,c5ExlBG;ADmwRX;A6ExqQI;EACI,c5E3lBK;ADqwRb;;A6ErqQA;;mBAAA;AAIA;EACI,oCAAA;A7EuqQJ;;A6EpqQA;EACI,oCAAA;A7EuqQJ;;A6EpqQA;EACI,oCAAA;A7EuqQJ;;A6EpqQA;EACI,oCAAA;A7EuqQJ;;A6EpqQA;EACI,oCAAA;A7EuqQJ;;A6EpqQA;EACI,oCAAA;A7EuqQJ;;A6EpqQA;EACI,yB5EnlBK;AD0vRT;;A6EpqQA;EACI,yB5EjnBO;ADwxRX;;A6EpqQA;EACI,yB5EpnBM;AD2xRV;;A6EpqQA;E5E/kBE,mBAAA;EAEA,+DAAA;ADuvRF;;A6EtqQA;E5EnlBE,mBAAA;EAEA,+DAAA;AD6vRF;;A6ExqQA;E5EvlBE,mBAAA;EAEA,+DAAA;ADmwRF;;A6EzqQI;EACI,yB5EzmBA;ADqxRR;A6EzqQI;EACI,yB5E1pBK;ADq0Rb;A6ExqQI;EACI,yB5EppBE;AD8zRV;A6EvqQI;EACI,yB5EvnBC;ADgyRT;A6EtqQI;EACI,oCAAA;A7EwqQR;A6ErqQI;EACI,yB5EnpBQ;AD0zRhB;A6EpqQI;EACI,yB5EzpBQ;AD+zRhB;A6EnqQI;EACI,yB5E1pBK;AD+zRb;A6ElqQI;EACI,yB5ExqBM;AD40Rd;A6EjqQI;EACI,yB5EpqBQ;ADu0RhB;A6EhqQI;EACI,yB5E1qBO;AD40Rf;A6E/pQI;EACI,yB5EzqBQ;AD00RhB;A6E9pQI;EACI,yB5EzrBA;ADy1RR;A6E7pQI;EACI,yB5ElqBA;ADi0RR;;A6E1pQA;;mBAAA;AAIA;EACI,iBAAA;EACA,c5E7qBI;E4E8qBJ,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mB5EntBG;AD+2RP;A6E1pQI;EACI,mBAAA;A7E4pQR;;A6ExpQA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;A7E2pQJ;;A6ExpQA;EACI,mB5EluBG;AD63RP;;A6ExpQA;EACI,mB5ExuBM;ADm4RV;;A6ExpQA;EACI,mB5E9uBK;ADy4RT;;A6ExpQA;EACI,mB5EjvBM;AD44RV;;A6ExpQA;EACI,mB5EnvBM;AD84RV;;A6EvpQA;;mBAAA;AAIA;EACI,iBAAA;EACA,iBAAA;EACA,c5E9tBI;E4E+tBJ,gBAAA;EACA,kB5ErtBK;E4EstBL,cAAA;A7EypQJ;;A6EtpQA;EACI,mBAAA;A7EypQJ;;A6EtpQA;EACI,yB5EpuBI;AD63RR;;A6EtpQA;EACI,yB5E/wBM;ADw6RV;;A6EtpQA;EACI,yB5EhxBG;ADy6RP;;A6EtpQA;EACI,yB5EtxBM;AD+6RV;;A6EtpQA;EACI,yB5E5xBK;ADq7RT;;A6EtpQA;EACI,yB5ExvBI;ADi5RR;;A6EtpQA;EACI,yB5EjyBM;AD07RV;;A6EtpQA;EACI,yB5ElwBK;AD25RT;;A6EtpQA;EACI,yB5ExwBE;ADi6RN;;A6EtpQA;EACI,yB5E3yBM;ADo8RV;;A6EtpQA;EACI,yB5E5yBI;ADq8RR;;A6EtpQA;EACI,yB5ErxBI;AD86RR;;A6EtpQA;EACI,yB5E5yBY;E4E6yBZ,c5E5zBM;ADq9RV;;A6EtpQA;EACI,yB5E9yBS;E4E+yBT,c5E9zBG;ADu9RP;;A6EtpQA;EACI,yB5ErzBY;E4EszBZ,c5Er0BM;AD89RV;;A6EtpQA;EACI,yB5E5zBW;E4E6zBX,c5E50BK;ADq+RT;;A6EtpQA;EACI,yB5E3zBU;E4E4zBV,c5EzyBI;ADk8RR;;A6EtpQA;EACI,yB5En0BY;E4Eo0BZ,c5En1BM;AD4+RV;;A6EtpQA;EACI,yB5Et0BY;E4Eu0BZ,c5Et1BM;AD++RV;;A6ErpQA;;kBAAA;AAIA;EACI,gBAAA;A7EupQJ;;A6EppQA;EACI,cAAA;A7EupQJ;;A6EppQA;;EAKI,6BAAA;A7EupQJ;;A6EppQA;EACI,yB5En3BM;AD0gSV;;A6EppQA;EACI,yB5Ep3BG;AD2gSP;;A6EppQA;EACI,yB5Ez3BM;ADghSV;;A6EppQA;EACI,yB5E93BM;ADqhSV;;A6EppQA;EACI,yB5Ep4BK;AD2hST;;A6EppQA;EACI,yB5El2BK;ADy/RT;;A6EppQA;EACI,yB5Ex2BE;AD+/RN;;A6EppQA;EACI,yB5E34BM;ADkiSV;;A6EnpQA;;kBAAA;AAIA;EACI,WAAA;EACA,YAAA;A7EqpQJ;A6EnpQI;EACI,gBAAA;A7EqpQR;A6EnpQQ;EACI,c5Et6BD;E4Eu6BC,gBAAA;EACA,cAAA;EACA,qBAAA;A7EqpQZ;A6EnpQY;EACI,c5E36BH;ADgkSb;;A6E9oQA;;kBAAA;AAIA;EACI,iBAAA;EACA,c5Ez7BO;ADykSX;;A6E7oQA;;kBAAA;AAGA;EACI,c5Ev5BI;E4Ew5BJ,kBAAA;EACA,eAAA;EACA,yCAAA;EACA,cAAA;A7EgpQJ;A6E9oQI;EACI,c5E95BA;AD8iSR;A6E7oQI;EACI,gBAAA;A7E+oQR;;A6E3oQA;EACI,gBAAA;EACA,c5Ep8BG;E4Eq8BH,kBAAA;A7E8oQJ;A6E5oQI;EACI,gCAAA;A7E8oQR;A6E3oQI;EACI,c5El9BE;AD+lSV;;A6EzoQA;EACI,c5Ej9BG;AD6lSP;A6E1oQI;EACI,mB5Ep9BD;E4Eq9BC,c5Ez7BA;E4E07BA,qB5Et9BD;ADkmSP;;A6ExoQA;EACI,uBAAA;EACA,kBAAA;A7E2oQJ;;A6ExoQA;EACI,kBAAA;EACA,eAAA;A7E2oQJ;;A6ExoQA;EACI,uBAAA;EACA,eAAA;A7E2oQJ;;A6ExoQA;EACI,uBAAA;EACA,eAAA;A7E2oQJ;;A6ExoQA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;A7E2oQJ;A6EzoQI;EACI,kBAAA;A7E2oQR;;A6EvoQA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;A7E0oQJ;;A6EvoQA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;A7E0oQJ;;A6EvoQA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;A7E0oQJ;;A6EvoQA;EACI,mBAAA;EACA,2BAAA;A7E0oQJ;;A6EvoQA;EACI,kBAAA;A7E0oQJ;A6ExoQI;EACI,qBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;A7E0oQR;A6EvoQI;EAEI,mCAAA;A7EwoQR;A6EroQI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;A7EuoQR;A6EpoQI;EAEI,UAAA;EACA,YAAA;A7EqoQR;;A6EjoQA;;EAEI,mB5E5jCM;E4E6jCN,yBAAA;EAEA,wBAAA;A7EmoQJ;A6EjoQI;;EACI,mB5EziCO;E4E0iCP,yBAAA;A7EooQR;A6EjoQI;;;;EAGI,mB5EhjCO;ADorSf;;A6EhoQA;;EAEI,mB5EvlCS;E4EwlCT,c5EhjCI;E4EijCJ,yBAAA;A7EmoQJ;A6EjoQI;;EACI,mB5E1lCU;E4E4lCV,yBAAA;A7EmoQR;A6EhoQI;;;;EAGI,mB5ElmCU;ADquSlB;;A6E9nQA;;EAEI,mB5ErmCM;E4EsmCN,yBAAA;A7EioQJ;A6E/nQI;;EACI,mB5EhlCO;E4EilCP,yBAAA;A7EkoQR;A6E/nQI;;;;EAGI,mB5EvlCO;ADytSf;;A6E7nQA;;EAEI,mB5EpnCG;E4EqnCH,yBAAA;EAEA,wBAAA;A7E+nQJ;A6E7nQI;;EACI,mB5EjmCI;E4EkmCJ,yBAAA;A7EgoQR;A6E5nQI;;;;EAGI,mB5EzmCI;ADwuSZ;;A6E1nQA;;EAEI,mB5E3oCM;E4E4oCN,c5E3mCI;E4E4mCJ,yBAAA;A7E6nQJ;A6E3nQI;;EACI,mB5EvnCO;E4EwnCP,c5EhnCA;E4EknCA,yBAAA;A7E6nQR;A6E1nQI;;;;EAGI,mB5EhoCO;E4EioCP,c5EznCA;ADsvSR;;A6ExnQA;;EAEI,mB5EnqCK;E4EoqCL,yBAAA;EAEA,wBAAA;A7E0nQJ;A6ExnQI;;EACI,mB5EhpCM;E4EkpCN,yBAAA;A7E0nQR;A6EvnQI;;;;EAGI,mB5ExpCM;ADkxSd;;A6ErnQA;;EAEI,mB5EnrCM;E4EorCN,yBAAA;EACA,c5EvpCI;AD+wSR;A6EtnQI;;EACI,mB5E9pCO;E4EgqCP,c5E5pCA;E4E6pCA,yBAAA;A7EwnQR;A6ErnQI;;;;EAGI,mB5EvqCO;E4EwqCP,c5EpqCA;AD4xSR;;A6EpnQA;;EAEI,mB5EzqCE;E4E0qCF,yBAAA;EACA,c5E5qCI;ADmySR;A6ErnQI;;EAEI,yBAAA;EACA,mB5EtrCG;AD6ySX;A6EpnQI;;;;EAGI,mB5EjsCM;ADwzSd;;A6EnnQA;E5E1qCE,mBAAA;EAEA,+DAAA;E4E0qCE,WAAA;A7EwnQJ;A6EtnQI;E5E9qCF,mBAAA;EAEA,+DAAA;ADuySF;A6EtnQI;EAGI,eAAA;EACA,UAAA;A7EsnQR;;A6ElnQA;E5E3rCE,mBAAA;EAEA,+DAAA;E4E2rCE,WAAA;A7EunQJ;A6ErnQI;E5E/rCF,mBAAA;EAEA,+DAAA;ADuzSF;A6ErnQI;EAGI,eAAA;EACA,UAAA;A7EqnQR;;A6EjnQA;E5E5sCE,mBAAA;EAEA,+DAAA;E4E4sCE,WAAA;A7EsnQJ;A6EpnQI;E5EhtCF,mBAAA;EAEA,+DAAA;ADu0SF;A6EpnQI;EAGI,eAAA;EACA,UAAA;A7EonQR;;A6EhnQA;EACI,yB5E/uCI;E4EgvCJ,c5EzwCQ;E4E0wCR,wBAAA;A7EmnQJ;A6E7mQI;EAGI,mB5EtxCD;ADm4SP;;A6EzmQA;EACI,c5E/xCM;E4EgyCN,yB5EhwCI;E4EiwCJ,qB5EjyCM;E4EkyCN,wBAAA;A7E4mQJ;A6E1mQI;EAGI,mB5EvyCE;E4EwyCF,c5ExwCA;E4EywCA,qB5EzyCE;ADm5SV;A6EvmQI;EAGI,mB5EtxCO;AD63Sf;;A6EnmQA;;EAEI,c5EvzCM;E4EwzCN,6BAAA;EACA,qB5EzzCM;E4E2zCN,wBAAA;A7EqmQJ;A6EnmQI;;;;EAGI,mB5Eh0CE;E4Ei0CF,qB5Ej0CE;E4Ek0CF,c5EhyCA;ADs4SR;A6ElmQI;;;;EAGI,mB5EhzCO;ADq5Sf;;A6EjmQA;EACI,c5E30CG;E4E40CH,6BAAA;EACA,qB5E70CG;E4E+0CH,wBAAA;A7EmmQJ;A6EjmQI;EAGI,mB5Ep1CD;E4Eq1CC,qB5Er1CD;E4Es1CC,c5EvzCA;ADw5SR;A6E7lQI;EAGI,mB5Ep0CI;ADi6SZ;;A6EzlQA;EACI,c5Ep2CM;E4Eq2CN,6BAAA;EACA,qB5Et2CM;E4Ew2CN,wBAAA;A7E2lQJ;A6EzlQI;EAGI,mB5E72CE;E4E82CF,qB5E92CE;E4E+2CF,c5E90CA;ADu6SR;A6ErlQI;EAGI,mB5E71CO;ADk7Sf;;A6EjlQA;EACI,c5E73CK;E4E83CL,6BAAA;EACA,qB5E/3CK;E4Ei4CL,wBAAA;A7EmlQJ;A6EjlQI;EAGI,mB5Et4CC;E4Eu4CD,qB5Ev4CC;E4Ew4CD,c5Er2CA;ADs7SR;A6E7kQI;EAGI,mB5Et3CM;ADm8Sd;;A6EzkQA;EACI,c5Eh3CE;E4Ei3CF,6BAAA;EACA,qB5El3CE;AD87SN;A6E1kQI;EAGI,mB5Ev3CF;E4Ew3CE,qB5Ex3CF;E4Ey3CE,c5E13CA;ADo8SR;A6EtkQI;EAGI,mB5E34CM;ADi9Sd;;A6ElkQA;EACI,c5Ep6CM;E4Eq6CN,6BAAA;EACA,qB5Et6CM;AD2+SV;A6EnkQI;EAGI,mB5E36CE;E4E46CF,qB5E56CE;E4E66CF,c5E/4CA;ADk9SR;;A6E/jQA;EACI,yBAAA;A7EkkQJ;;A6E/jQA;;;;;;;;;;;EAWI,yB5Ez6CW;E4E06CX,yBAAA;A7EkkQJ;;A6E/jQA;;;;;;;;;;;EAWI,yB5E17CW;E4E27CX,yBAAA;A7EkkQJ;;A6E/jQA;;;;;;;;;;;EAWI,yB5Et8CQ;E4Eu8CR,yBAAA;A7EkkQJ;;A6E/jQA;;;;;;;;;;;EAWI,yB5Ev9CW;E4Ew9CX,yBAAA;A7EkkQJ;;A6E/jQA;;;;;;;;;;;EAWI,yB5Ex+CU;E4Ey+CV,yBAAA;A7EkkQJ;;A6E/jQA;;;;;;;;;EASI,yB5E/+CW;E4Eg/CX,yBAAA;A7EkkQJ;;A6E9jQA;;;;;;;;;EASI,yB5E9/CO;E4E+/CP,yBAAA;EACA,c5E3/CI;AD4jTR;;A6E7jQI;EACI,qBAAA;EACA,kBAAA;A7EgkQR;;A6E3jQA,sBAAA;AACA,gBAAA;AACA,sBAAA;AACA;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;A7E8jQJ;;A6E3jQA;EACI,aAAA;A7E8jQJ;;A6E3jQA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;A7E8jQJ;;A6E3jQA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;A7E8jQJ;A6E5jQI;EAEI,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;A7E6jQR;A6E1jQI;EACI,WAAA;EACA,mBAAA;EACA,yB5EtlDE;E4EulDF,cAAA;A7E4jQR;A6EzjQI;EACI,WAAA;EACA,mBAAA;EACA,yB5EzlDE;E4E0lDF,cAAA;EACA,iBAAA;A7E2jQR;;A6EvjQA;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EAEA,mBAAA;EACA,+BAAA;A7EyjQJ;;A6EtjQA;EACI,cAAA;A7EyjQJ;;A6EtjQA;EACI,UAAA;A7EyjQJ;;A6ErjQA,sBAAA;AACA,mBAAA;AACA,sBAAA;AACA;EACI,gBAAA;A7EwjQJ;A6EtjQI;EACI,mBAAA;A7EwjQR;;A6EpjQA;EACI,6BAAA;A7EujQJ;;A6EpjQA;EACI,wBAAA;A7EujQJ;;A6EpjQA;EACI;IACI,wBAAA;E7EujQN;AACF;A6EpjQA;EACI;IACI,wBAAA;E7EsjQN;AACF;A6EnjQA;EACI;IACI,wBAAA;E7EqjQN;AACF;A6EljQA;EACI;IACI,wBAAA;E7EojQN;AACF;A6EjjQA;EACI;IACI,wBAAA;E7EmjQN;AACF;A6EhjQA;EACI;IACI,wBAAA;E7EkjQN;AACF;A6E/iQA;EACI;IACI,wBAAA;E7EijQN;AACF;A6E9iQA;EACI;IACI,wBAAA;E7EgjQN;AACF;A6E7iQA;EACI,wBAAA;A7E+iQJ;;A6E5iQA;EACI,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,mCAAA;EACA,0D5E3oDQ;AD0rTZ;;A8E9wTA;;;;;CAAA;AAQA;;mBAAA;AAIA;EACI,YAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;A9E8wTJ;;A8E3wTA;;mBAAA;AAII;EACI,c7EiCA;AD4uTR;A8E1wTI;EACI,iBAAA;A9E4wTR;;A8ExwTA;EACI,YAAA;A9E2wTJ;A8ExwTQ;EACI,kBAAA;EACA,+BAAA;EACA,yBAAA;EACA,0DAAA;A9E0wTZ;A8EvwTQ;;EAEI,yBAAA;A9EywTZ;A8EpwTQ;EACI,wBAAA;A9EswTZ;;A8EjwTA;EAGY;IACI,kBAAA;E9EkwTd;E8E7vTU;IACI,uBAAA;E9E+vTd;AACF;A8E1vTA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,kCAAA;EACA,0D7ECW;AD2vTf;A8E1vTI;EACI,c7E1BA;E6E2BA,gBAAA;EACA,eAAA;EACA,kBAAA;A9E4vTR;A8EzvTI;EACI,c7EjCA;E6EkCA,iBAAA;A9E2vTR;;A8EvvTA;EACI,WAAA;A9E0vTJ;;A8EtvTA;;mBAAA;AAIA;EACI,gBAAA;A9EwvTJ;;A8ErvTA;EACI,gBAAA;A9EwvTJ;;A8EpvTA;;mBAAA;AAIA;EACI,YAAA;A9EsvTJ;;A8ElvTA;;mBAAA;AAIA;EACI,eAAA;EACA,kBAAA;A9EovTJ;;A8EhvTA;;mBAAA;AAIA;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A9EkvTJ;;A8E9uTA;;mBAAA;AAIA;EACI,eAAA;A9EgvTJ;;A8E7uTA;EACI,eAAA;A9EgvTJ;;A8E5uTA;;mBAAA;AAIA;EACI,mBAAA;A9E8uTJ;;A8E1uTA;;mBAAA;AAIA;EACI,c7E/II;E6EgJJ,iBAAA;A9E4uTJ;;A8ExuTA;;mBAAA;AAIA;EACI,WAAA;EACA,mBAAA;A9E0uTJ;A8ExuTI;EACI,iD7EpHK;AD81Tb;;A8EtuTA;EACI,2CAAA;EACA,mBAAA;A9EyuTJ;;A8EruTA;;mBAAA;AAIA;EACI,cAAA;A9EuuTJ;;A8EpuTA;EACI,c7E7LU;ADo6Td;A8EruTI;EACI,eAAA;EACA,iBAAA;EACA,wBAAA;A9EuuTR;A8EpuTI;EACI,c7EpMK;AD06Tb;A8EpuTQ;EACI,iBAAA;A9EsuTZ;;A8EhuTA;;mBAAA;AAIA;EACI,WAAA;EACA,YAAA;A9EkuTJ;A8EhuTI;EACI,gBAAA;EACA,eAAA;EACA,aAAA;A9EkuTR;A8EhuTQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;A9EkuTZ;A8E7tTQ;EACI,kDAAA;EACA,eAAA;A9E+tTZ;;A8EztTA;;mBAAA;AAIA;EACI,WAAA;EACA,YAAA;A9E2tTJ;A8EztTI;EACI,gBAAA;A9E2tTR;A8EztTQ;EACI,UAAA;EACA,qBAAA;EACA,mBAAA;A9E2tTZ;;A8ErtTA;;mBAAA;AAIA;EACI,iD7E9MQ;ADq6TZ;;A8EntTA;;mBAAA;AAIA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;A9EqtTJ;;A8EltTA;EACI,cAAA;A9EqtTJ;;A8EjtTA;;mBAAA;AAIA;EACI,WAAA;EACA,kBAAA;A9EmtTJ;;A8EhtTA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A9EmtTJ;;A8E/sTA;;mBAAA;AAIA;EACI,cAAA;A9EitTJ;;A8E7sTA;;mBAAA;AAIA;EACI,kBAAA;A9E+sTJ;;A8E3sTA;;mBAAA;AAIA;EACI,sBAAA;EACA,iBAAA;A9E6sTJ;;A8EzsTA;;mBAAA;AAIA;EACI,cAAA;EACA,WAAA;A9E2sTJ;A8EzsTI;EACI,kBAAA;EACA,gBAAA;A9E2sTR;A8ExsTI;EACI,kBAAA;A9E0sTR;A8EvsTI;EACI,WAAA;A9EysTR;A8EtsTI;EACI,aAAA;A9EwsTR;;A8EnsTA;;mBAAA;AAIA;EACI,gBAAA;A9EqsTJ;;A8ElsTA;EACI,gBAAA;A9EqsTJ;;A8ElsTA;EACI,gBAAA;A9EqsTJ;;A8ElsTA;EACI,gBAAA;A9EqsTJ;;A8EjsTA;;mBAAA;AAIA;EACI,kBAAA;EACA,mBAAA;A9EmsTJ;A8EjsTI;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;A9EmsTR;;A8E9rTA;;mBAAA;AAIA;EACI,kBAAA;A9EgsTJ;;A8E7rTA;EACI,kBAAA;A9EgsTJ;;A8E5rTA,sBAAA;AAGA,mBAAA;AAGA,sBAAA;AAEA;EACI,6BAAA;A9E0rTJ;;A8EvrTA;EACI,wBAAA;A9E0rTJ;;A8EvrTA;EACI;IACI,wBAAA;E9E0rTN;AACF;A8EvrTA;EACI;IACI,wBAAA;E9EyrTN;AACF;A8EtrTA;EACI;IACI,wBAAA;E9EwrTN;AACF;A8ErrTA;EACI;IACI,wBAAA;E9EurTN;AACF;A8EprTA;EACI;IACI,wBAAA;E9EsrTN;AACF;A8EnrTA;EACI;IACI,wBAAA;E9EqrTN;AACF;A8ElrTA;EACI;IACI,wBAAA;E9EorTN;AACF;A8EjrTA;EACI;IACI,wBAAA;E9EmrTN;AACF;A8EhrTA;EACI,wBAAA;A9EkrTJ;;A8E9qTA,cAAA;AAGA,YAAA;AAGA,cAAA;AAGI;EACI,aAAA;A9E2qTR;;A8EvqTA;EACI,WAAA;EACA,iD7EvbS;ADimUb;;A8EvqTA;EACI,gBAAA;A9E0qTJ;;A8EvqTA;EACI,WAAA;EACA,iD7EhcS;AD0mUb;;A8EvqTA;EACI,kBAAA;A9E0qTJ;;A8EvqTA;EACI,kBAAA;A9E0qTJ;A8ExqTI;EACI,WAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;A9E0qTR;A8EvqTI;EACI,eAAA;A9EyqTR;A8EtqTI;EACI,2BAAA;A9EwqTR;A8ErqTI;EACI,2BAAA;A9EuqTR;A8EpqTI;EACI,sBAAA;EACA,YAAA;EACA,aAAA;A9EsqTR;A8EnqTI;EACI,cAAA;EACA,eAAA;A9EqqTR;;A8EjqTA,cAAA;AACA,mBAAA;AACA,cAAA;AAEA;EACI,YAAA;EACA,WAAA;A9EmqTJ;A8EjqTI;EACI,gBAAA;A9EmqTR;A8EjqTQ;EACI,c7E7iBD;E6E8iBC,aAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;A9EmqTZ;A8EhqTQ;EACI,c7EpjBC;E6EqjBD,kBAAA;A9EkqTZ;A8E/pTQ;EACI,iBAAA;EACA,sBAAA;A9EiqTZ;A8E5pTQ;EACI,UAAA;EACA,qBAAA;A9E8pTZ;A8EzpTQ;EACI,cAAA;A9E2pTZ;;A8ErpTA,cAAA;AAGA,aAAA;AAGA,cAAA;AAEA;EACI,qC7EpiBK;E6EqiBL,c7E/iBI;E6EgjBJ,uC7EtiBK;ADyrUT;A8EjpTI;EACI,qC7EziBC;E6E0iBD,c7EpjBA;ADusUR;;A8E9oTA,cAAA;AAGA,iBAAA;AAGA,cAAA;AAGI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;A9E2oTR;A8EzoTQ;EACI,sCAAA;A9E2oTZ;A8EtoTQ;EACI,c7E/mBL;E6EgnBK,mB7E/mBJ;ADuvUR;A8EroTQ;EACI,mB7EpnBL;E6EqnBK,c7EzlBJ;ADguUR;;A8EjoTA,cAAA;AAGA,gBAAA;AAGA,cAAA;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;A9E+nTJ;A8E7nTI;EACI,mBAAA;EACA,sBAAA;EACA,WAAA;A9E+nTR;;A8E3nTA;EACI;IACI,uBAAA;IACA,gBAAA;E9E8nTN;AACF;A8E3nTA;EACI;IACI,eAAA;E9E6nTN;AACF;A8E1nTA;EACI,gBAAA;EACA,2CAAA;A9E4nTJ;;A8EznTA;EACI,4BAAA;A9E4nTJ;;A8ExnTA;;kBAAA;AAKA;;kBAAA;AAKI;EACI,kBAAA;A9EunTR;;A8ElnTA;;kBAAA;AAIA;EACI,mBAAA;EACA,eAAA;A9EonTJ;;A8EjnTA;EACI,iBAAA;EACA,oBAAA;EACA,2CAAA;EACA,yB7EtsBI;AD0zUR;;A8EhnTA;;kBAAA;AAIA;EACI,mB7E/sBI;ADi0UR;;A8E/mTA;;EAEI,mB7EjuBS;E6EkuBT,qB7EluBS;ADo1Ub;;A8E/mTA;EACI,c7E3tBI;E6E4tBJ,mB7E1tBI;AD40UR;;A8E/mTA;EACI,2CAAA;EACA,mBAAA;EACA,aAAA;A9EknTJ;;A8E9mTA;;kBAAA;AAIA;EACI,mBAAA;A9EgnTJ;;A8E5mTA;;kBAAA;AAIA;;EAII,kDAAA;A9E8mTJ;;A8E3mTA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;A9E8mTJ;;A8E3mTA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A9E8mTJ;;A8E3mTA;EACI,8BAAA;EACA,mCAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;A9E8mTJ;A8ErmTA;EACI;IACI,QAAA;E9E6mTN;AACF;A8EzmTA;;kBAAA;AAIA;EACI,cAAA;A9E0mTJ;A8ExmTI;EACI,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,mBAAA;A9E0mTR;A8ExmTQ;EACI,c7EjzBL;E6EkzBK,mBAAA;EACA,WAAA;EACA,0BAAA;A9E0mTZ;A8EtmTI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;A9EwmTR;;A8EpmTA;;;EAGI,mB7E90BS;E6E+0BT,WAAA;EACA,c7ExyBI;AD+4UR;;A8EnmTA,sBAAA;AAEA;;;EAGI,mB7EjzBI;E6EkzBJ,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,c7E71BS;ADk8Ub;;A8ElmTA;EACI,sBAAA;EACA,eAAA;A9EqmTJ;;A8EhmTQ;EACI,WAAA;EACA,iBAAA;EACA,c7E32BD;AD88UX;A8EjmTY;EACI,mB7E72BH;E6E82BG,c7Et0BR;ADy6UR;A8EhmTY;EACI,c7E10BR;E6E20BQ,mB7En3BH;ADq9Ub;;A8E3lTA;;kBAAA;AAIA;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;A9E6lTJ;;A8E1lTA;EACI,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,yB7Ej4BI;AD89UR;;A8E1lTA;EACI,kBAAA;EACA,mBAAA;A9E6lTJ;;A8E1lTA;;EAEI,YAAA;EACA,cAAA;A9E6lTJ;;A8E1lTA;EACI,WAAA;A9E6lTJ;;A8E1lTA;;EAEI,YAAA;EACA,cAAA;A9E6lTJ;;A8E1lTA;EACI,WAAA;A9E6lTJ;;A8E1lTA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,2CAAA;EACA,kB7E73BK;E6E+3BL,yCAAA;A9E6lTJ;;A8E1lTA;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,+CAAA;EACA,oCAAA;EACA,gDAAA;A9E6lTJ;;A8E1lTA;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;A9E6lTJ;;A8E1lTA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;A9E6lTJ;;A8E1lTA;EACI,YAAA;A9E6lTJ;;A8E1lTA;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A9E6lTJ;;A8E1lTA;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A9E6lTJ;;A8E1lTA;EACI,yB7Ex+BM;ADqkVV;;A8E1lTA;EACI,yB7E9+BM;AD2kVV;;A8E1lTA;EACI,yB7Ej/BM;AD8kVV;;A8E1lTA;EACI,yB7Ev/BK;ADolVT;;A8E1lTA;EACI,yB7Ev/BG;ADolVP;;A8E1lTA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;A9E6lTJ;;A8E1lTA;;EAEI,gBAAA;A9E6lTJ;;A8E1lTA;EACI,eAAA;A9E6lTJ;;A8EzlTA;;iEAAA;AAIA;EACI,WAAA;EACA,YAAA;A9E2lTJ;A8EzlTI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,wBAAA;A9E2lTR;A8EzlTQ;EACI,c7EniCD;AD8nVX;A8EzlTY;EACI,c7EriCH;ADgoVb;A8EvlTQ;EACI,eAAA;EACA,kBAAA;A9EylTZ;;A8EnlTI;EACI,qBAAA;A9EslTR;A8EplTQ;EACI,iBAAA;A9EslTZ;A8EnlTQ;EACI,c7E1jCD;AD+oVX;A8EnlTY;EACI,c7E5jCH;ADipVb;;A8E9kTA;EACI,WAAA;A9EilTJ;A8E/kTI;EACI,YAAA;A9EilTR;;A8E5kTA,YAAA;AAGI;EACI,kBAAA;A9E6kTR;;A8ExkTI;EACI,2CAAA;EACA,uBAAA;EACA,mBAAA;A9E2kTR;A8EzkTQ;EACI,c7EhlCJ;AD2pVR;A8ExkTQ;EACI,yB7EtlCL;E6EulCK,yBAAA;A9E0kTZ;A8ExkTY;EACI,c7E3jCR;ADqoVR;A8ErkTI;EACI,yB7EhmCD;E6EimCC,yBAAA;A9EukTR;A8ErkTQ;EACI,c7ErkCJ;AD4oVR;;A8EjkTA;;sBAAA;AAMI;;EAEI,c7EnlCA;ADopVR;A8E/jTQ;;EACI,YAAA;A9EkkTZ;A8E9jTI;EACI,+BAAA;A9EgkTR;;A8E3jTA;;mBAAA;AAIA;EACI,eAAA;A9E6jTJ;;A8E1jTA;EACI,c7EtoCI;E6EuoCJ,mBAAA;EACA,eAAA;A9E6jTJ;;A8E1jTA;;;;EAII,gCAAA;A9E6jTJ;;A8EzjTI;EACI,mB7EvnCA;E6EwnCA,kBAAA;A9E4jTR;;A8ExjTA;EACI,mB7E/pCM;E6EgqCN,qB7EhqCM;AD2tVV;;A8ExjTA;EACI,mB7ErqCK;E6EsqCL,qB7EtqCK;ADiuVT;;A8ExjTA;EACI,mB7ExqCM;E6EyqCN,qB7EzqCM;ADouVV;;A8ExjTA;EACI,mB7E3qCG;E6E4qCH,qB7E5qCG;ADuuVP;;A8ExjTA;EACI,mB7EjrCM;E6EkrCN,qB7ElrCM;AD6uVV;;A8ExjTA;EACI,mB7EprCM;E6EqrCN,qB7ErrCM;ADgvVV;;A8ExjTA;EACI,mB7EtpCI;E6EupCJ,qB7EvpCI;ADktVR;;A8EvjTA;;iEAAA;AAIA;EACI,mBAAA;A9EyjTJ;;A8EtjTA;EAEI,6BAAA;A9EyjTJ;;A8EtjTA;EACI,mB7E7sCG;E6E8sCH,qB7E9sCG;ADuwVP;;A8EtjTA;EACI,mB7EntCM;E6EotCN,qB7EptCM;AD6wVV;;A8EtjTA;EACI,qB7EvtCG;ADgxVP;A8EvjTI;EACI,mB7E1tCD;E6E2tCC,qB7E3tCD;ADoxVP;;A8ErjTA;EACI,qB7E/tCM;ADuxVV;A8EtjTI;EACI,mB7EluCE;E6EmuCF,qB7EnuCE;AD2xVV;;A8EpjTA;EACI,qB7E3uCM;ADkyVV;A8ErjTI;EACI,mB7E9uCE;E6E+uCF,qB7E/uCE;ADsyVV;;A8EnjTA;EACI,qB7ErvCM;AD2yVV;A8EpjTI;EACI,mB7ExvCE;E6EyvCF,qB7EzvCE;AD+yVV;;A8EljTA;EACI,qB7E/vCK;ADozVT;A8EnjTI;EACI,mB7ElwCC;E6EmwCD,qB7EnwCC;ADwzVT;;A8EjjTA;EACI,qB7ErwCM;ADyzVV;A8EljTI;EACI,mB7ExwCE;E6EywCF,qB7EzwCE;AD6zVV;;A8E/iTA;;kBAAA;AAIA;EACI,mFAAA;EACA,2CAAA;EACA,4BAAA;A9EijTJ;;A8E7iTA;;kBAAA;AAIA;EACI,YAAA;A9E+iTJ;;A8E5iTA;;;EAGI,sBAAA;EACA,4BAAA;EACA,2CAAA;EAEA,kCAAA;A9E+iTJ;;A8E5iTA;;;;;EAKI,c7ElzCM;ADi2VV;;A8E5iTA;EACI,0DAAA;A9E+iTJ;;A8E5iTA;EACI,qB7E1zCM;ADy2VV;;A8E5iTA;;;;;EAKI,c7Ej0CM;ADg3VV;;A8E5iTA;EACI,0DAAA;A9E+iTJ;;A8E5iTA;EACI,qB7Ez0CM;ADw3VV;;A8E5iTA;;;;;EAKI,c7En1CK;ADk4VT;;A8E5iTA;EACI,0DAAA;A9E+iTJ;;A8E5iTA;EACI,qB7E31CK;AD04VT;;A8E1iTI;;;;EAII,iBAAA;EACA,UAAA;A9E6iTR;;A8EziTA;EACI,kBAAA;A9E4iTJ;;A8EziTA;EACI,uBAAA;A9E4iTJ;;A8ExiTA;;kBAAA;AAKI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,c7Er3CA;E6Es3CA,eAAA;EACA,mB7E11CA;E6E21CA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;A9EyiTR;A8EtiTI;EACI,gBAAA;A9EwiTR;A8EriTI;EACI,sBAAA;EACA,kCAAA;EACA,iBAAA;A9EuiTR;;A8EliTI;EACI,wBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;A9EqiTR;A8EliTI;EACI,iBAAA;A9EoiTR;;A8E/hTI;EACI,4BAAA;A9EkiTR;;A8E7hTI;EACI,4BAAA;A9EgiTR;;A8E3hTI;EACI,4BAAA;A9E8hTR;;A8EzhTA;;kBAAA;AAIA;EACI,kBAAA;EACA,WAAA;A9E2hTJ;;A8EvhTA;;mBAAA;AAGA;EACI,sBAAA;EACA,sBAAA;EACA,kCAAA;A9E0hTJ;A8ExhTI;EACI,c7Ej6CA;E6Ek6CA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A9E0hTR;A8EvhTI;EACI,c7Ez6CA;ADk8VR;;A8ErhTA;EAEQ;IACI,eAAA;IACA,iBAAA;E9EuhTV;AACF;A8ElhTI;EACI,WAAA;EACA,YAAA;EACA,cAAA;A9EohTR;;A8EhhTA;;EAEI,mB7Ex+CS;AD2/Vb;;A8EhhTA;;mBAAA;AAII;EACI,iBAAA;EACA,gBAAA;A9EkhTR;A8EhhTQ;EACI,c7Er/CD;ADugWX;A8EhhTY;EACI,c7E9+CT;ADggWP;A8E5gTQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9E8gTZ;A8E5gTY;EACI,mB7E1/CT;ADwgWP;;A8ExgTA;;mBAAA;AAGA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;A9E2gTJ;A8EzgTI;EAPJ;IAQQ,8BAAA;E9E4gTN;AACF;;A8EzgTA;EAEI,wBAAA;A9E4gTJ;;A+ExjWA;;;;;CAAA;AAQA;;iEAAA;AASA;;iEAAA;AASA;;iEAAA;AAIA;EAEQ;IACI,4BAAA;E/E2iWV;E+EtiWU;IACI,cAAA;IACA,eAAA;E/EwiWd;E+EjiWW;IACG,gBAAA;IACA,eAAA;E/EmiWd;E+E/hWE;IACI,cAAA;E/EiiWN;AACF;A+E7hWA;EACI;IACI,yBAAA;E/E+hWN;E+E9hWM;IACI,wBAAA;E/EgiWV;E+E7hWE;IACI,OAAA;IACA,QAAA;IACA,cAAA;IACA,QAAA;E/E+hWN;E+E1hWM;;;IACI,kBAAA;IACA,aAAA;E/E8hWV;E+E7hWU;;;IACI,WAAA;E/EiiWd;E+E3hWM;IACI,gBAAA;E/E6hWV;E+E3hWM;IACI,gBAAA;E/E6hWV;E+EzhWM;IACI,0BAAA;E/E2hWV;E+EvhWM;IACI,kBAAA;E/EyhWV;E+ExhWU;IACI,eAAA;E/E0hWd;E+ExhWU;IACI,gBAAA;E/E0hWd;E+EvhWM;IACI,cAAA;E/EyhWV;E+EvhWM;IACI,gBAAA;E/EyhWV;E+ErhWM;IACI,kBAAA;IACA,UAAA;E/EuhWV;E+EphWE;IACI,kBAAA;E/EshWN;E+EphWE;IACI,kBAAA;IACA,iBAAA;E/EshWN;E+EphWE;IACI,mB9E9GK;I8E+GL,kBAAA;E/EshWN;E+ErhWM;IACI,sBAAA;E/EuhWV;E+EthWU;IAEQ,oBAAA;E/EwhWlB;AACF;A+EjhWA;;iEAAA;AASA;;iEAAA;AAIA;EACI,yBAAA;EACA;IACI,gBAAA;IACA,iBAAA;IACA,kDAAA;E/E4gWN;E+EzgWM;IACI,WAAA;E/E2gWV;E+ExgWE;IACI,cAAA;E/E0gWN;E+ExgWE;IACI,kBAAA;E/E0gWN;E+EtgWM;IACI,WAAA;IACA,cAAA;E/EwgWV;E+ErgWE,6BAAA;EACA;IACI,eAAA;E/EugWN;E+ErgWE,6BAAA;EAEI;IACI,gBAAA;E/EsgWV;E+EngWE,6BAAA;EACA;IACI,UAAA;IACA,WAAA;E/EqgWN;E+EngWE,6BAAA;EACA;IACI,iBAAA;E/EqgWN;E+EngWE;IACI,kBAAA;E/EqgWN;E+ElgWM;IACI,kBAAA;E/EogWV;E+EhgWM;IACI,kBAAA;IACA,mBAAA;E/EkgWV;E+E9/VM;IACI,aAAA;E/EggWV;E+E5/VM;IACI,uBAAA;E/E8/VV;E+E1/VM;IACI,aAAA;E/E4/VV;E+Ex/VE;IACI,cAAA;E/E0/VN;AACF","sourcesContent":["/*\nTemplate Name: Wrakit UI Kit\nAuthor: wrappixel\nEmail: niravjoshi87@gmail.com\nFile: scss\n*/\n\n/**\n * Table Of Content\n *\n * \t1. Globals\n *\t2. Headers\n *\t3. Navigations\n *\t4. Banners\n *\t5. Footers\n *\t6. app\n *\t7. Widgets\n *\t8. Custom Templates\n */\n\n@import 'variable';\n@import 'bootstrap/bootstrap.scss';\n@import '../scss/icons/font-awesome/css/font-awesome.min.css'; \n@import '../scss/icons/simple-line-icons/css/simple-line-icons.css';\n@import '../scss/icons/themify-icons/themify-icons.css';\n@import 'ui/ui.scss'; \n@import 'app.scss'; \n@import 'common.scss'; \n@import 'responsive.scss';     ","/*\nTemplate Name: Wrapkit\nAuthor: wrappixel\nEmail: niravjoshi87@gmail.com\nFile: scss\n*/\n\n// Variables - here you can change this global values of the UI Kit\n\n$bodyfont:'Montserrat',\nsans-serif;\n$headingfont:'Montserrat',\nsans-serif;\n\n/*Theme Colors*/\n$bodycolor: #ffffff;\n$headingtext: #3e4555;\n$bodytext: #8d97ad;\n$themecolor: #631117;\n$themecolor-alt: #26c6da;\n$themecolor-dark: #028ee1;\n\n/*bootstrap Color*/\n$danger: #ff4d7e;\n$success: #2cdd9b;\n$warning: #fec500;\n$primary: #316ce8;\n$info: #188ef4;\n$inverse: #3e4555;\n$muted: #8d97ad;\n$dark: #263238;\n$light: #f4f8fa;\n$extra-light: #ebf3f5;\n$secondary: #727b84;\n$facebook: #3b5a9a;\n$twitter: #56adf2;\n\n/*Light colors*/\n$light-danger: #f9e7eb;\n$light-success: #e8fdeb;\n$light-warning: #fff8ec;\n$light-primary: #f1effd;\n$light-info: #cfecfe;\n$light-inverse: #f6f6f6;\n$light-megna: #e0f2f4;\n\n\n\n$danger-dark: #d73e6b;\n$success-dark: #1dc8cc;\n$warning-dark: #dcaf17;\n$primary-dark: #345bcb;\n$info-dark: #2c73cb;\n$red-dark: #d61f1f;\n$inverse-dark: #232a37;\n$dark-transparent:rgba(0, 0, 0, 0.05);\n\n/*Normal Color*/\n$white: #ffffff;\n$red: #fb3a3a;\n$yellow: #fed700;\n$purple: #7460ee;\n$blue: #02bec9;\n$megna: #1dc8cd;\n$orange:#ff6a5b;\n/*Extra Variable*/\n$rgt: right;\n$lft: left;\n$border: rgba(120, 130, 140, 0.13);\n$radius: 4px;\n$card-shadow:0px 0px 30px rgba(115, 128, 157, 0.1);\n$img-shadow:0px 0px 30px rgba(115, 128, 157, 0.3);\n/*Gradiant*/\n\n@mixin linear-gradient($direction, $color-stops...) {\n  background: nth(nth($color-stops, 1), 1);\n  background: -webkit-linear-gradient(legacy-direction($direction), $color-stops);\n  background: linear-gradient($direction, $color-stops);\n}\n\n// $banner-image: url(../images/landingpage/banner-bg.jpg);\n// $banner-image: url(../images/landingpage/backgroundInicio.png);\n$banner-image: url(../images/landingpage/banner.png);\n// $c2a-image: url(../images/landingpage/bg-certificado.jpg);\n$c2a-image: url(../images/landingpage/imagenjueces.png);\n$banner-slider: url(../images/static-slider/slider10/img1.jpg);\n$form-banner: url(../images/form-banners/banner1/banner-bg.jpg);\n$t1: url(../images/team/t1.jpg);\n$t2: url(../images/team/t2.jpg);\n$t3: url(../images/team/t3.jpg);\n$t4: url(../images/team/t4.jpg);","/*!\n * Bootstrap v4.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Setting @viewport causes scrollbars to overlap content in IE11 and Edge, so\n//    we force a non-overlapping, non-auto-hiding scrollbar to counteract.\n// 6. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -ms-text-size-adjust: 100%; // 4\n  -ms-overflow-style: scrollbar; // 5\n  -webkit-tap-highlight-color: rgba($black, 0); // 6\n}\n\n// IE10+ doesn't honor `<meta name=\"viewport\">` in some cases.\n@at-root {\n  @-ms-viewport {\n    width: device-width;\n  }\n}\n\n// stylelint-disable selector-list-comma-newline-after\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n// stylelint-enable selector-list-comma-newline-after\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use the\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  font-size: $font-size-base;\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\n// This prevents an unwanted focus outline from appearing around elements that\n// might still respond to pointer events.\n//\n// Credit: https://github.com/suitcss/base\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n// stylelint-enable selector-list-comma-newline-after\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Remove the bottom border in Firefox 39-.\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Duplicate behavior to the data-* attribute for our tooltip plugin\n\nabbr[title],\nabbr[data-original-title] { // 4\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 1\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\ndfn {\n  font-style: italic; // Add the correct font style in Android 4.3-\n}\n\n// stylelint-disable font-weight-notation\nb,\nstrong {\n  font-weight: bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n// stylelint-enable font-weight-notation\n\nsmall {\n  font-size: 80%; // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n  -webkit-text-decoration-skip: objects; // Remove gaps in links underline in iOS 8+ and Safari 8+.\n\n  @include hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href)\n// which have not been made explicitly keyboard-focusable (without tabindex).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover-focus {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  font-size: 1em; // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // We have @viewport set which causes scrollbars to overlap content in IE11 and Edge, so\n  // we force a non-overlapping, non-auto-hiding scrollbar to counteract.\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\n  // closest parent with a set `text-align`.\n  text-align: inherit;\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  border-radius: 0;\n}\n\n// Work around a Firefox/IE bug where the transparent `button` background\n// results in a loss of the default `button` focus styles.\n//\n// Credit: https://github.com/suitcss/base/\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\nhtml [type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  // Remove the default appearance of temporal inputs to avoid a Mobile Safari\n  // bug where setting a custom line-height prevents text from being vertically\n  // centered within the input.\n  // See https://bugs.webkit.org/show_bug.cgi?id=139848\n  // and https://github.com/twbs/bootstrap/issues/11266\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n\n//\n// Color system\n//\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:              true !default;\n$enable-rounded:            true !default;\n$enable-shadows:            false !default;\n$enable-gradients:          false !default;\n$enable-transitions:        true !default;\n$enable-hover-media-query:  false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:       true !default;\n$enable-print-styles:       true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                theme-color(\"primary\") !default;\n$link-decoration:           none !default;\n$link-hover-color:          darken($link-color, 15%) !default;\n$link-hover-decoration:     underline !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n\n// Fonts\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                ($font-size-base * 1.25) !default;\n$font-size-sm:                ($font-size-base * .875) !default;\n\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      ($spacer / 2) !default;\n$headings-font-family:        inherit !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              ($font-size-base * 1.25) !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-font-size:        ($font-size-base * 1.25) !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-bg:                    transparent !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $gray-300 !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n\n$table-dark-bg:               $gray-900 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($gray-900, 7.5%) !default;\n$table-dark-color:            $body-bg !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-line-height:             $input-btn-line-height !default;\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\n$input-height:                          calc(#{$input-height-inner} + #{$input-height-border}) !default;\n\n$input-height-inner-sm:                 ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\n$input-height-sm:                       calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\n\n$input-height-inner-lg:                 ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\n$input-height-lg:                       calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 1.5rem !default;\n$custom-control-spacer-x:               1rem !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $gray-300 !default;\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   none !default;\n\n$custom-control-indicator-focus-box-shadow:     0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    none !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:          $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:       $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:  none !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$custom-select-padding-y:           .375rem !default;\n$custom-select-padding-x:           .75rem !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-line-height:         $input-btn-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$custom-select-border-width:        $input-btn-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-btn-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width rgba($custom-select-focus-border-color, .5) !default;\n\n$custom-select-font-size-sm:        75% !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-font-size-lg:        125% !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-btn-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-btn-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-btn-padding-y !default;\n$custom-file-padding-x:             $input-btn-padding-x !default;\n$custom-file-line-height:           $input-btn-line-height !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-btn-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-100 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-600 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              ($spacer / 2) !default;\n\n// Navbar\n\n$navbar-padding-y:                  ($spacer / 2) !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width}) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 ($grid-gutter-width / 2) !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $gray-200 !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding:              1rem !default;\n\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-transition:                  transform .3s ease-out !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                ($font-size-base * .75) !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n// List group\n\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:            $white !default;\n$carousel-control-width:            15% !default;\n$carousel-control-opacity:          .5 !default;\n\n$carousel-indicator-width:          30px !default;\n$carousel-indicator-height:         3px !default;\n$carousel-indicator-spacer:         3px !default;\n$carousel-indicator-active-bg:      $white !default;\n\n$carousel-caption-width:            70% !default;\n$carousel-caption-color:            $white !default;\n\n$carousel-control-icon-width:       20px !default;\n\n$carousel-control-prev-icon-bg:     str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$carousel-control-next-icon-bg:     str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$carousel-transition:               transform .6s ease !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Printing\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover {\n  &:hover { @content; }\n}\n\n@mixin hover-focus {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { font-size: $h1-font-size; }\nh2, .h2 { font-size: $h2-font-size; }\nh3, .h3 { font-size: $h3-font-size; }\nh4, .h4 { font-size: $h4-font-size; }\nh5, .h5 { font-size: $h5-font-size; }\nh6, .h6 { font-size: $h6-font-size; }\n\n.lead {\n  font-size: $lead-font-size;\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  font-size: $display1-size;\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  font-size: $display2-size;\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  font-size: $display3-size;\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  font-size: $display4-size;\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  font-size: $small-font-size;\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled;\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled;\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  font-size: $blockquote-font-size;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%; // back to default font-size\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014 \\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid;\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid;\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: ($spacer / 2);\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: $figure-caption-font-size;\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n// stylelint-disable indentation, media-query-list-comma-newline-after\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n  only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n}\n","// Single side border-radius\n\n@mixin border-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-radius: $radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-top-right-radius: $radius;\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: $radius;\n    border-bottom-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n","// Inline code\ncode {\n  font-size: $code-font-size;\n  color: $code-color;\n  word-break: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  font-size: $kbd-font-size;\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  font-size: $code-font-size;\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  .container {\n    @include make-container();\n    @include make-container-max-widths();\n  }\n}\n\n// Fluid container\n//\n// Utilizes the mixin meant for fixed width containers, but with 100% width for\n// fluid, full width layouts.\n\n@if $enable-grid-classes {\n  .container-fluid {\n    @include make-container();\n  }\n}\n\n// Row\n//\n// Rows contain and clear the floats of your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container() {\n  width: 100%;\n  padding-right: ($grid-gutter-width / 2);\n  padding-left: ($grid-gutter-width / 2);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n}\n\n@mixin make-row() {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: ($grid-gutter-width / -2);\n  margin-left: ($grid-gutter-width / -2);\n}\n\n@mixin make-col-ready() {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  min-height: 1px; // Prevent collapsing\n  padding-right: ($grid-gutter-width / 2);\n  padding-left: ($grid-gutter-width / 2);\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage($size / $columns);\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage($size / $columns);\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: $size / $columns;\n  margin-left: if($num == 0, 0, percentage($num));\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    min-height: 1px; // Prevent columns from collapsing when empty\n    padding-right: ($gutter / 2);\n    padding-left: ($gutter / 2);\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    // Allow columns to stretch full width below their breakpoints\n    @for $i from 1 through $columns {\n      .col#{$infix}-#{$i} {\n        @extend %grid-column;\n      }\n    }\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n      .col#{$infix}-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: none; // Reset earlier grid tiers\n      }\n\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @include make-col($i, $columns);\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      // `$columns - 1` because offsetting by the width of an entire row isn't possible\n      @for $i from 0 through ($columns - 1) {\n        @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n          .offset#{$infix}-#{$i} {\n            @include make-col-offset($i, $columns);\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  .table {\n    background-color: $body-bg;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: (2 * $table-border-width);\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover {\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, -9));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(odd) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover {\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-size: $font-size-base;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @if $enable-rounded {\n    // Manually use the if/else instead of the mixin to account for iOS override\n    border-radius: $input-border-radius;\n  } @else {\n    // Otherwise undo the iOS default\n    border-radius: 0;\n  }\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus();\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\nselect.form-control {\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: calc(#{$input-padding-y} + #{$input-border-width});\n  padding-bottom: calc(#{$input-padding-y} + #{$input-border-width});\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  font-size: inherit; // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: calc(#{$input-padding-y-lg} + #{$input-border-width});\n  padding-bottom: calc(#{$input-padding-y-lg} + #{$input-border-width});\n  font-size: $font-size-lg;\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: calc(#{$input-padding-y-sm} + #{$input-border-width});\n  padding-bottom: calc(#{$input-padding-y-sm} + #{$input-border-width});\n  font-size: $font-size-sm;\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: $input-padding-y;\n  padding-bottom: $input-padding-y;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  font-size: $font-size-sm;\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  font-size: $font-size-lg;\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n// stylelint-enable no-duplicate-selectors\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@include form-validation-state(\"valid\", $form-feedback-valid-color);\n@include form-validation-state(\"invalid\", $form-feedback-invalid-color);\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","@mixin transition($transition...) {\n  @if $enable-transitions {\n    @if length($transition) == 0 {\n      transition: $transition-base;\n    } @else {\n      transition: $transition;\n    }\n  }\n\n  @media screen and (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus() {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n}\n\n\n@mixin form-validation-state($state, $color) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    font-size: $form-feedback-font-size;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $tooltip-padding-y $tooltip-padding-x;\n    margin-top: .1rem;\n    font-size: $tooltip-font-size;\n    line-height: $line-height-base;\n    color: color-yiq($color);\n    background-color: rgba($color, $tooltip-opacity);\n    @include border-radius($tooltip-border-radius);\n  }\n\n  .form-control,\n  .custom-select {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      border-color: $color;\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .form-control-file {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .form-check-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          background-color: lighten($color, 25%);\n        }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-file-label {\n        border-color: $color;\n\n        &::after { border-color: inherit; }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-weight: $btn-font-weight;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  // Share hover and focus styles\n  @include hover-focus {\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .btn elements\n  &:not(:disabled):not(.disabled) {\n    cursor: pointer;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active {\n    @include box-shadow($btn-active-box-shadow);\n\n    &:focus {\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  background-color: transparent;\n\n  @include hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n    border-color: transparent;\n    box-shadow: none;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n    } @else {\n      box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  background-color: transparent;\n  background-image: none;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  font-size: $font-size;\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @if $enable-rounded {\n    border-radius: $border-radius;\n  } @else {\n    border-radius: 0;\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n.fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  // Generate the caret automatically\n  @include caret;\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  margin: $dropdown-spacer 0 0; // override default ul\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\n  color: $body-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When enabled Popper.js, reset basic dropdown position\n// stylelint-disable no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n// stylelint-enable no-duplicate-selectors\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  @include hover-focus {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-padding-y $dropdown-item-padding-x;\n  margin-bottom: 0; // for use with heading elements\n  font-size: $font-size-sm;\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      width: 0;\n      height: 0;\n      margin-left: $caret-width * .85;\n      vertical-align: $caret-width * .85;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down;\n      } @else if $direction == up {\n        @include caret-up;\n      } @else if $direction == right {\n        @include caret-right;\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        width: 0;\n        height: 0;\n        margin-right: $caret-width * .85;\n        vertical-align: $caret-width * .85;\n        content: \"\";\n        @include caret-left;\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 0 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n\n  // Prevent double borders when buttons are next to each other\n  .btn + .btn,\n  .btn + .btn-group,\n  .btn-group + .btn,\n  .btn-group + .btn-group {\n    margin-left: -$btn-border-width;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  > .btn:first-child {\n    margin-left: 0;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  .btn,\n  .btn-group {\n    width: 100%;\n  }\n\n  > .btn + .btn,\n  > .btn + .btn-group,\n  > .btn-group + .btn,\n  > .btn-group + .btn-group {\n    margin-top: -$btn-border-width;\n    margin-left: 0;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    // Add width 1% and flex-basis auto to ensure that button will not wrap out\n    // the column. Applies to IE Edge+ and Firefox. Chrome does not require this.\n    width: 1%;\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:last-child) { @include border-right-radius(0); }\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  font-size: $font-size-base; // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  font-size: $font-size-lg;\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  font-size: $font-size-sm;\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: ($font-size-base * $line-height-base);\n  padding-left: $custom-control-gutter;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    box-shadow: $custom-control-indicator-focus-box-shadow;\n  }\n\n  &:active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: (($font-size-base * $line-height-base - $custom-control-indicator-size) / 2);\n    left: -$custom-control-gutter;\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    user-select: none;\n    background-color: $custom-control-indicator-bg;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: (($font-size-base * $line-height-base - $custom-control-indicator-size) / 2);\n    left: -$custom-control-gutter;\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: $custom-control-indicator-bg-size;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::before {\n      @include gradient-bg($custom-control-indicator-checked-bg);\n    }\n    &::after {\n      background-image: $custom-checkbox-indicator-icon-checked;\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: $custom-checkbox-indicator-icon-indeterminate;\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::before {\n      @include gradient-bg($custom-control-indicator-checked-bg);\n    }\n    &::after {\n      background-image: $custom-radio-indicator-icon-checked;\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      background-color: $custom-control-indicator-checked-disabled-bg;\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-indicator no-repeat right $custom-select-padding-x center;\n  background-size: $custom-select-bg-size;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @if $enable-rounded {\n    border-radius: $custom-select-border-radius;\n  } @else {\n    border-radius: 0;\n  }\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      box-shadow: $custom-select-box-shadow, $custom-select-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    opacity: 0;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y;\n  padding-bottom: $custom-select-padding-y;\n  font-size: $custom-select-font-size-sm;\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y;\n  padding-bottom: $custom-select-padding-y;\n  font-size: $custom-select-font-size-lg;\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n\n    &::after {\n      border-color: $custom-file-focus-border-color;\n    }\n  }\n\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: $custom-file-border-width solid $custom-file-border-color;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  padding-left: 0; // Firefox specific\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: none;\n\n    // Pseudo-elements must be split across multiple rulesets to have an affect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: (($custom-range-track-height - $custom-range-thumb-height) / 2); // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: ($custom-range-thumb-height * .5);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s or `<ul>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n\n  @include hover-focus {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-item {\n    margin-bottom: -$nav-tabs-border-width;\n  }\n\n  .nav-link {\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus {\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  > .container,\n  > .container-fluid {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  font-size: $navbar-brand-font-size;\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  font-size: $navbar-toggler-font-size;\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus {\n    text-decoration: none;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled):not(.disabled) {\n    cursor: pointer;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        > .container,\n        > .container-fluid {\n          padding-right: 0;\n          padding-left: 0;\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        > .container,\n        > .container-fluid {\n          flex-wrap: nowrap;\n        }\n\n        .navbar-collapse {\n          display: flex !important;  // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-active-color;\n\n    @include hover-focus {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: $navbar-light-toggler-icon-bg;\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-active-color;\n\n    @include hover-focus {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: $navbar-dark-toggler-icon-bg;\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group:first-child {\n    .list-group-item:first-child {\n      @include border-top-radius($card-border-radius);\n    }\n  }\n\n  > .list-group:last-child {\n    .list-group-item:last-child {\n      @include border-bottom-radius($card-border-radius);\n    }\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: $card-spacer-x;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -($card-spacer-y / 2);\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n\n  + .list-group {\n    .list-group-item:first-child {\n      border-top: 0;\n    }\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -($card-spacer-x / 2);\n  margin-bottom: -$card-spacer-y;\n  margin-left: -($card-spacer-x / 2);\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -($card-spacer-x / 2);\n  margin-left: -($card-spacer-x / 2);\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n}\n\n.card-img {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n  @include border-radius($card-inner-border-radius);\n}\n\n// Card image caps\n.card-img-top {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  display: flex;\n  flex-direction: column;\n\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      display: flex;\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      flex-direction: column;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  display: flex;\n  flex-direction: column;\n\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:first-child {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:last-child {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            border-bottom-left-radius: 0;\n          }\n        }\n\n        &:only-child {\n          @include border-radius($card-border-radius);\n\n          .card-img-top,\n          .card-header {\n            @include border-top-radius($card-border-radius);\n          }\n          .card-img-bottom,\n          .card-footer {\n            @include border-bottom-radius($card-border-radius);\n          }\n        }\n\n        &:not(:first-child):not(:last-child):not(:only-child) {\n          @include border-radius(0);\n\n          .card-img-top,\n          .card-img-bottom,\n          .card-header,\n          .card-footer {\n            @include border-radius(0);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  .card:not(:first-of-type):not(:last-of-type) {\n    border-bottom: 0;\n    border-radius: 0;\n  }\n\n  .card:not(:first-of-type) {\n    .card-header:first-child {\n      border-radius: 0;\n    }\n  }\n\n  .card:first-of-type {\n    border-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .card:last-of-type {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      display: inline-block; // Suppress underlining of the separator in modern browsers\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: $breadcrumb-divider;\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 2;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\n  &:not(:disabled):not(.disabled) {\n    cursor: pointer;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 1;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    font-size: $font-size;\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  font-size: $badge-font-size;\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  &[href] {\n    @include hover-focus {\n      color: color-yiq($bg);\n      text-decoration: none;\n      background-color: darken($bg, 10%);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\n  margin-bottom: $jumbotron-padding;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: ($close-font-size + $alert-padding-x * 2);\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","@keyframes progress-bar-stripes {\n  from { background-position: $progress-height 0; }\n  to { background-position: 0 0; }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  font-size: $progress-font-size;\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes $progress-bar-animation-timing;\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus {\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  // Place the border on the list items and negative margin up for better styling\n  margin-bottom: -$list-group-border-width;\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius($list-group-border-radius);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n    @include border-bottom-radius($list-group-border-radius);\n  }\n\n  @include hover-focus {\n    z-index: 1; // Place hover/active items above their siblings for proper border styling\n    text-decoration: none;\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  .list-group-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n  }\n\n  &:first-child {\n    .list-group-item:first-child {\n      border-top: 0;\n    }\n  }\n\n  &:last-child {\n    .list-group-item:last-child {\n      border-bottom: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  font-size: $close-font-size;\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  &:not(:disabled):not(.disabled) {\n\n    @include hover-focus {\n      color: $close-color;\n      text-decoration: none;\n      opacity: .75;\n    }\n\n    // Opinionated: add \"hand\" cursor to non-disabled .close elements\n    cursor: pointer;\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable property-no-vendor-prefix, selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n// stylelint-enable\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: translate(0, -25%);\n  }\n  .modal.show & {\n    transform: translate(0, 0);\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - (#{$modal-dialog-margin} * 2));\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: calc(100vh - (#{$modal-dialog-margin} * 2));\n    content: \"\";\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding) (-$modal-header-padding) (-$modal-header-padding) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when should there be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n\n  // Easily place margin between footer elements\n  > :not(:first-child) { margin-left: .25rem; }\n  > :not(:last-child) { margin-right: .25rem; }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - (#{$modal-dialog-margin-y-sm-up} * 2));\n\n    &::before {\n      height: calc(100vh - (#{$modal-dialog-margin-y-sm-up} * 2));\n    }\n\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg { max-width: $modal-lg; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  font-size: $tooltip-font-size;\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start; // stylelint-disable-line declaration-block-no-duplicate-properties\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  font-size: $popover-font-size;\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $border-radius-lg;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  .arrow {\n    bottom: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n  }\n\n  .arrow::before,\n  .arrow::after {\n    border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n  }\n\n  .arrow::before {\n    bottom: 0;\n    border-top-color: $popover-arrow-outer-color;\n  }\n\n  .arrow::after {\n    bottom: $popover-border-width;\n    border-top-color: $popover-arrow-color;\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  .arrow {\n    left: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\n  }\n\n  .arrow::before,\n  .arrow::after {\n    border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n  }\n\n  .arrow::before {\n    left: 0;\n    border-right-color: $popover-arrow-outer-color;\n  }\n\n  .arrow::after {\n    left: $popover-border-width;\n    border-right-color: $popover-arrow-color;\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  .arrow {\n    top: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n  }\n\n  .arrow::before,\n  .arrow::after {\n    border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n  }\n\n  .arrow::before {\n    top: 0;\n    border-bottom-color: $popover-arrow-outer-color;\n  }\n\n  .arrow::after {\n    top: $popover-border-width;\n    border-bottom-color: $popover-arrow-color;\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: ($popover-arrow-width / -2);\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  .arrow {\n    right: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\n  }\n\n  .arrow::before,\n  .arrow::after {\n    border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n  }\n\n  .arrow::before {\n    right: 0;\n    border-left-color: $popover-arrow-outer-color;\n  }\n\n  .arrow::after {\n    right: $popover-border-width;\n    border-left-color: $popover-arrow-color;\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  font-size: $font-size-base;\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  $offset-border-width: calc(#{$border-radius-lg} - #{$popover-border-width});\n  @include border-top-radius($offset-border-width);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 2. .active.carousel-item is the current slide.\n// 3. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 4. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  align-items: center;\n  width: 100%;\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n  @include transition($carousel-transition);\n}\n\n.carousel-item-next,\n.carousel-item-prev {\n  position: absolute;\n  top: 0;\n}\n\n.carousel-item-next.carousel-item-left,\n.carousel-item-prev.carousel-item-right {\n  transform: translateX(0);\n\n  @supports (transform-style: preserve-3d) {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.carousel-item-next,\n.active.carousel-item-right {\n  transform: translateX(100%);\n\n  @supports (transform-style: preserve-3d) {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.carousel-item-prev,\n.active.carousel-item-left {\n  transform: translateX(-100%);\n\n  @supports (transform-style: preserve-3d) {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-duration: .6s;\n    transition-property: opacity;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    opacity: 0;\n  }\n\n  .carousel-item-next,\n  .carousel-item-prev,\n  .carousel-item.active,\n  .active.carousel-item-left,\n  .active.carousel-item-prev {\n    transform: translateX(0);\n\n    @supports (transform-style: preserve-3d) {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  color: $carousel-control-color;\n  text-align: center;\n  opacity: $carousel-control-opacity;\n  // We can't have a transition here because WebKit cancels the carousel\n  // animation if you trip this while in the middle of another animation.\n\n  // Hover/focus state\n  @include hover-focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: transparent no-repeat center center;\n  background-size: 100% 100%;\n}\n.carousel-control-prev-icon {\n  background-image: $carousel-control-prev-icon-bg;\n}\n.carousel-control-next-icon {\n  background-image: $carousel-control-next-icon-bg;\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    position: relative;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: rgba($carousel-indicator-active-bg, .5);\n\n    // Use pseudo classes to increase the hit area by 10px on top and bottom.\n    &::before {\n      position: absolute;\n      top: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\";\n    }\n    &::after {\n      position: absolute;\n      bottom: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\";\n    }\n  }\n\n  .active {\n    background-color: $carousel-indicator-active-bg;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: ((100% - $carousel-caption-width) / 2);\n  bottom: 20px;\n  left: ((100% - $carousel-caption-width) / 2);\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n}\n\n@mixin bg-gradient-variant($parent, $color) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .d#{$infix}-none         { display: none !important; }\n    .d#{$infix}-inline       { display: inline !important; }\n    .d#{$infix}-inline-block { display: inline-block !important; }\n    .d#{$infix}-block        { display: block !important; }\n    .d#{$infix}-table        { display: table !important; }\n    .d#{$infix}-table-row    { display: table-row !important; }\n    .d#{$infix}-table-cell   { display: table-cell !important; }\n    .d#{$infix}-flex         { display: flex !important; }\n    .d#{$infix}-inline-flex  { display: inline-flex !important; }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  .d-print-none         { display: none !important; }\n  .d-print-inline       { display: inline !important; }\n  .d-print-inline-block { display: inline-block !important; }\n  .d-print-block        { display: block !important; }\n  .d-print-table        { display: table !important; }\n  .d-print-table-row    { display: table-row !important; }\n  .d-print-table-cell   { display: table-cell !important; }\n  .d-print-flex         { display: flex !important; }\n  .d-print-inline-flex  { display: inline-flex !important; }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n.embed-responsive-21by9 {\n  &::before {\n    padding-top: percentage(9 / 21);\n  }\n}\n\n.embed-responsive-16by9 {\n  &::before {\n    padding-top: percentage(9 / 16);\n  }\n}\n\n.embed-responsive-4by3 {\n  &::before {\n    padding-top: percentage(3 / 4);\n  }\n}\n\n.embed-responsive-1by1 {\n  &::before {\n    padding-top: percentage(1 / 1);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { @include float-left; }\n    .float#{$infix}-right { @include float-right; }\n    .float#{$infix}-none  { @include float-none; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@mixin float-left {\n  float: left !important;\n}\n@mixin float-right {\n  float: right !important;\n}\n@mixin float-none {\n  float: none !important;\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n\n// Sass list not in variables since it's not intended for customization.\n// stylelint-disable-next-line scss/dollar-variable-default\n$positions: static, relative, absolute, fixed, sticky;\n\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate; }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light  { font-weight: $font-weight-light !important; }\n.font-weight-normal { font-weight: $font-weight-normal !important; }\n.font-weight-bold   { font-weight: $font-weight-bold !important; }\n.font-italic        { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color) {\n  #{$parent} {\n    color: $color !important;\n  }\n  a#{$parent} {\n    @include hover-focus {\n      color: darken($color, 10%) !important;\n    }\n  }\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @if ($ignore-warning != true) {\n    @warn \"The `text-hide()` mixin has been deprecated as of v4.1.0. It will be removed entirely in v5.\";\n  }\n}\n","//\n// Visibility utilities\n//\n\n.visible {\n  @include invisible(visible);\n}\n\n.invisible {\n  @include invisible(hidden);\n}\n","// stylelint-disable declaration-no-important\n\n// Visibility\n\n@mixin invisible($visibility) {\n  visibility: $visibility !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500;   // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    //\n    // Printing Tables:\n    // http://css-discuss.incutio.com/wiki/Printing_Tables\n    //\n\n    thead {\n      display: table-header-group;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","@import '../variable';\n\n/*******************\ntopbar color\n*******************/\n.topbar.fixed-header {\n    background: $dark;\n}\n\n/*******************\nStatic slide 10\n*******************/\n.static-slider-head{\n    min-height: 600px; \n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: auto;\n    background-size:cover;\n    background-position: center center;\n    .title{\n        color:$white;\n        font-weight: 700;\n        font-size: 70px;\n        line-height: 1000px;\n    }\n    .subtitle{\n        color:$white;\n        line-height: 30px;\n    }\n}\n/*******************\nHeader 1\n*******************/\n\n.h1-nav {\n    padding: 15px 0;\n    .navbar-nav .nav-item {\n        margin: 0 20px;\n        .nav-link {\n            padding: 12px 0px;\n            color: $muted;\n            font-weight: 400;\n            &:hover {\n                color: $success;\n            }\n        }\n        &:last-child {\n            margin-right: 0px;\n        }\n    }\n}\n/*******************\nHeader 2\n*******************/\n\n.h2-nav {\n    padding: 15px 0;\n    .navbar-nav .nav-item {\n        margin: 0 20px;\n        .nav-link {\n            padding: 12px 0px;\n            color: $white;\n            font-weight: 400;\n            &:hover {\n                color: $info;\n            }\n        }\n        &:last-child {\n            margin-right: 0px;\n        }\n    }\n}\n\n/*******************\nStatic slide 10\n*******************/\n.static-slider10 {\n    padding: 10% 0;\n    background-image: $banner-slider;\n    background-size:cover;\n    background-position: center center;\n    .title{\n        color:$white;\n        text-transform: uppercase;\n        font-weight: 700;\n        font-size: 48px;\n        line-height: 50px;\n    }\n    .subtitle{\n        color:$white;\n    }\n}\n@media(max-width:900px) {\n    .static-slider10 {\n        .title {\n            font-size:40px;\n            line-height: 45px;\n        }\n    }\n}\n\n/*******************\nStatic slide 3\n*******************/\n\n.static-slider3{\n    padding: 10% 0;\n    h1{\n        font-weight: 300;\n        line-height: 50px;\n        span{\n            border-bottom:3px solid $success;\n        }\n    }\n    \n}\n@media(max-width:767px) {\n.static-slider3{    \n        h1{\n            line-height: 30px;\n            font-size:24px;\n        } \n    }\n}\n\n/*******************\nform-banner 1\n*******************/\n\n#banner1 {\n    background: right -3em center no-repeat #e9f3f8;\n    background-image: $form-banner;\n    h2 {\n        font-size: 48px;\n        line-height: 1;\n        letter-spacing: -1px;\n    }\n    input {\n        line-height: 72px;\n        padding: 0;\n        margin: 0;\n        border: none;\n        display: inline-block;\n        vertical-align: top;\n    }\n    input[type=\"text\"] {\n        color: $bodytext;\n        border-radius: 36px 0 0 36px;\n        text-indent: 35px;\n        padding-right: 15px;\n        width: 61%;\n        font-weight: 300;\n        box-shadow: -5px 0 30px 0 rgba(0, 0, 0, 0.05);\n        text-overflow: ellipsis;\n    }\n    input[type=\"submit\"] {\n        border-radius: 0 36px 36px 0;\n        width: auto;\n        padding: 0 30px;\n        cursor: pointer;\n        margin-left: -4px;\n        box-shadow: 5px 0 30px 0 rgba(0, 0, 0, 0.05);\n        transition: all 0.5s ease-in-out;\n\n        &:hover {\n            opacity: 0.7;\n        }\n    }\n}\n\n@media (min-width: 2301px) and (max-width: 2700px) {\n    #banner1 {\n        background-position: 70% center;\n    }\n}\n\n@media (min-width: 1900px) and (max-width: 2300px) {\n    #banner1 {\n        background-position: 80% center;\n    }\n}\n\n@media (min-width: 1500px) and (max-width: 1680px) {\n    #banner1 {\n        background-position: right center;\n    }\n}\n\n@media (max-width: 1100px) {\n    #banner1 {\n        background-position: right -14em center;\n\n        h2 {\n            font-size: 40px;\n        }\n        input[type=\"text\"] {\n            width: 59%;\n        }\n        input[type=\"submit\"] {\n            padding: 0 20px;\n        }\n    }\n}\n\n@media (max-width: 992px) {\n    .banner {\n        height: auto !important;\n        padding: 100px 0;\n    }\n    #banner1 {\n        background-position: right -6em center;\n        background-size: 80%;\n\n        h2 {\n            font-size: 30px;\n        }\n    }\n}\n\n@media (max-width: 767px) {\n    .banner {\n        padding: 30px 0;\n    }\n    #banner1 {\n        background-size: 100%;\n        background-position: right center;\n\n        input[type=\"submit\"] {\n            padding: 0 30px;\n        }\n        img {\n            margin-top: 25px;\n        }\n    }\n}\n\n@media (max-width: 590px) {\n    #banner1 {\n        background-image: none;\n    }\n}\n\n@media (max-width: 428px) {\n    #banner1 {\n        input {\n            font-size: 14px;\n            line-height: 50px;\n        }\n        input[type=\"text\"] {\n            border-radius: 25px 0 0 25px;\n            text-indent: 20px;\n        }\n        input[type=\"submit\"] {\n            border-radius: 0 25px 25px 0;\n            padding: 0 15px;\n        }\n    }\n}\n\n@media (max-width: 320px) {\n    #banner1 {\n        input[type=\"submit\"] {\n            padding: 0 10px;\n        }\n    }\n}\n\n/*******************\nFeature 4\n*******************/\n\n.wrap-feature4-box {\n    .icon-round {\n        font-size: 45px;\n        width: 80px;\n        color: $themecolor;\n        line-height: 80px;\n        text-align: center;\n        display: inline-block;\n        margin: 20px 0 30px;\n        border-radius: 100%;\n    }\n}\n\n/*******************\nFeature 20\n*******************/\n.wrap-feature-20 {\n    margin-top: 60px;\n    [class*=col-lg-6] {\n        .card{\n            overflow: hidden;\n        }\n    }\n    .linking {\n        width: 100%;\n        display: block;\n        padding:35px 0;\n    }\n}\n\n/*******************\nFeature 30\n*******************/\n.feature30{\n    position: relative;\n}\n.wrap-feature30-box{\n    position: absolute;\n    top:20%;\n    right: 0px;\n}\n\n/*******************\nPortfolio 1\n*******************/\n.img-ho{\n    overflow:hidden;\n    img{\n        transition:0.1s ease-in;\n        &:hover{\n            transform:scale(1.1);\n        }\n    }\n}  \n\n/*******************\nPricing 8\n*******************/\n.pricing8{\n    .pricing-box{\n        sup{\n            top:-20px;\n            font-size: 16px;\n        }\n        .btn{\n            border-top-left-radius: 0px;\n            border-top-right-radius: 0px;\n        }   \n    }\n}\n\n/*******************\nteam 2\n*******************/ \n.team2{\n    .pro-pic{\n        min-height:200px;\n        background-position: center center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        &.t1 {\n            background-image: $t1;\n        }\n        &.t2 {\n            background-image: $t2;\n        }\n        &.t3 {\n            background-image: $t3;\n        }\n        &.t4 {\n            background-image: $t4;\n        }\n        .card-img-overlay{\n            background: rgba(26, 139, 243, 0.87);\n            display: none;\n            \n            ul{\n                position: relative;\n                top:50%;\n                text-align: center;\n                li a{\n                    color:$white;\n                    padding:0 10px;\n                    transition: 0.1s ease-in;\n                    display: block;\n                    &:hover{\n                        \n                        transform: translate3d(0px, -5px, 0px);\n                    }\n                }\n            }\n        }\n        &:hover{\n            .card-img-overlay{\n                display: block;\n            }\n        }\n    } \n    .title{\n        margin: 30px 0 0 0;\n    }\n    .subtitle{\n        margin: 0 0 20px 0; \n        font-size: 13px;\n    }\n}\n\n/*******************\nTestimonial 3\n*******************/\n  \n  .testimonial3 {\n      .testi3 {\n          .card-body {\n              padding: 40px;\n          }\n          h6 {\n              line-height: 26px;\n          }\n          .thumb-img {\n              img {\n                  width: 60px;\n              }\n          }\n          .customer {\n              text-transform: uppercase;\n              font-size: 14px;\n              font-weight: 500;\n          }\n      }\n  }\n\n/*******************\nBlog homepage 2\n*******************/\n  \n.blog-home2 {\n    [class*=col-] {\n          transition: 0.2s ease-in;\n          &:hover {\n              transform: translateY(-10px);\n          } \n      }\n    .date-pos{\n        padding: 10px;\n        display: inline-block;\n        position: absolute;\n        right:10px;\n        top:10px;\n        color:$white;\n        border-radius: $radius;\n        text-align: center;\n        span{\n            display: block;\n            font-size: 30px;\n            line-height: 30px;\n        }\n    }\n}\n\n/*******************\nResponsive\n*******************/\n@media(max-width:1024px) {\n    .static-slider10{\n        .title{\n                font-size:60px;\n                line-height: 60px;\n            }\n    }\n    .topbar {\n        background: $dark;\n    }\n\n}","/*\nTemplate Name: Wrakit UI Kit\nAuthor: wrappixel\nEmail: niravjoshi87@gmail.com\nFile: scss\n*/\n@import 'variable';\n/******************* \nThis is the font import from the google api \n*******************/\n@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800');\n/******************* \nGlobal Styles \n*******************/\n\n* {\n    outline: none;\n}\n\nbody {\n    background: $bodycolor;\n    font-family: $bodyfont;\n    margin: 0;\n    overflow-x: hidden;\n    color: $bodytext;\n    font-weight: 300;\n}\n\nhtml {\n    position: relative;\n    min-height: 100%;\n    background: $white;\n}\n\na:hover,\na:focus {\n    text-decoration: none;\n}\n\na.link {\n    color: $headingtext;\n\n    &:hover,\n    &:focus {\n        color: $themecolor;\n    }\n}\n\na.white-link {\n    color: $white;\n\n    &:hover,\n    &:focus {\n        color: $dark;\n    }\n}\n\n.img-responsive {\n    width: 100%;\n    height: auto;\n    display: inline-block;\n}\n\n.img-rounded {\n    border-radius: $radius;\n}\n\nhtml body .mdi:before,\nhtml body .mdi-set {\n    line-height: initial;\n}\n\n\n/*******************\nHeadings\n*******************/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    color: $headingtext;\n    font-family: $headingfont;\n}\n\nh1 {\n    line-height: 40px;\n    font-size: 36px\n}\n\nh2 {\n    line-height: 36px;\n    font-size: 30px\n}\n\nh3 {\n    line-height: 30px;\n    font-size: 24px\n}\n\nh4 {\n    line-height: 26px;\n    font-size: 21px\n}\n\nh5 {\n    line-height: 22px;\n    font-size: 18px;\n    font-weight: 400;\n}\n\nh6 {\n    line-height: 20px;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.display-5 {\n    font-size: 3rem;\n}\n\n.display-6 {\n    font-size: 36px;\n}\n\n.display-7 {\n    font-size: 26px;\n}\n\n.box {\n    border-radius: $radius;\n    padding: 10px;\n}\n\nhtml body {\n    .dl {\n        display: inline-block;\n    }\n\n    .db {\n        display: block;\n    }\n}\n\n.no-wrap {\n\n    td,\n    th {\n        white-space: nowrap;\n    }\n}\n\n.circle {\n    border-radius: 100%;\n}\n\n/*******************\nBlockquote\n*******************/\n\nhtml body blockquote {\n    border-left: 5px solid $themecolor;\n    border: 1px solid $border;\n    padding: 15px;\n}\n\n.clear {\n    clear: both;\n}\n\nol li {\n    margin: 5px 0;\n}\n\n\n/*******************\nPaddings\n*******************/\n\nhtml body {\n    .p-0 {\n        padding: 0px;\n    }\n\n    .p-10 {\n        padding: 10px;\n    }\n\n    .p-15 {\n        padding: 15px;\n    }\n\n    .p-20 {\n        padding: 20px;\n    }\n\n    .p-30 {\n        padding: 30px;\n    }\n\n    .p-40 {\n        padding: 40px;\n    }\n\n    .p-l-0 {\n        padding-left: 0px;\n    }\n\n    .p-l-10 {\n        padding-left: 10px;\n    }\n\n    .p-l-20 {\n        padding-left: 20px;\n    }\n\n    .p-r-0 {\n        padding-right: 0px;\n    }\n\n    .p-r-10 {\n        padding-right: 10px;\n    }\n\n    .p-r-20 {\n        padding-right: 20px;\n    }\n\n    .p-r-30 {\n        padding-right: 30px;\n    }\n\n    .p-r-40 {\n        padding-right: 40px;\n    }\n\n    .p-t-0 {\n        padding-top: 0px;\n    }\n\n    .p-t-10 {\n        padding-top: 10px;\n    }\n\n    .p-t-20 {\n        padding-top: 20px;\n    }\n\n    .p-t-30 {\n        padding-top: 30px;\n    }\n\n    .p-b-0 {\n        padding-bottom: 0px;\n    }\n\n    .p-b-5 {\n        padding-bottom: 5px;\n    }\n\n    .p-b-10 {\n        padding-bottom: 10px;\n    }\n\n    .p-b-20 {\n        padding-bottom: 20px;\n    }\n\n    .p-b-30 {\n        padding-bottom: 30px;\n    }\n\n    .p-b-40 {\n        padding-bottom: 40px;\n    }\n}\n\n\n/*******************\nMargin\n*******************/\n\nhtml body {\n    .m-0 {\n        margin: 0px;\n    }\n\n    .m-l-5 {\n        margin-left: 5px;\n    }\n\n    .m-l-10 {\n        margin-left: 10px;\n    }\n\n    .m-l-15 {\n        margin-left: 15px;\n    }\n\n    .m-l-20 {\n        margin-left: 20px;\n    }\n\n    .m-l-30 {\n        margin-left: 30px;\n    }\n\n    .m-l-40 {\n        margin-left: 40px;\n    }\n\n    .m-r-5 {\n        margin-right: 5px;\n    }\n\n    .m-r-10 {\n        margin-right: 10px;\n    }\n\n    .m-r-15 {\n        margin-right: 15px;\n    }\n\n    .m-r-20 {\n        margin-right: 20px;\n    }\n\n    .m-r-30 {\n        margin-right: 30px;\n    }\n\n    .m-r-40 {\n        margin-right: 40px;\n    }\n\n    .m-t-0 {\n        margin-top: 0px;\n    }\n\n    .m-t-5 {\n        margin-top: 5px;\n    }\n\n    .m-t-10 {\n        margin-top: 10px;\n    }\n\n    .m-t-15 {\n        margin-top: 15px;\n    }\n\n    .m-t-20 {\n        margin-top: 20px;\n    }\n\n    .m-t-30 {\n        margin-top: 30px;\n    }\n\n    .m-t-40 {\n        margin-top: 40px;\n    }\n\n    .m-b-0 {\n        margin-bottom: 0px;\n    }\n\n    .m-b-5 {\n        margin-bottom: 5px;\n    }\n\n    .m-b-10 {\n        margin-bottom: 10px;\n    }\n\n    .m-b-15 {\n        margin-bottom: 15px;\n    }\n\n    .m-b-20 {\n        margin-bottom: 20px;\n    }\n\n    .m-b-30 {\n        margin-bottom: 30px;\n    }\n\n    .m-b-40 {\n        margin-bottom: 40px;\n    }\n}\n\n\n/*******************\nvertical alignment\n*******************/\n\nhtml body {\n    .vt {\n        vertical-align: top;\n    }\n\n    .vm {\n        vertical-align: middle;\n    }\n\n    .vb {\n        vertical-align: bottom;\n    }\n}\n\n\n/*******************\nOpacity\n*******************/\n.op-8 {\n    opacity: 0.8;\n}\n\n.op-7 {\n    opacity: 0.7;\n}\n\n.op-5 {\n    opacity: 0.5;\n}\n\n.op-3 {\n    opacity: 0.3;\n}\n\n/*******************\nfont weight\n*******************/\n\nhtml body {\n    .font-bold {\n        font-weight: 700;\n    }\n\n    .font-semibold {\n        font-weight: 600;\n    }\n\n    .font-normal {\n        font-weight: normal;\n    }\n\n    .font-light {\n        font-weight: 300;\n    }\n\n    .font-medium {\n        font-weight: 500;\n    }\n\n    .font-16 {\n        font-size: 16px;\n    }\n\n    .font-14 {\n        font-size: 14px;\n    }\n\n    .font-13 {\n        font-size: 13px;\n    }\n\n    .font-10 {\n        font-size: 10px;\n    }\n\n    .font-18 {\n        font-size: 18px;\n    }\n\n    .font-20 {\n        font-size: 20px;\n    }\n\n    .font-stylish {\n        font-family: \"Calafia-Regular\";\n    }\n}\n\n\n/*******************\nBorder\n*******************/\n\nhtml body {\n    .b-0 {\n        border: none !important;\n    }\n\n    .b-r {\n        border-right: 1px solid $border;\n    }\n\n    .b-l {\n        border-left: 1px solid $border;\n    }\n\n    .b-b {\n        border-bottom: 1px solid $border;\n    }\n\n    .b-t {\n        border-top: 1px solid $border;\n    }\n\n    .b-all {\n        border: 1px solid $border !important;\n    }\n}\n\n\n/*******************\nThumb size\n*******************/\n\n.thumb-sm {\n    height: 32px;\n    width: 32px;\n}\n\n.thumb-md {\n    height: 48px;\n    width: 48px;\n}\n\n.thumb-lg {\n    height: 88px;\n    width: 88px;\n}\n\n.hide {\n    display: none;\n}\n\n.img-circle {\n    border-radius: 100%;\n}\n\n.radius {\n    border-radius: $radius;\n}\n\n\n/*******************\nText Colors\n*******************/\n\n.text-white {\n    color: $white !important;\n}\n\n.text-danger {\n    color: $danger !important;\n}\n\n.text-muted {\n    color: $muted !important;\n}\n\n.text-warning {\n    color: $warning !important;\n}\n\n.text-success {\n    color: $success !important;\n}\n\n.text-info {\n    color: $info !important;\n}\n\n.text-inverse {\n    color: $inverse !important;\n}\n\n.text-success-gradiant {\n    @include linear-gradient (to right, $success 0%, $success-dark 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    text-fill-color: transparent;\n}\n\n.text-info-gradiant {\n    @include linear-gradient (to right, $info 0%, $primary 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    text-fill-color: transparent;\n}\n\nhtml body {\n    .text-blue {\n        color: $blue;\n    }\n\n    .text-purple {\n        color: $purple;\n    }\n\n    .text-primary {\n        color: $primary !important;\n    }\n\n    .text-megna {\n        color: $megna;\n    }\n\n    .text-dark {\n        color: $bodytext;\n    }\n\n    .text-themecolor {\n        color: $themecolor;\n    }\n}\n\n\n/*******************\nBackground Colors\n*******************/\n\n.bg-primary {\n    background-color: $primary !important;\n}\n\n.bg-success {\n    background-color: $success !important;\n}\n\n.bg-info {\n    background-color: $info !important;\n}\n\n.bg-warning {\n    background-color: $warning !important;\n}\n\n.bg-danger {\n    background-color: $danger !important;\n}\n\n.bg-orange {\n    background-color: $orange !important;\n}\n\n.bg-yellow {\n    background-color: $yellow;\n}\n\n.bg-facebook {\n    background-color: $facebook;\n}\n\n.bg-twitter {\n    background-color: $twitter;\n}\n\n.bg-success-gradiant {\n    @include linear-gradient (to right, $success 0%, $success-dark 100%);\n}\n\n.bg-info-gradiant {\n    @include linear-gradient (to right, $info 0%, $primary 100%);\n}\n\n.bg-danger-gradiant {\n    @include linear-gradient (to right, $danger 0%, $orange 100%);\n}\n\nhtml body {\n    .bg-megna {\n        background-color: $megna;\n    }\n\n    .bg-theme {\n        background-color: $themecolor;\n    }\n\n    .bg-inverse {\n        background-color: $inverse;\n    }\n\n    .bg-purple {\n        background-color: $purple;\n    }\n\n    .bg-light {\n        background-color: $light !important;\n    }\n\n    .bg-light-primary {\n        background-color: $light-primary;\n    }\n\n    .bg-light-success {\n        background-color: $light-success;\n    }\n\n    .bg-light-info {\n        background-color: $light-info;\n    }\n\n    .bg-light-extra {\n        background-color: $extra-light;\n    }\n\n    .bg-light-warning {\n        background-color: $light-warning;\n    }\n\n    .bg-light-danger {\n        background-color: $light-danger;\n    }\n\n    .bg-light-inverse {\n        background-color: $light-inverse;\n    }\n\n    .bg-light {\n        background-color: $light;\n    }\n\n    .bg-white {\n        background-color: $white;\n    }\n}\n\n\n/*******************\nRounds\n*******************/\n\n.round {\n    line-height: 48px;\n    color: $white;\n    width: 50px;\n    height: 50px;\n    display: inline-block;\n    font-weight: 400;\n    text-align: center;\n    border-radius: 100%;\n    background: $info;\n\n    img {\n        border-radius: 100%;\n    }\n}\n\n.round-lg {\n    line-height: 65px;\n    width: 60px;\n    height: 60px;\n    font-size: 30px;\n}\n\n.round.round-info {\n    background: $info;\n}\n\n.round.round-warning {\n    background: $warning;\n}\n\n.round.round-danger {\n    background: $danger;\n}\n\n.round.round-success {\n    background: $success;\n}\n\n.round.round-primary {\n    background: $primary;\n}\n\n\n/*******************\nLabels\n*******************/\n\n.label {\n    padding: 3px 15px;\n    line-height: 13px;\n    color: $white;\n    font-weight: 400;\n    border-radius: $radius;\n    font-size: 75%;\n}\n\n.label-rounded {\n    border-radius: 60px;\n}\n\n.label-custom {\n    background-color: $megna;\n}\n\n.label-success {\n    background-color: $success;\n}\n\n.label-info {\n    background-color: $info;\n}\n\n.label-warning {\n    background-color: $warning;\n}\n\n.label-danger {\n    background-color: $danger;\n}\n\n.label-megna {\n    background-color: $megna;\n}\n\n.label-primary {\n    background-color: $primary;\n}\n\n.label-purple {\n    background-color: $purple;\n}\n\n.label-red {\n    background-color: $red;\n}\n\n.label-inverse {\n    background-color: $inverse;\n}\n\n.label-default {\n    background-color: $light;\n}\n\n.label-white {\n    background-color: $white;\n}\n\n.label-light-success {\n    background-color: $light-success;\n    color: $success;\n}\n\n.label-light-info {\n    background-color: $light-info;\n    color: $info;\n}\n\n.label-light-warning {\n    background-color: $light-warning;\n    color: $warning;\n}\n\n.label-light-danger {\n    background-color: $light-danger;\n    color: $danger;\n}\n\n.label-light-megna {\n    background-color: $light-megna;\n    color: $megna;\n}\n\n.label-light-primary {\n    background-color: $light-primary;\n    color: $primary;\n}\n\n.label-light-inverse {\n    background-color: $light-inverse;\n    color: $inverse;\n}\n\n\n/*******************\n Badge\n******************/\n\n.badge {\n    font-weight: 400;\n}\n\n.badge-xs {\n    font-size: 9px;\n}\n\n.badge-xs,\n.badge-sm {\n    -webkit-transform: translate(0, -2px);\n    -ms-transform: translate(0, -2px);\n    -o-transform: translate(0, -2px);\n    transform: translate(0, -2px);\n}\n\n.badge-success {\n    background-color: $success;\n}\n\n.badge-info {\n    background-color: $info;\n}\n\n.badge-primary {\n    background-color: $primary;\n}\n\n.badge-warning {\n    background-color: $warning;\n}\n\n.badge-danger {\n    background-color: $danger;\n}\n\n.badge-purple {\n    background-color: $purple;\n}\n\n.badge-red {\n    background-color: $red;\n}\n\n.badge-inverse {\n    background-color: $inverse;\n}\n\n\n/*******************\nList-style-none\n******************/\n\nul.list-style-none {\n    margin: 0px;\n    padding: 0px;\n\n    li {\n        list-style: none;\n\n        a {\n            color: $bodytext;\n            padding: 8px 0px;\n            display: block;\n            text-decoration: none;\n\n            &:hover {\n                color: $themecolor;\n            }\n        }\n    }\n}\n\n\n/*******************\ndropdown-item\n******************/\n\n.dropdown-item {\n    padding: 8px 1rem;\n    color: $bodytext;\n}\n\n/*******************\nButtons\n******************/\n.btn {\n    color: $white;\n    padding: 10px 25px;\n    cursor: pointer;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.14);\n    transition: 0s;\n\n    &:hover {\n        color: $white;\n    }\n\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n.btn-link {\n    box-shadow: none;\n    color: $dark;\n    padding: 10px 15px;\n\n    .underline {\n        border-bottom: 1px solid $dark;\n    }\n\n    &:hover {\n        color: $success;\n    }\n}\n\n.btn-light {\n    color: $dark;\n\n    &:hover {\n        background: $dark;\n        color: $white;\n        border-color: $dark;\n    }\n}\n\n.btn-lg {\n    padding: .75rem 1.5rem;\n    font-size: 1.25rem;\n}\n\n.btn-md {\n    padding: 15px 45px;\n    font-size: 16px;\n}\n\n.btn-sm {\n    padding: .25rem .5rem;\n    font-size: 12px;\n}\n\n.btn-xs {\n    padding: .25rem .5rem;\n    font-size: 10px;\n}\n\n.btn-circle {\n    border-radius: 100%;\n    width: 40px;\n    height: 40px;\n    padding: 10px;\n\n    &.btn-md {\n        padding: 22px 25px;\n    }\n}\n\n.btn-circle.btn-sm {\n    width: 35px;\n    height: 35px;\n    padding: 8px 10px;\n    font-size: 14px;\n}\n\n.btn-circle.btn-lg {\n    width: 50px;\n    height: 50px;\n    padding: 14px 15px;\n    font-size: 18px;\n    line-height: 23px;\n}\n\n.btn-circle.btn-xl {\n    width: 70px;\n    height: 70px;\n    padding: 14px 15px;\n    font-size: 24px;\n}\n\n.btn-rounded {\n    border-radius: 60px;\n    -webkit-border-radius: 60px;\n}\n\n.btn-arrow {\n    position: relative;\n\n    span {\n        display: inline-block;\n        position: relative;\n        transition: all 300ms ease-out;\n        will-change: transform;\n    }\n\n    &:hover span,\n    &:focus span {\n        transform: translate3d(-1rem, 0, 0);\n    }\n\n    i {\n        position: absolute;\n        width: 1.1em;\n        right: 0px;\n        right: 0rem;\n        opacity: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        transition: all 300ms ease-out;\n        will-change: right, opacity;\n    }\n\n    &:hover i,\n    &:focus i {\n        opacity: 1;\n        right: -2rem;\n    }\n}\n\n.btn-primary,\n.btn-primary.disabled {\n    background: $primary;\n    border: 1px solid $primary;\n\n    transition: 0.2s ease-in;\n\n    &:hover {\n        background: $primary-dark;\n        border: 1px solid $primary-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $primary-dark;\n    }\n}\n\n.btn-themecolor,\n.btn-themecolor.disabled {\n    background: $themecolor;\n    color: $white;\n    border: 1px solid $themecolor;\n\n    &:hover {\n        background: $themecolor-dark;\n\n        border: 1px solid $themecolor-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $themecolor-dark;\n    }\n\n}\n\n.btn-success,\n.btn-success.disabled {\n    background: $success;\n    border: 1px solid $success;\n\n    &:hover {\n        background: $success-dark;\n        border: 1px solid $success-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $success-dark;\n\n    }\n}\n\n.btn-info,\n.btn-info.disabled {\n    background: $info;\n    border: 1px solid $info;\n\n    transition: 0.2s ease-in;\n\n    &:hover {\n        background: $info-dark;\n        border: 1px solid $info-dark;\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $info-dark;\n\n    }\n}\n\n.btn-warning,\n.btn-warning.disabled {\n    background: $warning;\n    color: $white;\n    border: 1px solid $warning;\n\n    &:hover {\n        background: $warning-dark;\n        color: $white;\n\n        border: 1px solid $warning-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $warning-dark;\n        color: $white;\n\n    }\n}\n\n.btn-danger,\n.btn-danger.disabled {\n    background: $danger;\n    border: 1px solid $danger;\n\n    transition: 0.2s ease-in;\n\n    &:hover {\n        background: $danger-dark;\n\n        border: 1px solid $danger-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $danger-dark;\n\n    }\n}\n\n.btn-inverse,\n.btn-inverse.disabled {\n    background: $inverse;\n    border: 1px solid $inverse;\n    color: $white;\n\n    &:hover {\n        background: $inverse-dark;\n\n        color: $white;\n        border: 1px solid $inverse-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $inverse-dark;\n        color: $white;\n    }\n}\n\n.btn-red,\n.btn-red.disabled {\n    background: $red;\n    border: 1px solid $red;\n    color: $white;\n\n    &:hover {\n\n        border: 1px solid $red-dark;\n        background: $red-dark;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $danger-dark;\n    }\n}\n\n.btn-success-gradiant {\n    @include linear-gradient (to right, $success 0%, $success-dark 100%);\n    border: 0px;\n\n    &:hover {\n        @include linear-gradient (to right, $success-dark 0%, $success 100%);\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        box-shadow: 0px;\n        opacity: 1;\n    }\n}\n\n.btn-danger-gradiant {\n    @include linear-gradient (to right, $danger 0%, $orange 100%);\n    border: 0px;\n\n    &:hover {\n        @include linear-gradient (to right, $orange 0%, $danger 100%);\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        box-shadow: 0px;\n        opacity: 1;\n    }\n}\n\n.btn-info-gradiant {\n    @include linear-gradient (to right, $info 0%, $primary 100%);\n    border: 0px;\n\n    &:hover {\n        @include linear-gradient (to right, $primary 0%, $info 100%);\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        box-shadow: 0px;\n        opacity: 1;\n    }\n}\n\n.btn-outline-secondary {\n    background-color: $white;\n    color: $secondary;\n    transition: 0.2s ease-in;\n\n    &:hover,\n    &:focus,\n    &.focus {}\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $dark;\n    }\n}\n\n.btn-outline-primary {\n    color: $primary;\n    background-color: $white;\n    border-color: $primary;\n    transition: 0.2s ease-in;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $primary;\n        color: $white;\n        border-color: $primary;\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $primary-dark;\n    }\n}\n\n.btn-outline-success,\na.btn-outline-success {\n    color: $success;\n    background-color: transparent;\n    border-color: $success;\n\n    transition: 0.2s ease-in;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $success;\n        border-color: $success;\n        color: $white;\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $success-dark;\n    }\n}\n\n.btn-outline-info {\n    color: $info;\n    background-color: transparent;\n    border-color: $info;\n\n    transition: 0.2s ease-in;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $info;\n        border-color: $info;\n        color: $white;\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $info-dark;\n    }\n}\n\n.btn-outline-warning {\n    color: $warning;\n    background-color: transparent;\n    border-color: $warning;\n\n    transition: 0.2s ease-in;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $warning;\n        border-color: $warning;\n        color: $white;\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $warning-dark;\n    }\n}\n\n.btn-outline-danger {\n    color: $danger;\n    background-color: transparent;\n    border-color: $danger;\n\n    transition: 0.2s ease-in;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $danger;\n        border-color: $danger;\n        color: $white;\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $danger-dark;\n    }\n}\n\n.btn-outline-red {\n    color: $red;\n    background-color: transparent;\n    border-color: $red;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $red;\n        border-color: $red;\n        color: $white;\n\n    }\n\n    &.active,\n    &:active,\n    &:focus {\n        background: $danger-dark;\n    }\n}\n\n.btn-outline-inverse {\n    color: $inverse;\n    background-color: transparent;\n    border-color: $inverse;\n\n    &:hover,\n    &:focus,\n    &.focus {\n        background: $inverse;\n        border-color: $inverse;\n        color: $white;\n    }\n}\n\n.btn-outline-light:hover {\n    color: $dark !important;\n}\n\n.btn-primary.active.focus,\n.btn-primary.active:focus,\n.btn-primary.active:hover,\n.btn-primary.focus:active,\n.btn-primary:active:focus,\n.btn-primary:active:hover,\n.open>.dropdown-toggle.btn-primary.focus,\n.open>.dropdown-toggle.btn-primary:focus,\n.open>.dropdown-toggle.btn-primary:hover,\n.btn-primary.focus,\n.btn-primary:focus {\n    background-color: $primary-dark;\n    border: 1px solid $primary-dark;\n}\n\n.btn-success.active.focus,\n.btn-success.active:focus,\n.btn-success.active:hover,\n.btn-success.focus:active,\n.btn-success:active:focus,\n.btn-success:active:hover,\n.open>.dropdown-toggle.btn-success.focus,\n.open>.dropdown-toggle.btn-success:focus,\n.open>.dropdown-toggle.btn-success:hover,\n.btn-success.focus,\n.btn-success:focus {\n    background-color: $success-dark;\n    border: 1px solid $success-dark;\n}\n\n.btn-info.active.focus,\n.btn-info.active:focus,\n.btn-info.active:hover,\n.btn-info.focus:active,\n.btn-info:active:focus,\n.btn-info:active:hover,\n.open>.dropdown-toggle.btn-info.focus,\n.open>.dropdown-toggle.btn-info:focus,\n.open>.dropdown-toggle.btn-info:hover,\n.btn-info.focus,\n.btn-info:focus {\n    background-color: $info-dark;\n    border: 1px solid $info-dark;\n}\n\n.btn-warning.active.focus,\n.btn-warning.active:focus,\n.btn-warning.active:hover,\n.btn-warning.focus:active,\n.btn-warning:active:focus,\n.btn-warning:active:hover,\n.open>.dropdown-toggle.btn-warning.focus,\n.open>.dropdown-toggle.btn-warning:focus,\n.open>.dropdown-toggle.btn-warning:hover,\n.btn-warning.focus,\n.btn-warning:focus {\n    background-color: $warning-dark;\n    border: 1px solid $warning-dark;\n}\n\n.btn-danger.active.focus,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.btn-danger.focus:active,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.open>.dropdown-toggle.btn-danger.focus,\n.open>.dropdown-toggle.btn-danger:focus,\n.open>.dropdown-toggle.btn-danger:hover,\n.btn-danger.focus,\n.btn-danger:focus {\n    background-color: $danger-dark;\n    border: 1px solid $danger-dark;\n}\n\n.btn-inverse:hover,\n.btn-inverse:focus,\n.btn-inverse:active,\n.btn-inverse.active,\n.btn-inverse.focus,\n.btn-inverse:active,\n.btn-inverse:focus,\n.btn-inverse:hover,\n.open>.dropdown-toggle.btn-inverse {\n    background-color: $inverse-dark;\n    border: 1px solid $inverse-dark;\n\n}\n\n.btn-red:hover,\n.btn-red:focus,\n.btn-red:active,\n.btn-red.active,\n.btn-red.focus,\n.btn-red:active,\n.btn-red:focus,\n.btn-red:hover,\n.open>.dropdown-toggle.btn-red {\n    background-color: $red-dark;\n    border: 1px solid $red-dark;\n    color: $white;\n}\n\n.btn {\n    span.btn-devider {\n        display: inline-block;\n        padding-left: 10px;\n\n    }\n}\n\n/*-------------------*/\n/*On off switch*/\n/*-------------------*/\n.onoffswitch {\n    position: relative;\n    width: 70px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    margin: 0 auto;\n}\n\n.onoffswitch-checkbox {\n    display: none;\n}\n\n.onoffswitch-label {\n    display: block;\n    overflow: hidden;\n    cursor: pointer;\n    border: 2px solid transparent;\n    border-radius: 20px;\n}\n\n.onoffswitch-inner {\n    display: block;\n    width: 200%;\n    margin-left: -100%;\n    transition: margin 0.3s ease-in 0s;\n\n    &:before,\n    &:after {\n        display: block;\n        float: left;\n        width: 50%;\n        height: 30px;\n        padding: 0;\n        line-height: 30px;\n        font-size: 14px;\n        color: white;\n        box-sizing: border-box;\n    }\n\n    &:before {\n        content: \"\";\n        padding-right: 27px;\n        background-color: $success;\n        color: #FFFFFF;\n    }\n\n    &:after {\n        content: \"\";\n        padding-right: 24px;\n        background-color: $inverse;\n        color: #999999;\n        text-align: right;\n    }\n}\n\n.onoffswitch-switch {\n    display: block;\n    width: 23px;\n    margin: 6px;\n    background: #FFFFFF;\n    height: 23px;\n    position: absolute;\n    top: -1px;\n    bottom: 0;\n    right: 35px;\n\n    border-radius: 20px;\n    transition: all 0.3s ease-in 0s;\n}\n\n.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {\n    margin-left: 0;\n}\n\n.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {\n    right: 0px;\n}\n\n\n/*-------------------*/\n/*Bootstrap 4 hack*/\n/*-------------------*/\n.card-columns {\n    column-gap: 30px;\n\n    .card {\n        margin-bottom: 30px;\n    }\n}\n\n.invisible {\n    visibility: hidden !important;\n}\n\n.hidden-xs-up {\n    display: none !important;\n}\n\n@media (max-width: 575px) {\n    .hidden-xs-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 576px) {\n    .hidden-sm-up {\n        display: none !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .hidden-sm-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .hidden-md-up {\n        display: none !important;\n    }\n}\n\n@media (max-width: 991px) {\n    .hidden-md-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .hidden-lg-up {\n        display: none !important;\n    }\n}\n\n@media (max-width: 1199px) {\n    .hidden-lg-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .hidden-xl-up {\n        display: none !important;\n    }\n}\n\n.hidden-xl-down {\n    display: none !important;\n}\n\n.coming-soon {\n    min-height: 400px;\n    overflow: auto;\n    background-size: cover;\n    background-position: top 20% center;\n    background-image: $c2a-image;\n}","/*\nTemplate Name: Wrakit UI Kit\nAuthor: wrappixel\nEmail: niravjoshi87@gmail.com\nFile: scss\n*/\n\n\n/******************* \nTopbar\n*******************/\n\n.topbar {\n    padding: 0px;\n    transition: 0.2s ease-in;\n    width: 100%;\n    position: absolute;\n    z-index: 20;\n}\n\n/*******************\nHeader 6\n*******************/\n.header6 {\n    .navbar-toggler {\n        color: $white;\n    }\n\n    .navbar-brand {\n        line-height: 80px;\n    }\n}\n\n.h6-nav-bar {\n    padding: 0px;\n\n    .navbar-nav {\n        .nav-link {\n            padding: 35px 15px;\n            color: rgba(255, 255, 255, 0.5);\n            transition-duration: 1.2s;\n            transition-timing-function: cubic-bezier(0.1, 0.7, 1.0, 0.1);\n        }\n\n        .nav-item:hover .nav-link,\n        .nav-item.active .nav-link {\n            color: rgba(255, 255, 255, 1);\n        }\n    }\n\n    .act-buttons {\n        .btn {\n            margin: 10px 0 10px 10px;\n        }\n    }\n}\n\n@media(max-width:1023px) {\n    .h6-nav-bar {\n        .navbar-nav {\n            .nav-link {\n                padding: 15px 15px;\n            }\n        }\n\n        .act-buttons {\n            .btn {\n                margin: 10px 0 10px 0px;\n            }\n        }\n    }\n}\n\n.static-slider-head {\n    min-height: 600px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: auto;\n    background-size: cover;\n    background-position: center center;\n    background-image: $banner-image;\n\n    .title {\n        color: $white;\n        font-weight: 700;\n        font-size: 70px;\n        line-height: 100px;\n    }\n\n    .subtitle {\n        color: $white;\n        line-height: 30px;\n    }\n}\n\n.carousel-item>img {\n    width: 100%;\n}\n\n\n/******************* \nMain & Page wrapper\n*******************/\n\n.page-wrapper {\n    padding-top: 0px;\n}\n\n#main-wrapper {\n    overflow: hidden;\n}\n\n\n/******************* \ncontainer fluid\n*******************/\n\n.container-fluid {\n    padding: 0px;\n}\n\n\n/******************* \nfooter\n*******************/\n\n.footer {\n    padding: 20px 0;\n    text-align: center;\n}\n\n\n/******************* \nFix-width\n*******************/\n\n.fix-width {\n    width: 100%;\n    max-width: 1170px;\n    margin: 0 auto;\n    padding: 0 15px;\n}\n\n\n/******************* \nSpacer\n*******************/\n\n.spacer {\n    padding: 90px 0;\n}\n\n.mini-spacer {\n    padding: 40px 0;\n}\n\n\n/******************* \nTitle\n*******************/\n\n.title {\n    margin: 20px 0 15px;\n}\n\n\n/******************* \nSubtitle\n*******************/\n\n.subtitle {\n    color: $muted;\n    line-height: 24px;\n}\n\n\n/******************* \ncard\n*******************/\n\n.card {\n    border: 0px;\n    margin-bottom: 30px;\n\n    &.card-shadow {\n        box-shadow: $card-shadow;\n    }\n}\n\n.card-group .card {\n    border: 1px solid $border;\n    margin-bottom: 30px;\n}\n\n\n/******************* \nIcon space\n*******************/\n\n.icon-space {\n    margin: 20px 0;\n}\n\n.linking {\n    color: $headingtext;\n\n    i {\n        font-size: 14px;\n        margin-left: 10px;\n        transition: 0.2s ease-in;\n    }\n\n    &:hover {\n        color: $themecolor;\n\n        i {\n            margin-left: 15px;\n        }\n    }\n}\n\n\n/******************* \nListing\n*******************/\n\n.list-block {\n    margin: 0px;\n    padding: 0px;\n\n    li {\n        list-style: none;\n        padding: 10px 0;\n        display: flex;\n\n        i {\n            margin-right: 10px;\n            flex-shrink: 0px;\n            margin-top: 3px;\n        }\n    }\n\n    &.with-underline {\n        li {\n            border-bottom: 1px solid $border;\n            padding: 15px 0;\n        }\n    }\n}\n\n\n/******************* \nListing\n*******************/\n\n.img-inline {\n    margin: 0px;\n    padding: 0px;\n\n    li {\n        list-style: none;\n\n        &.half-width {\n            width: 49%;\n            display: inline-block;\n            vertical-align: top;\n        }\n    }\n}\n\n\n/******************* \nImage shadow\n*******************/\n\n.img-shadow {\n    box-shadow: $img-shadow;\n}\n\n\n/******************* \nImage shadow\n*******************/\n\n.icon-round {\n    width: 80px;\n    line-height: 80px;\n    text-align: center;\n    border-radius: 100%;\n    display: inline-block;\n}\n\n.no-shrink {\n    flex-shrink: 0;\n}\n\n\n/******************* \nup section\n*******************/\n\n.up {\n    z-index: 10;\n    position: relative;\n}\n\n.bt-top {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 100;\n    visibility: hidden;\n}\n\n\n/******************* \nboth space\n*******************/\n\n.both-space {\n    margin: 80px 0;\n}\n\n\n/******************* \nSide text content\n*******************/\n\n.side-content {\n    padding: 40px 60px;\n}\n\n\n/******************* \nbackground cover\n*******************/\n\n.bg-cover {\n    background-size: cover;\n    min-height: 200px;\n}\n\n\n/******************* \nOwl carousel\n*******************/\n\n.owl-carousel {\n    display: block;\n    width: 100%;\n\n    .owl-stage-outer {\n        position: relative;\n        overflow: hidden;\n    }\n\n    .owl-stage {\n        position: relative;\n    }\n\n    .owl-item {\n        float: left;\n    }\n\n    .owl-nav.disabled {\n        display: none;\n    }\n}\n\n\n/******************* \nMax width\n*******************/\n\n.max-300 {\n    max-width: 300px;\n}\n\n.max-400 {\n    max-width: 400px;\n}\n\n.max-500 {\n    max-width: 500px;\n}\n\n.max-600 {\n    max-width: 600px;\n}\n\n\n/******************* \nline sticks\n*******************/\n\n.stick-bottom {\n    position: relative;\n    margin-bottom: 30px;\n\n    >span {\n        width: 30px;\n        height: 2px;\n        position: absolute;\n        bottom: -7px;\n        left: 0px;\n        display: inline-block;\n    }\n}\n\n\n/******************* \nposition\n*******************/\n\n.po-absolute {\n    position: absolute;\n}\n\n.po-relative {\n    position: relative;\n}\n\n\n/*-------------------*/\n\n\n/*Bootstrap 4 hack*/\n\n\n/*-------------------*/\n\n.invisible {\n    visibility: hidden !important;\n}\n\n.hidden-xs-up {\n    display: none !important;\n}\n\n@media (max-width: 575px) {\n    .hidden-xs-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 576px) {\n    .hidden-sm-up {\n        display: none !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .hidden-sm-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .hidden-md-up {\n        display: none !important;\n    }\n}\n\n@media (max-width: 991px) {\n    .hidden-md-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .hidden-lg-up {\n        display: none !important;\n    }\n}\n\n@media (max-width: 1199px) {\n    .hidden-lg-down {\n        display: none !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .hidden-xl-up {\n        display: none !important;\n    }\n}\n\n.hidden-xl-down {\n    display: none !important;\n}\n\n\n/*************/\n\n\n/* Dropdown*/\n\n\n/*************/\n\n.navbar-nav .dropdown-toggle {\n    &::after {\n        display: none;\n    }\n}\n\n.navbar-nav .dropdown-menu.b-none {\n    border: 0px;\n    box-shadow: $card-shadow;\n}\n\n.navbar-nav {\n    font-weight: 400;\n}\n\n.navbar-nav .dropdown-menu.b-none {\n    border: 0px;\n    box-shadow: $card-shadow;\n}\n\n.pre-scroll {\n    position: relative;\n}\n\n.mega-dropdown {\n    position: relative;\n\n    .dropdown-menu {\n        width: 100%;\n        min-width: 400px !important;\n        padding: 30px;\n        margin-top: 0px;\n        overflow: hidden;\n        right: 0;\n        left: unset;\n    }\n\n    .list-style-none {\n        font-size: 14px;\n    }\n\n    .inside-bg {\n        margin: -30px 0 -30px -30px;\n    }\n\n    .inside-bg-right {\n        margin: -30px -30px -30px 0;\n    }\n\n    .bg-img {\n        background-size: cover;\n        height: 100%;\n        padding: 30px;\n    }\n\n    h6 {\n        margin: 15px 0;\n        font-size: 15px;\n    }\n}\n\n/*************/\n/* General Listing*/\n/*************/\n\n.general-listing {\n    padding: 0px;\n    margin: 0px;\n\n    li {\n        list-style: none;\n\n        a {\n            color: $bodytext;\n            display: flex;\n            padding: 10px 0;\n            transition: 0.2s ease-in;\n            align-items: center;\n        }\n\n        &:hover a {\n            color: $themecolor;\n            padding-left: 10px;\n        }\n\n        i {\n            margin-right: 7px;\n            vertical-align: middle;\n        }\n    }\n\n    &.two-part {\n        li {\n            width: 49%;\n            display: inline-block;\n        }\n    }\n\n    &.only-li {\n        li {\n            padding: 5px 0;\n        }\n    }\n}\n\n\n/*************/\n\n\n/* form dark*/\n\n\n/*************/\n\n.form-control-dark {\n    background: $border;\n    color: $white;\n    border-color: $border;\n\n    &:focus {\n        background: $border;\n        color: $white;\n    }\n}\n\n\n/*************/\n\n\n/* social-round */\n\n\n/*************/\n\n.round-social {\n    a {\n        width: 50px;\n        height: 50px;\n        line-height: 50px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 100%;\n        margin: 0 5px;\n        transition: 0.2s ease-in;\n\n        &:hover {\n            transform: translate3d(0px, -5px, 0px);\n        }\n    }\n\n    &.light {\n        a {\n            color: $dark;\n            background: $light;\n        }\n\n        a:hover {\n            background: $dark;\n            color: $white;\n        }\n    }\n}\n\n\n/*************/\n\n\n/* Form Banner */\n\n\n/*************/\n\n.banner {\n    position: relative;\n    max-height: 700px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center top;\n    width: 100%;\n    display: table;\n\n    .banner-content {\n        display: table-cell;\n        vertical-align: middle;\n        width: 100%;\n    }\n}\n\n@media (max-width: 992px) {\n    .banner {\n        height: auto !important;\n        padding: 100px 0;\n    }\n}\n\n@media (max-width: 767px) {\n    .banner {\n        padding: 30px 0;\n    }\n}\n\n.form-control {\n    padding: .75rem;\n    border: 2px solid $border;\n}\n\nselect.form-control:not([size]):not([multiple]) {\n    height: calc(2.25rem + 12px);\n}\n\n\n/*******************\nUI-Elements\n******************/\n\n\n/*******************\nButtons\n******************/\n\n.button-group {\n    .btn {\n        margin-bottom: 7px;\n    }\n}\n\n\n/*******************\nGrid page\n******************/\n\n.show-grid {\n    margin-bottom: 10px;\n    padding: 0 15px\n}\n\n.show-grid [class^=col-] {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border: 1px solid $border;\n    background-color: $light;\n}\n\n\n/*******************\nlist and media\n******************/\n\n.list-group a.list-group-item:hover {\n    background: $light;\n}\n\n.list-group-item.active,\n.list-group .list-group-item.active:hover {\n    background: $themecolor;\n    border-color: $themecolor;\n}\n\n.list-group-item.disabled {\n    color: $muted;\n    background: $light;\n}\n\n.media {\n    border: 1px solid $border;\n    margin-bottom: 10px;\n    padding: 15px;\n}\n\n\n/*******************\nNotification page Jquery toaster\n******************/\n\n.alert-rounded {\n    border-radius: 60px;\n}\n\n\n/*******************\nProgress bar\n******************/\n\n.progress.active .progress-bar,\n.progress-bar.active {\n    -webkit-animation: progress-bar-stripes 2s linear infinite;\n    -o-animation: progress-bar-stripes 2s linear infinite;\n    animation: progress-bar-stripes 2s linear infinite;\n}\n\n.progress-vertical {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n}\n\n.progress-vertical-bottom {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n    transform: rotate(180deg);\n}\n\n.progress-animated {\n    -webkit-animation-duration: 5s;\n    -webkit-animation-name: myanimation;\n    -webkit-transition: 5s all;\n    animation-duration: 5s;\n    animation-name: myanimation;\n    transition: 5s all;\n}\n\n@-webkit-keyframes myanimation {\n    from {\n        width: 0;\n    }\n}\n\n@keyframes myanimation {\n    from {\n        width: 0;\n    }\n}\n\n\n/*******************\nVertical tabs\n******************/\n\n.vtabs {\n    display: table;\n\n    .tabs-vertical {\n        width: 150px;\n        border-bottom: 0px;\n        border-right: 1px solid $border;\n        display: table-cell;\n        vertical-align: top;\n\n        li .nav-link {\n            color: $dark;\n            margin-bottom: 10px;\n            border: 0px;\n            border-radius: $radius 0 0 $radius;\n        }\n    }\n\n    .tab-content {\n        display: table-cell;\n        padding: 20px;\n        vertical-align: top;\n    }\n}\n\n.tabs-vertical li .nav-link.active,\n.tabs-vertical li .nav-link:hover,\n.tabs-vertical li .nav-link.active:focus {\n    background: $themecolor;\n    border: 0px;\n    color: $white;\n}\n\n\n/*Custom vertical tab*/\n\n.customvtab .tabs-vertical li .nav-link.active,\n.customvtab .tabs-vertical li .nav-link:hover,\n.customvtab .tabs-vertical li .nav-link:focus {\n    background: $white;\n    border: 0px;\n    border-right: 2px solid $themecolor;\n    margin-right: -1px;\n    color: $themecolor;\n}\n\n.tabcontent-border {\n    border: 1px solid #ddd;\n    border-top: 0px;\n}\n\n.customtab2 {\n    li {\n        a.nav-link {\n            border: 0px;\n            margin-right: 3px;\n            color: $bodytext;\n\n            &.active {\n                background: $themecolor;\n                color: $white;\n            }\n\n            &:hover {\n                color: $white;\n                background: $themecolor;\n            }\n        }\n    }\n}\n\n\n/*******************\nTimeline page\n******************/\n\n.timeline {\n    position: relative;\n    padding: 20px 0 20px;\n    list-style: none;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.timeline:before {\n    content: \" \";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    width: 3px;\n    margin-left: -1.5px;\n    background-color: $light;\n}\n\n.timeline>li {\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.timeline>li:before,\n.timeline>li:after {\n    content: \" \";\n    display: table;\n}\n\n.timeline>li:after {\n    clear: both;\n}\n\n.timeline>li:before,\n.timeline>li:after {\n    content: \" \";\n    display: table;\n}\n\n.timeline>li:after {\n    clear: both;\n}\n\n.timeline>li>.timeline-panel {\n    float: left;\n    position: relative;\n    width: 46%;\n    padding: 20px;\n    border: 1px solid $border;\n    border-radius: $radius;\n    -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);\n}\n\n.timeline>li>.timeline-panel:before {\n    content: \" \";\n    display: inline-block;\n    position: absolute;\n    top: 26px;\n    right: -8px;\n    border-top: 8px solid transparent;\n    border-right: 0 solid $border;\n    border-bottom: 8px solid transparent;\n    border-left: 8px solid $border;\n}\n\n.timeline>li>.timeline-panel:after {\n    content: \" \";\n    display: inline-block;\n    position: absolute;\n    top: 27px;\n    right: -7px;\n    border-top: 7px solid transparent;\n    border-right: 0 solid $white;\n    border-bottom: 7px solid transparent;\n    border-left: 7px solid $white;\n}\n\n.timeline>li>.timeline-badge {\n    z-index: 10;\n    position: absolute;\n    top: 16px;\n    left: 50%;\n    width: 50px;\n    height: 50px;\n    margin-left: -25px;\n    border-radius: 50% 50% 50% 50%;\n    text-align: center;\n    font-size: 1.4em;\n    line-height: 46px;\n    color: #fff;\n    overflow: hidden;\n}\n\n.timeline>li.timeline-inverted>.timeline-panel {\n    float: right;\n}\n\n.timeline>li.timeline-inverted>.timeline-panel:before {\n    right: auto;\n    left: -8px;\n    border-right-width: 8px;\n    border-left-width: 0;\n}\n\n.timeline>li.timeline-inverted>.timeline-panel:after {\n    right: auto;\n    left: -7px;\n    border-right-width: 7px;\n    border-left-width: 0;\n}\n\n.timeline-badge.primary {\n    background-color: $primary;\n}\n\n.timeline-badge.success {\n    background-color: $success;\n}\n\n.timeline-badge.warning {\n    background-color: $warning;\n}\n\n.timeline-badge.danger {\n    background-color: $danger;\n}\n\n.timeline-badge.info {\n    background-color: $info;\n}\n\n.timeline-title {\n    margin-top: 0;\n    color: inherit;\n    font-weight: 400;\n}\n\n.timeline-body>p,\n.timeline-body>ul {\n    margin-bottom: 0;\n}\n\n.timeline-body>p+p {\n    margin-top: 5px;\n}\n\n\n/*============================================================== \n Ui-bootstrap\n ============================================================== */\n\nul.list-icons {\n    margin: 0px;\n    padding: 0px;\n\n    li {\n        list-style: none;\n        line-height: 30px;\n        margin: 5px 0;\n        transition: 0.2s ease-in;\n\n        a {\n            color: $bodytext;\n\n            &:hover {\n                color: $themecolor;\n            }\n        }\n\n        i {\n            font-size: 13px;\n            padding-right: 8px;\n        }\n    }\n}\n\nul.list-inline {\n    li {\n        display: inline-block;\n\n        &:first-child {\n            padding-left: 0px;\n        }\n\n        a {\n            color: $bodytext;\n\n            &:hover {\n                color: $themecolor;\n            }\n        }\n    }\n\n}\n\nul.two-part {\n    margin: 0px;\n\n    li {\n        width: 48.8%;\n    }\n}\n\n\n/*Accordion*/\n\nhtml body .accordion {\n    .card {\n        margin-bottom: 0px;\n    }\n}\n\n#accordion4 {\n    .card-header {\n        border: 1px solid $border;\n        background: transparent;\n        margin-bottom: 10px;\n\n        a {\n            color: $muted;\n        }\n\n        &:hover {\n            background-color: $info;\n            border: 1px solid $info;\n\n            a {\n                color: $white;\n            }\n        }\n    }\n\n    .card.active .card-header {\n        background-color: $info;\n        border: 1px solid $info;\n\n        a {\n            color: $white;\n        }\n    }\n}\n\n\n/*===================== \nBreadcrumb\n=====================*/\n\n.bc-colored {\n\n    .breadcrumb-item,\n    .breadcrumb-item a {\n        color: $white;\n\n        &.active {\n            opacity: 0.7;\n        }\n    }\n\n    .breadcrumb-item+.breadcrumb-item::before {\n        color: rgba(255, 255, 255, 0.4);\n    }\n}\n\n\n/*******************\n Card title\n*******************/\n\n.card-title {\n    font-size: 18px;\n}\n\n.card-subtitle {\n    color: $muted;\n    margin-bottom: 30px;\n    font-size: 14px;\n}\n\n.card-inverse .card-bodyquote .blockquote-footer,\n.card-inverse .card-link,\n.card-inverse .card-subtitle,\n.card-inverse .card-text {\n    color: rgba(255, 255, 255, .65);\n}\n\n.card-default {\n    .card-header {\n        background: $white;\n        border-bottom: 0px;\n    }\n}\n\n.card-success {\n    background: $success;\n    border-color: $success;\n}\n\n.card-danger {\n    background: $danger;\n    border-color: $danger;\n}\n\n.card-warning {\n    background: $warning;\n    border-color: $warning;\n}\n\n.card-info {\n    background: $info;\n    border-color: $info;\n}\n\n.card-primary {\n    background: $primary;\n    border-color: $primary;\n}\n\n.card-dark {\n    background: $inverse;\n    border-color: $inverse;\n}\n\n.card-megna {\n    background: $megna;\n    border-color: $megna;\n}\n\n\n/*============================================================== \n Cards page\n ============================================================== */\n\n.card-columns .card {\n    margin-bottom: 20px;\n}\n\n.collapsing {\n    -webkit-transition: height .08s ease;\n    transition: height .08s ease;\n}\n\n.card-info {\n    background: $info;\n    border-color: $info;\n}\n\n.card-primary {\n    background: $primary;\n    border-color: $primary;\n}\n\n.card-outline-info {\n    border-color: $info;\n\n    .card-header {\n        background: $info;\n        border-color: $info;\n    }\n}\n\n.card-outline-inverse {\n    border-color: $inverse;\n\n    .card-header {\n        background: $inverse;\n        border-color: $inverse;\n    }\n}\n\n.card-outline-warning {\n    border-color: $warning;\n\n    .card-header {\n        background: $warning;\n        border-color: $warning;\n    }\n}\n\n.card-outline-success {\n    border-color: $success;\n\n    .card-header {\n        background: $success;\n        border-color: $success;\n    }\n}\n\n.card-outline-danger {\n    border-color: $danger;\n\n    .card-header {\n        background: $danger;\n        border-color: $danger;\n    }\n}\n\n.card-outline-primary {\n    border-color: $primary;\n\n    .card-header {\n        background: $primary;\n        border-color: $primary;\n    }\n}\n\n\n/*******************\nCustom-select\n******************/\n\n.custom-select {\n    background: url(../../assets/images/ui/custom-select.png) right .75rem center no-repeat;\n    border: 2px solid $border;\n    height: calc(2.25rem + 12px);\n}\n\n\n/*******************\ntextarea\n******************/\n\ntextarea {\n    resize: none;\n}\n\n.form-control-danger,\n.form-control-success,\n.form-control-warning {\n    padding-right: 2.25rem;\n    background-repeat: no-repeat;\n    background-position: center right .5625rem;\n    -webkit-background-size: 1.125rem 1.125rem;\n    background-size: 1.125rem 1.125rem;\n}\n\n.has-success .col-form-label,\n.has-success .custom-control,\n.has-success .form-check-label,\n.has-success .form-control-feedback,\n.has-success .form-control-label {\n    color: $success;\n}\n\n.has-success .form-control-success {\n    background-image: url(../../assets/images/ui/success.svg);\n}\n\n.has-success .form-control {\n    border-color: $success;\n}\n\n.has-warning .col-form-label,\n.has-warning .custom-control,\n.has-warning .form-check-label,\n.has-warning .form-control-feedback,\n.has-warning .form-control-label {\n    color: $warning;\n}\n\n.has-warning .form-control-warning {\n    background-image: url(../../assets/images/ui/warning.svg);\n}\n\n.has-warning .form-control {\n    border-color: $warning;\n}\n\n.has-danger .col-form-label,\n.has-danger .custom-control,\n.has-danger .form-check-label,\n.has-danger .form-control-feedback,\n.has-danger .form-control-label {\n    color: $danger;\n}\n\n.has-danger .form-control-danger {\n    background-image: url(../../assets/images/ui/danger.svg);\n}\n\n.has-danger .form-control {\n    border-color: $danger;\n}\n\n.input-group-addon {\n\n    [type=\"radio\"]:not(:checked),\n    [type=\"radio\"]:checked,\n    [type=\"checkbox\"]:not(:checked),\n    [type=\"checkbox\"]:checked {\n        position: initial;\n        opacity: 1;\n    }\n}\n\n.input-form .btn {\n    padding: 14px 12px;\n}\n\n.form-control-sm {\n    padding: .25rem .5rem;\n}\n\n\n/*******************\ncustom modals\n******************/\n\n.custom-modal {\n    .close-btn {\n        position: absolute;\n        right: 12px;\n        top: 10px;\n        color: $muted;\n        font-size: 25px;\n        background: $white;\n        width: 20px;\n        height: 20px;\n        text-align: center;\n        display: block;\n        border-radius: 100%;\n        line-height: 19px;\n    }\n\n    .modal-body {\n        overflow: hidden;\n    }\n\n    .modal-bg-img {\n        background-size: cover;\n        background-position: center center;\n        min-height: 300px;\n    }\n}\n\n.modal1 {\n    .modal-bg {\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-position: center top;\n        padding: 40px;\n    }\n\n    .input-group {\n        margin-top: -45px;\n    }\n}\n\n.modal2 {\n    .modal-bg {\n        padding: 30px 30px 30px 15px;\n    }\n}\n\n.modal3 {\n    .modal-bg {\n        padding: 50px 40px 60px 25px;\n    }\n}\n\n.modal4 {\n    .modal-bg {\n        padding: 55px 55px 55px 40px;\n    }\n}\n\n\n/*******************\nOverlay headers and thrid dropdown\n******************/\n\n.header-overlay {\n    position: absolute;\n    width: 100%;\n}\n\n\n/*******************\ncommon-innerpage-banner\n*******************/\n.banner-innerpage {\n    padding: 150px 0 100px;\n    background-size: cover;\n    background-position: center center;\n\n    .title {\n        color: $white;\n        text-transform: uppercase;\n        font-weight: 700;\n        font-size: 40px;\n        line-height: 40px;\n    }\n\n    .subtitle {\n        color: $white;\n    }\n}\n\n@media(max-width:900px) {\n    .static-slider10 {\n        .title {\n            font-size: 40px;\n            line-height: 45px;\n        }\n    }\n}\n\n.with-noborder {\n    .media {\n        border: 0px;\n        padding: 0px;\n        margin: 50px 0;\n    }\n}\n\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n    background: $themecolor;\n}\n\n/*******************\nFooter 4\n*******************/\n.footer4 {\n    .f4-bottom-bar {\n        padding-top: 10px;\n        margin-top: 20px;\n\n        a {\n            color: $bodytext;\n\n            &:hover {\n                color: $info;\n            }\n        }\n    }\n\n    .round-social.light {\n        a {\n            width: 34px;\n            height: 34px;\n            line-height: 34px;\n\n            &:hover {\n                background: $info;\n            }\n        }\n    }\n}\n\n/*******************\nModal in center\n*******************/\n.modal-dialog {\n    min-height: calc(100vh - 60px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: auto;\n\n    @media(max-width: 768px) {\n        min-height: calc(100vh - 20px);\n    }\n}\n\n.animated {\n    -webkit-animation-duration: 0.5s;\n    animation-duration: 0.5s;\n}","/*\nTemplate Name: Admin Press Admin\nAuthor: Themedesigner\nEmail: niravjoshi87@gmail.com\nFile: scss\n*/\n\n\n/*============================================================== \n For Laptop & above all (1650px) \n ============================================================== */\n\n@media(min-width:1650px) {\n   \n}\n\n\n/*============================================================== \n For Laptop & above all (1370px) \n ============================================================== */\n\n@media(max-width:1370px) {\n    \n}\n\n\n/*-- ============================================================== \n Small Desktop & above all (1024px) \n ============================================================== */ \n\n@media(min-width:1024px) {\n    .contact4 {\n        .contact-box {\n            padding: 80px 105px 80px 0px;\n        }\n    } \n    .hover-dropdown .navbar-nav {\n        > .dropdown:hover {\n            > .dropdown-menu {\n                display: block;\n                margin-top: 0px;\n                \n            }\n        }\n    }\n    .navbar-nav {\n        > .dropdown {\n             .dropdown-menu {\n                min-width: 210px;\n                margin-top: 0px;\n            }\n        }\n    }\n    .dropdown-submenu:hover > .dropdown-menu {\n        display: block;\n    }\n}\n\n\n@media(max-width:1023px) {\n    .d-flex{\n        display: block!important;\n        &.no-block{\n            display: flex !important;\n        }\n    }\n    .wrap-feature30-box{\n        left:0;\n        right:0;\n        margin: 0 auto;\n        top:50%;\n    }\n    .wrap-feature31-box,\n    .contact4,\n    .form6 {\n        .right-image{\n            position: relative;\n            bottom: -95px;\n            img{\n                width: 100%;\n                \n            }\n        }\n    }\n    .contact1 {\n        .detail-box {\n            margin-top: 40px;\n        }\n        .p-r-40 {\n            padding-right: 0;\n        }\n    }\n    .contact4 {\n        .contact-box {\n            padding: 40px 0px 40px 0px;\n        }\n    }\n    .contact3 {\n        .c-detail {\n            text-align: center;\n            .m-r-20 {\n                margin-right: 0;\n            }\n            h6 {\n                margin-top: 20px;\n            }\n        }\n        .m-l-30 {\n            margin-left: 0;\n        }\n        .contact-box {\n            margin-top: 30px;\n        }\n    }\n    .wrap-feature34-box {\n        .left-image{\n            position: relative;\n            top:-90px;\n        }\n    }\n    .po-absolute{\n        position: relative;\n    }\n    .contact2 .bg-image {\n        margin-right: 15px;\n        margin-left: 15px;\n    }\n    .topbar{\n        background: $themecolor; \n        position: relative;\n        &.animated{\n            animation-duration:0s;\n            &.slideInDown{\n                    -webkit-animation-name: none;\n                    animation-name: none;\n            }\n        }\n    }\n    \n}\n\n\n/*-- ============================================================== \n Ipad & above all(768px) \n ============================================================== */\n\n@media(min-width:768px) {\n    \n}\n\n\n/*-- ============================================================== \n Phone and below ipad(767px) \n ============================================================== */\n\n@media(max-width:767px) {\n    /*This is for the Global*/\n    .b-l, .b-r{\n        border-left: 0px;\n        border-right: 0px;\n        border-bottom: 1px solid $border;\n    }\n    .img-inline{\n        li.half-width{\n            width: 100%;\n        }\n    }\n    .both-space{\n        margin: 10px 0;\n    }\n    .side-content{\n        padding: 40px 20px;\n    }\n    \n    .general-listing.two-part{\n        li{\n            width: 100%;\n            display: block;\n        }\n    }\n    /*This is for the feature 12*/\n    .wrap-feature-12 .uneven-box{\n        margin-top: 0px;\n    }\n    /*This is for the feature 16*/\n    .wrap-feature-16{\n        .with-text{\n            margin-left: 0px;\n        }\n    }\n    /*This is for the feature 18*/\n    .wrap-feature-18 .icon-position .icon-round{\n        top:157px;\n        right:30px;\n    }\n    /*This is for the feature 22*/\n    .wrap-feature-22 .text-box, .wrap-feature23-box .text-box{\n        padding: 20px 0px;\n    }\n    .wrap-feature30-box{\n        position: relative;\n    }\n    .contact3 {\n        .p-l-0 {\n            padding-left: 20px;\n        }\n    }\n    .contact4 {\n        .contact-box {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n    }\n    .modal2 {\n        .modal-bg {\n            padding: 30px; \n        }\n    }\n    .modal3 {\n        .modal-bg {\n            padding: 50px 40px 60px;\n        }\n    }\n    .modal4 {\n        .modal-bg {\n            padding: 40px;\n        }\n    }\n    \n    .dropdown-submenu > .dropdown-menu.show {\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
